var _commonMessageTypeMap;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { attachShadow, createEvent, h, Fragment, proxyCustomElement } from '@stencil/core/internal/client';
export { setAssetPath, setPlatformOptions } from '@stencil/core/internal/client';
import { getConversationList, removeConversation, setConversationToTop, setConversationNotificationStatus, getCurrentUserId, ReceivedStatus as ReceivedStatus$1, getHistoryMessages, MessageDirection as MessageDirection$1, ConversationType as ConversationType$1, installPlugin, getServerTime, addEventListener, Events, sendReadReceiptResponseV2, recallMessage as _recallMessage, deleteMessages, registerMessageType as _registerMessageType, ReferenceMessage as ReferenceMessage$3, TextMessage as TextMessage$1, sendMessage as _sendMessage, ImageMessage as ImageMessage$1, sendImageMessage as _sendImageMessage, FileMessage as FileMessage$1, sendFileMessage as _sendFileMessage, clearMessagesUnreadStatus as _clearMessagesUnreadStatus, sendSyncReadStatusMessage, saveTextMessageDraft as _saveTextMessageDraft, __addSDKVersion, MessageType as MessageType$1, getConnectionStatus, RCConnectionStatus, getTextMessageDraft, NotificationStatus, removeEventListener, clearTextMessageDraft, sendTypingStatusMessage, MentionedType, sendReadReceiptMessage } from '@rongcloud/imlib-next';
import { ReceivedStatus, ConversationType, MessageDirection, EventEmitter as EventEmitter$1, notEmptyString, MessageType, isArray, notEmptyArray, isObject, RCConnectionStatus as RCConnectionStatus$1 } from '@rongcloud/engine';
/**
 * 事件类型
 */

/* eslint-disable */

var CoreEvent;

(function (CoreEvent) {
  CoreEvent["INIT"] = "INIT";
  CoreEvent["CONNECTED"] = "CONNECTED";
  CoreEvent["MESSAGES"] = "MESSAGES";
  CoreEvent["CONVERSATION"] = "conversation";
  CoreEvent["UPDATE_CONVERSATION"] = "udpate_conversation";
  CoreEvent["TYPING_STATUS"] = "typing_status";
  CoreEvent["PULL_OFFLINE_MESSAGE_FINISHED"] = "pull_offline_message_finished";
  CoreEvent["READ_RECEIPT_RECEIVED"] = "read_receipt_received";
  CoreEvent["MESSAGE_RECEIPT_REQUEST"] = "message_receipt_request";
  CoreEvent["MESSAGE_RECEIPT_RESPONSE"] = "message_receipt_response";
  CoreEvent["SWITCH_CONVERSATION"] = "switch_conversation";
  CoreEvent["REFERENCE_MESSAGE"] = "reference_message";
  CoreEvent["CLOSE_REFERENCE"] = "close_reference";
  CoreEvent["UPDATE_MESSAGE"] = "update_message";
  CoreEvent["DELETE_MESSAGE"] = "delete_message";
  CoreEvent["MESSAGE_SENDING"] = "message_sending";
  CoreEvent["MESSAGE_SEND_SUCCESS"] = "message_send_success";
  CoreEvent["MESSAGE_SEND_FAIL"] = "message_send_fail";
  CoreEvent["UPLOAD_PROGRESS"] = "upload_progress";
  CoreEvent["UPLOAD_COMPLETE"] = "upload_complete";
  CoreEvent["LANGUAGE_CHANGED"] = "language_changed";
  CoreEvent["USER_INFO_CHANGED"] = "user_info_changed";
  CoreEvent["GROUP_INFO_CHANGED"] = "group_info_changed";
  CoreEvent["CONVERSATION_INFO_CHANGED"] = "conversation_info_changed";
})(CoreEvent || (CoreEvent = {})); // eslint-disable-next-line no-shadow


var LogTagId;

(function (LogTagId) {
  LogTagId["A_KIT_INIT_O"] = "A-kit-init-O";
  LogTagId["A_KIT_MSG_INSERT_O"] = "A-kit-msg_insert-O";
  LogTagId["A_KIT_MSG_DELETE_O"] = "A-kit-msg_delete-O";
  LogTagId["A_KIT_MSG_UPDATE_O"] = "A-kit-msg_update-O";
  LogTagId["A_KIT_WILL__MSGMSG_RECALL_O"] = "A-kit-msg_recall-O";
  LogTagId["A_KIT_WILL_SEND_MSG_T"] = "A-kit-will_send_msg-T";
  LogTagId["A_KIT_WILL_SEND_MSG_R"] = "A-kit-will_send_msg-R";
  LogTagId["A_KIT_WILL_DISPLAY_MSG_T"] = "A-kit-will_display_msg-T";
  LogTagId["A_KIT_WILL_DISPLAY_MSG_R"] = "A-kit-will_display_msg-R";
  LogTagId["A_KIT_CONVERSATION_CREATE_O"] = "A-kit-conversation_create-O";
  LogTagId["A_KIT_CONVERSATION_UPDATE_O"] = "A-kit-conversation_update-O";
  LogTagId["A_KIT_CONVERSATION_DELETE_O"] = "A-kit-conversation_delete-O";
  LogTagId["A_KIT_CONVERSATION_UNREAD_TIME_S"] = "A-kit-conversation_unread_time-S";
  LogTagId["A_KIT_CONVERSATION_LISTENER_S"] = "A-kit-conversation_listener-S";
  LogTagId["A_KIT_CONVERSATION_RENDER_S"] = "A-kit-conversation_render-S";
  LogTagId["A_KIT_MESSAGE_LISTENER_S"] = "A-kit-message_listener-S";
  LogTagId["A_KIT_READ_RECEIOT_LISTENER_S"] = "A-kit-read_receipt_listener-S";
  LogTagId["A_KIT_FORWARD_O"] = "A-kit-forward-O";
  LogTagId["A_KIT_UPDATA_INFO_O"] = "A-kit-update_info-O";
  LogTagId["A_KIT_UPDATA_INFO_E"] = "A-kit-update_info-E";
  LogTagId["A_KIT_SAVE_DRAFT_O"] = "A-kit-save-draft-O";
  LogTagId["A_KIT_MESSAGE_UNKNOW_O"] = "A-kit-message-unknow-O";
  LogTagId["A_KIT_PARAM_ERROR_O"] = "A-kit-param-error-O";
  LogTagId["A_KIT_COPY_FAILE_O"] = "A-kit-copy-faile-O";
  LogTagId["A_KIT_MESSAGE_E"] = "A-kit-message-E";
  LogTagId["A_KIT_SYNC_READ_E"] = "A-kit-sync-read-E";
  LogTagId["A_KIT_HANDLE_SWITCH_CONVERSATION_O"] = "A-kit-handle_switch_conversation-O";
  LogTagId["A_KIT_GET_CONVERSATION_T"] = "A-kit-get_conversation-T";
  LogTagId["A_KIT_GET_CONVERSATION_R"] = "A-kit-get_conversation-R";
  LogTagId["A_KIT_LOAD_DATA_O"] = "A-kit-load_data-O";
  LogTagId["A_KIT_GET_MESSAGES_O"] = "A-kit-get_messages-O";
  LogTagId["A_KIT_SEND_MESSAGE_CALLBACK_S"] = "A-kit-send_message_callback-S";
  LogTagId["A_KIT_SELECT_HANDLER_O"] = "A-kit-select_handler-O";
})(LogTagId || (LogTagId = {})); // 填充的空会话标识


var PolyfillMessage = 'polyfill';

var ConversationManager = /*#__PURE__*/function () {
  function ConversationManager() {
    _classCallCheck(this, ConversationManager);

    // 第一次拉取数量
    this.FIRST_COUNT_BASE = 30; // 每次的拉取数量

    this.COUNT_BASE = 30; // 是否为第一次拉取

    this.first = true;
    this.logger = null;
    /**
     * 会话分为置顶会话和非置顶会话，
     */

    this.topConversations = [];
    this.unTopConversations = [];
  }
  /**
   * 设置拉取数量
   * @param option
   */


  _createClass(ConversationManager, [{
    key: "setPullCount",
    value: function setPullCount(option) {
      this.COUNT_BASE = option.pullCount;
      this.FIRST_COUNT_BASE = option.pullCount;
    }
  }, {
    key: "setLogger",
    value: function setLogger(logger) {
      this.logger = logger;
    }
  }, {
    key: "setReceivedStatus",
    value: function setReceivedStatus(data, conversationStorage) {
      data.forEach(function (con) {
        var conversation = con;
        var unReadTime = conversationStorage.getUnReadTime(conversation.conversationType, conversation.targetId, conversation.channelId); // 根据本地存储的已读响应时间戳判断单聊消息的已读未读状态。

        var isPrivat = conversation.latestMessage.conversationType === ConversationType.PRIVATE;
        var isSendUser = conversation.latestMessage.messageDirection === MessageDirection.SEND; // 大于本地已读存储时间或者没有本地存储已读时间均设置为未读

        var isUnRead = conversation.latestMessage.sentTime > unReadTime || !unReadTime;

        if (isPrivat && isSendUser && isUnRead) {
          // 单聊，自己发送的消息
          conversation.latestMessage.receivedStatus = ReceivedStatus.UNREAD;
        }
      });
      return data;
    } // 用户处理lastMessage

  }, {
    key: "setLastMessage",
    value: function setLastMessage(data) {
      var _this2 = this;

      var conversationList = data; // 用户处理lastMessage

      if (this.customDisplayMessage && this.customDisplayMessage.willDisplayConversationMessage && typeof this.customDisplayMessage.willDisplayConversationMessage === 'function') {
        conversationList = data.map(function (item) {
          var one = item;
          var lastMessage = one.latestMessage;

          if (lastMessage) {
            var content = _this2.customDisplayMessage.willDisplayConversationMessage(lastMessage.content, lastMessage.conversationType, lastMessage.targetId, lastMessage.messageType);

            one.latestMessage.content = content;
          }

          return one;
        });
      }

      return conversationList;
    }
    /**
     * 获取远程会话
     * @param count
     * @param startTime
     * @param order
     * @returns Promise<void | IAsyncRes<IAReceivedConversation[]>>
     */

  }, {
    key: "getRemoteConversation",
    value: function getRemoteConversation(count, conversationStorage) {
      var _this3 = this;

      var startTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      return getConversationList({
        count: count,
        startTime: startTime,
        order: order
      }).then(function (result) {
        if (result.code === 0) {
          var data = result.data;
          data = _this3.setReceivedStatus(data, conversationStorage); // 排除用户需要自己接管的数据

          if (_this3.customIntercept && typeof _this3.customIntercept.interceptConversation === 'function') {
            data = data.filter(function (one) {
              var isMatch = _this3.customIntercept.interceptConversation(one);

              return !isMatch;
            });
          } // 用户处理lastMessage


          _this3.setLastMessage(data);

          _this3.update(data.map(function (one) {
            return {
              conversation: one
            };
          }));
        }
      });
    }
    /**
     * 获取一个会话
     * @param target
     * @param source
     * @returns number
     */

  }, {
    key: "findConversationFromList",
    value: function findConversationFromList(target, source) {
      var index = source.findIndex(function (one) {
        return one.conversationType === target.conversationType && one.targetId === target.targetId && one.channelId === target.channelId;
      });
      return index;
    }
    /**
     * 在本地缓存数据中找一个会话
     * @param t 目标会话参数
     * @returns IAReceivedConversation 会话
     */

  }, {
    key: "findConversation",
    value: function findConversation(t) {
      var target = t;
      target.channelId = target.channelId || '';
      var index = this.findConversationFromList(target, this.topConversations);

      if (index !== -1) {
        return {
          source: this.topConversations,
          index: index
        };
      }

      index = this.findConversationFromList(target, this.unTopConversations);

      if (index !== -1) {
        return {
          source: this.unTopConversations,
          index: index
        };
      }

      return null;
    }
    /**
     * 接受SDK返回的会话数据
     * @param lsit
     */

  }, {
    key: "update",
    value: function update(list) {
      var _this4 = this;

      var conversationList = list; // 找到空会话

      var polyfillTopConversation = this.topConversations.filter(function (one) {
        return one.latestMessage && one.latestMessage.messageType === PolyfillMessage;
      });
      var polyfillUnTopConversation = this.unTopConversations.filter(function (one) {
        return one.latestMessage && one.latestMessage.messageType === PolyfillMessage;
      });
      var polyfillConversation = polyfillTopConversation.concat(polyfillUnTopConversation);
      conversationList = conversationList.concat(polyfillConversation.map(function (one) {
        return {
          conversation: one
        };
      }));
      conversationList.forEach(function (one) {
        if (!one || !one.conversation && !one.updatedItems) {
          return;
        } // 找到会话


        var matchResult = _this4.findConversation({
          conversationType: one.conversation.conversationType,
          targetId: one.conversation.targetId,
          channelId: one.conversation.channelId || '' // channelId 可能会是undefined

        });

        var target = matchResult ? matchResult.source[matchResult.index] : one.conversation; // 新数据字段可能不完整，用新数据存在的字段更新老的会话数据

        _this4.merge(target, one.conversation);

        if (one.updatedItems !== undefined && Object.keys(one.updatedItems).length && matchResult) {
          Object.prototype.hasOwnProperty.call(one.updatedItems, 'isTop');
          matchResult.source.splice(matchResult.index, 1);

          if (target) {
            Object.keys(one.updatedItems).forEach(function (key) {
              target[key] = one.updatedItems[key].val;
            });
          }
        } else if (one.conversation && matchResult) {
          matchResult.source.splice(matchResult.index, 1);
        } // logger.info(LogTagId.A_KIT_CONVERSATION_UPDATE_O, { target, conversationUpdate: one })


        if (target.isTop) {
          _this4.sortConversation(target, _this4.topConversations);
        } else {
          _this4.sortConversation(target, _this4.unTopConversations);
        }
      });
    }
  }, {
    key: "merge",
    value: function merge(t, source) {
      var target = t;
      Object.keys(source).forEach(function (key) {
        if (source[key] !== undefined && source[key] !== null) {
          target[key] = source[key];
        }
      });
    }
  }, {
    key: "sort",
    value: function sort(target, source) {
      var position = -1;

      for (var i = 0; i < target.length; i++) {
        var conversation = target[i];

        if (conversation.latestMessage) {
          if (source.latestMessage && source.latestMessage.sentTime >= conversation.latestMessage.sentTime) {
            position = i;
            break;
          } else {
            continue;
          }
        } else {
          position = i;
          break;
        }
      }

      return position;
    }
    /**
     * 会话排序，按照会话的最后一条消息
     * @param source
     * @param target
     * @returns void
     */

  }, {
    key: "sortConversation",
    value: function sortConversation(source, target) {
      if (!target.length) {
        target.push(source);
      } // 查看是否已经存在


      var index = target.findIndex(function (conversation) {
        return conversation.targetId === source.targetId && conversation.channelId === source.channelId && conversation.conversationType === source.conversationType;
      }); // 如果存在则先删除

      if (index !== -1 && target[index].latestMessage) {
        if (!source.latestMessage) {
          // 新的会话数据没有最后一条消息
          return;
        }

        if (target[index].latestMessage.sentTime > source.latestMessage.sentTime) {
          // 当前会话的最后一条消息时间大于新会话数据的消息时间
          return;
        }

        target.splice(index, 1);
      }

      var position = this.sort(target, source);

      if (position === -1) {
        position = target.length;
      }

      target.splice(position, 0, source);
    }
    /**
     * 创建一个新会话，并插入到本地会话中
     * @param option
     */

  }, {
    key: "create",
    value: function create(option) {
      var conversation = {
        conversationType: option.conversationType,
        channelId: option.channelId,
        targetId: option.targetId,
        latestMessage: {
          conversationType: option.conversationType,
          targetId: option.targetId,
          channelId: option.channelId,
          sentTime: new Date().getTime(),
          messageType: PolyfillMessage,
          content: '',
          senderUserId: '',
          receivedTime: 0,
          messageUId: 'none',
          messageDirection: 1,
          isPersited: true,
          isCounted: true,
          isOffLineMessage: false,
          canIncludeExpansion: false,
          receivedStatus: ReceivedStatus.UNREAD
        }
      };
      this.sortConversation(conversation, this.unTopConversations);
      this.logger.info(LogTagId.A_KIT_CONVERSATION_CREATE_O, JSON.stringify(conversation));
      return conversation;
    }
    /**
     * 移除一个会话
     * @param conversation
     * @returns void
     */

  }, {
    key: "remove",
    value: function remove(conversation) {
      var _this5 = this;

      return removeConversation(conversation).then(function (res) {
        var result = _this5.findConversation(conversation);

        if (result) {
          if (res.code === 0) {
            result.source.splice(result.index, 1);

            _this5.logger.info(LogTagId.A_KIT_CONVERSATION_DELETE_O, JSON.stringify({
              index: result.index,
              conversation: result.source[result.index]
            }));
          }
        }

        return res;
      });
    }
    /**
     * 获取所有会话中最新的消息发送时间
     * @param conversationList
     * @returns number
     */

  }, {
    key: "getLastTime",
    value: function getLastTime(conversationList) {
      var lastTime = new Date().getTime();

      for (var i = conversationList.length - 1; i >= 0; i--) {
        var conversation = conversationList[i];

        if (conversation.latestMessage) {
          lastTime = conversation.latestMessage.sentTime;
          break;
        }
      }

      return lastTime;
    }
    /**
     * 获取会话列表
     * @param more 为true的情况下从服务端拉取，如果是false则从本地获取
     * @returns Promise<IAReceivedConversation[]>
     */

  }, {
    key: "getList",
    value: function getList(more, conversationStorage) {
      var _this6 = this;

      if (more) {
        var topLastTime = this.getLastTime(this.topConversations);
        var unTopLastTime = this.getLastTime(this.unTopConversations);
        var count = this.first ? this.FIRST_COUNT_BASE : this.COUNT_BASE;
        var lastTime = Math.min(topLastTime, unTopLastTime);
        return this.getRemoteConversation(count, conversationStorage, lastTime).then(function () {
          _this6.first = false;
          var list = [].concat(_toConsumableArray(_this6.topConversations), _toConsumableArray(_this6.unTopConversations));
          return list;
        });
      }

      var list = [].concat(_toConsumableArray(this.topConversations), _toConsumableArray(this.unTopConversations));
      return Promise.resolve(list);
    }
    /**
     * 改变会话置顶状态
     * @param option
     * @param status
     * @returns
     */

  }, {
    key: "changeTopStatus",
    value: function changeTopStatus(option, status) {
      return setConversationToTop(option, status).then(function (res) {
        return res;
      });
    }
    /**
     * 改变通知状态
     * @param option
     * @param status
     * @returns
     */

  }, {
    key: "changeNotificationStatus",
    value: function changeNotificationStatus(option, status) {
      var _this7 = this;

      return setConversationNotificationStatus(option, status).then(function (res) {
        if (res.code === 0) {
          var result = _this7.findConversation(option);

          result.source[result.index].notificationStatus = status;
        }

        return res;
      });
    }
    /**
     * disconnect 置空会话信息
     */

  }, {
    key: "clearLocalConversation",
    value: function clearLocalConversation() {
      this.unTopConversations = [];
      this.topConversations = [];
    }
  }]);

  return ConversationManager;
}();

function isEqual(x, y) {
  if ((x.channelId || '') === (y.channelId || '') && x.conversationType === y.conversationType && x.targetId === y.targetId) {
    return true;
  }

  return false;
}
/**
 * 检查参数是否为 number 数据
 * @param value
 */


var isNumber = function isNumber(value) {
  return typeof value === 'number' && !Number.isNaN(value);
};

function getConversationKey(conversation) {
  return "".concat(conversation.conversationType, "&&").concat(conversation.targetId, "&&").concat(conversation.channelId || '');
}

function file2Base64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function (e) {
      reader.onerror = null;
      reader.onload = null;
      resolve(e.target.result);
    };

    reader.onerror = function (e) {
      reader.onerror = null;
      reader.onload = null;
      reject(e);
    };
  });
}

function setGroupNtfContent(locale, content) {
  var text = '';
  var message = content.message;
  var dataStr = content.data;

  if (!dataStr) {
    return text;
  }

  var data = dataStr && JSON.parse(dataStr) || {};
  var operation = content.operation;
  var operatorUserId = content.operatorUserId;
  var isSend = operatorUserId === getCurrentUserId();
  var nickname = isSend ? locale.message.you : data.operatorNickname;

  switch (operation) {
    case 'Create':
      text = "".concat(nickname, " ").concat(locale.message.createGroup);
      break;

    case 'Rename':
      text = "".concat(nickname, " ").concat(locale.message.rename, " ").concat(data.targetGroupName);
      break;

    case 'Add':
      text = "".concat(nickname, " ").concat(locale.message.inviteGroup(data.targetUserDisplayNames));
      break;

    case 'Kicked':
      text = "".concat(nickname, " ").concat(locale.message.removeGroupMember(data.targetUserDisplayNames));
      break;

    case 'Quit':
      text = "".concat(nickname, " ").concat(locale.message.quitGroup);
      break;

    case 'Dismiss':
      text = "".concat(nickname, " ").concat(locale.message.dismiss);
      break;

    default:
      text = message;
      break;
  }

  return text;
} // 节流工厂函数


function throttle(fun, delay) {
  var last = Date.now();
  var timer = null;

  function func() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var that = this;
    var now = Date.now();
    var remaining = delay - (now - last);
    clearTimeout(timer);

    if (remaining > 0) {
      timer = setTimeout(function () {
        last = now;
        fun.apply(that, args);
      }, delay);
    } else {
      last = now;
      fun.apply(that, args);
    }
  }

  return func;
}

var myProfileCache;
var profileCache = {};
var groupMembersCache = {};

var Service = /*#__PURE__*/function () {
  function Service(config, logger) {
    _classCallCheck(this, Service);

    this.logger = null;
    this.config = config;
    this.logger = logger;
  }

  _createClass(Service, [{
    key: "getUserProfile",
    value: function getUserProfile(id) {
      if (!this.config.getUserProfile) {
        return Promise.reject(new Error('Method getUserProfile is not defined!'));
      }

      if (myProfileCache) {
        return Promise.resolve(myProfileCache);
      }

      return this.config.getUserProfile(id).then(function (res) {
        myProfileCache = res;
        return myProfileCache;
      });
    }
  }, {
    key: "getConversationProfile",
    value: function getConversationProfile(conversations) {
      if (!this.config.getConversationProfile) {
        return Promise.reject(new Error('Method getConversationProfile is not defined!'));
      } // 临时存放从缓存取出的数据


      var temp = [];
      var newConversations = conversations.filter(function (conversation) {
        var key = getConversationKey(conversation);
        var profile = profileCache[key];

        if (profile) {
          // 缓存中存在的数据，不再查询
          temp.push(profile);
        }

        return !profile;
      });

      if (newConversations.length > 0) {
        return this.config.getConversationProfile(newConversations).then(function (profiles) {
          // 对数据进行缓存
          profiles.forEach(function (profile) {
            if (profile && profile.targetId && profile.conversationType) {
              var key = getConversationKey(profile);
              profileCache[key] = profile;
            }
          }); // 将之前的临时数据合并

          return [].concat(_toConsumableArray(profiles), temp);
        });
      }

      return Promise.resolve(temp);
    }
  }, {
    key: "getGroupMembers",
    value: function getGroupMembers(conversation) {
      if (!this.config.getGroupMembers) {
        return Promise.reject(new Error('Method getGroupMembers is not defined!'));
      }

      var key = getConversationKey(conversation);

      if (groupMembersCache[key]) {
        return Promise.resolve(groupMembersCache[key]);
      }

      return this.config.getGroupMembers(conversation).then(function (res) {
        var conKey = getConversationKey(conversation);

        if (res) {
          groupMembersCache[conKey] = res;
          return groupMembersCache[conKey];
        }

        return null;
      });
    }
  }, {
    key: "clearMyProfileCache",
    value: function clearMyProfileCache() {
      myProfileCache = null;
    }
    /**
    * 更新用户信息
    * @param info
    */

  }, {
    key: "updateUserProfile",
    value: function updateUserProfile(info) {
      // TODO 增加校验 id 是否一致，不一致不进行替换，给出日志提示
      if (myProfileCache.id === info.id) {
        myProfileCache = info;
        this.logger.info(LogTagId.A_KIT_UPDATA_INFO_O, JSON.stringify({
          myProfileCache: info
        }));
        return;
      }

      this.logger.warn(LogTagId.A_KIT_UPDATA_INFO_O, JSON.stringify({
        msg: 'update failed id is not equal'
      }));
    }
    /**
     * 更新群组信息
     * @param conversation
     * @param info
     */

  }, {
    key: "updateGroupMembers",
    value: function updateGroupMembers(conversation, info) {
      if (!conversation || !conversation.targetId || !conversation.conversationType) {
        this.logger.warn(LogTagId.A_KIT_UPDATA_INFO_E, JSON.stringify({
          msg: 'update group member info error.'
        }));
        return;
      }

      var key = getConversationKey(conversation);

      if (groupMembersCache[key]) {
        groupMembersCache[key] = info;
      }

      this.logger.info(LogTagId.A_KIT_UPDATA_INFO_O, JSON.stringify({
        key: info
      }));
    }
    /**
     * 更新会话信息
     * @param conversation
     * @param info
     */

  }, {
    key: "updateConversationProfile",
    value: function updateConversationProfile(conversation, info) {
      if (!conversation || !conversation.targetId || !conversation.conversationType) {
        this.logger.warn(LogTagId.A_KIT_UPDATA_INFO_E, JSON.stringify({
          msg: 'update conversation info error.'
        }));
        return;
      }

      var key = getConversationKey(conversation);

      if (profileCache[key]) {
        profileCache[key] = _objectSpread(_objectSpread({}, info), conversation);
      }

      this.logger.info(LogTagId.A_KIT_UPDATA_INFO_O, JSON.stringify({
        key: info
      }));
    }
  }]);

  return Service;
}();

var MessageManager = /*#__PURE__*/function () {
  function MessageManager() {
    _classCallCheck(this, MessageManager);

    this.logger = null;
    /**
     * 最近的消息列表
     */

    this.localMessages = {};
  }

  _createClass(MessageManager, [{
    key: "setLogger",
    value: function setLogger(logger) {
      this.logger = logger;
    }
    /**
     * 设置当前会话
     */

  }, {
    key: "currentConversation",
    get:
    /**
     * 获取当前会话
     */
    function get() {
      return this._currentConversation;
    }
    /**
     * 获取消息，如果本地消息不足，则从服务端拉取
     * @param conversation 会话
     * @param start 开始时间，默认从最新一条的时间开始
     * @param num 获取数量，默认20条
     * @returns
     */
    ,
    set: function set(conversation) {
      this._currentConversation = conversation;
    }
  }, {
    key: "getMessages",
    value: function getMessages(conversation, unReadTime) {
      var _this8 = this;

      var startTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var num = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
      var count = num;
      count = Math.min(20, Math.max(1, count));
      this._unReadTime = unReadTime;
      var result = this.getLocalMessage(conversation, startTime, count);
      this.logger.info(LogTagId.A_KIT_GET_MESSAGES_O, JSON.stringify({
        conversation: conversation,
        count: count,
        resultList: result.list.length
      })); // 拿到本地消息匹配消息是否已读

      if (result.list) {
        result.list.forEach(function (msg) {
          var message = msg;
          var isPrivat = message.conversationType === ConversationType$1.PRIVATE;
          var isSendUser = message.messageDirection === MessageDirection$1.SEND;
          var isUnRead = message.sentTime <= _this8._unReadTime;

          if (isPrivat && isSendUser && isUnRead) {
            // 单聊，自己发送的消息
            message.receivedStatus = ReceivedStatus$1.READ;
          }
        });
      }

      if (result.list.length >= count) {
        // 消息数量能满足count
        return Promise.resolve(result);
      }

      if (result.hasMore === false) {
        // 服务器没有更多历史消息
        return Promise.resolve(result);
      }

      var c = getConversationKey(conversation);
      var timestamp = 0;

      if (this.localMessages[c] && this.localMessages[c].list.length > 0) {
        timestamp = this.localMessages[c].list[0].sentTime;
      }

      return this.getRemoteMessages(conversation, {
        count: count,
        timestamp: timestamp
      }).then(function () {
        return _this8.getLocalMessage(conversation, startTime, count);
      });
    }
    /**
     * 获取本地消息
     * @param conversation 会话
     * @param st 从什么时间开始获取
     * @param count 获取数量
     * @returns { list: IAReceivedMessage[], hasMore: boolean }
     */

  }, {
    key: "getLocalMessage",
    value: function getLocalMessage(conversation) {
      var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
      var c = getConversationKey(conversation);
      var messages = this.localMessages[c];
      var startTime = st; // 直接获取全部

      if (count === 0) {
        return messages || {
          list: [],
          hasMore: true
        };
      } // 本地数据中不存在此会话的数据，hasmore标记为true，则要求调用方拉取一次远程历史


      if (!messages) {
        return {
          list: [],
          hasMore: true
        };
      }

      if (startTime === 0) {
        startTime = Date.now();
      }

      var index = messages.list.findIndex(function (one) {
        return startTime <= one.sentTime;
      });
      var result = [];

      if (index === 0) {
        // 说明startTime小于第零个的sentTime，则直接用第零个的sentTime开始在服务器查找数据
        return {
          list: [],
          hasMore: messages.hasMore
        };
      }

      if (index === -1) {
        // 没有找到，说明starttime大于任何一个messages中的消息sentTime
        index = messages.list.length;
      }

      result = messages.list.slice(Math.max(0, index - count), index);

      if (result.length >= count && index - count > 0) {
        // 通知业务层，本地是否还有更多的历史记录
        // 假设此会话已经将历史记录全部拉取回本地，此时hasMore记录为false（没有更多的历史消息）
        // 当切换回此会话时，下拉加载通知给业务层的会为false，造成判断错误。
        return {
          list: result,
          hasMore: true
        };
      } // 本地数据不足，因此通知业务层的hasmore 为服务器返回


      return {
        list: result,
        hasMore: messages.hasMore
      };
    }
    /**
     * 获取远程消息
     * @param conversation
     * @param option
     * @returns Promise<void>
     */

  }, {
    key: "getRemoteMessages",
    value: function getRemoteMessages(conversation, option) {
      var _this9 = this;

      return getHistoryMessages(conversation, option).then(function (res) {
        if (res.code === 0) {
          var list = res.data.list; // 排除用户要自己接管的数据

          if (_this9.customIntercept && typeof _this9.customIntercept.interceptMessage === 'function') {
            list = list.filter(function (one) {
              var isMatch = _this9.customIntercept.interceptMessage(one);

              return !isMatch;
            });
          } // 用户处理消息【供客户对消息进行加解密操作】


          if (_this9.customDisplayMessage && _this9.customDisplayMessage.willDisplayMessages && typeof _this9.customDisplayMessage.willDisplayMessages === 'function') {
            list = list.map(function (msg) {
              var message = msg;

              var content = _this9.customDisplayMessage.willDisplayMessages(message.content, message.conversationType, message.targetId, message.messageType);

              message.content = content;
              return message;
            });
          }

          _this9.setLocalMessages(conversation, list, res.data.hasMore);
        }
      });
    }
  }, {
    key: "calculateUpdateMessage",
    value: function calculateUpdateMessage(messages, list, conversation) {
      var _this10 = this;

      var result = [];
      messages.forEach(function (msg) {
        var message = msg;
        var targetPosition = list.length;

        for (var i = 0; i < list.length; i++) {
          var localMessage = list[i];

          if (message.messageUId === localMessage.messageUId) {
            // 防止消息重复
            return;
          }

          if (message.sentTime <= localMessage.sentTime) {
            targetPosition = i;
            break;
          }
        } // 返回当前的会话的更新消息


        if (_this10._currentConversation && isEqual(message, _this10._currentConversation)) {
          result.push(message);
        } // 根据本地存储的已读响应时间戳判断单聊消息的已读未读状态。


        var isPrivat = message.conversationType === ConversationType$1.PRIVATE;
        var isSendUser = message.messageDirection === MessageDirection$1.SEND;
        var isUnRead = message.sentTime > _this10._unReadTime || !_this10._unReadTime;

        if (isPrivat && isSendUser && isUnRead) {
          // 单聊，自己发送的消息
          message.receivedStatus = ReceivedStatus$1.UNREAD;
        } // 将历史消息写入本地数据


        var key = getConversationKey(conversation);

        _this10.localMessages[key].list.splice(targetPosition, 0, message);
      });
      return result;
    }
  }, {
    key: "createWillRemoveList",
    value: function createWillRemoveList(messages, list) {
      var _this11 = this;

      var willRemove = [];
      messages.forEach(function (msg) {
        var message = msg; // 收到对方的消息撤回通知，则在本地会话中清理要撤回的消息

        if (message.messageType === 'RC:RcCmd' && message.messageDirection === MessageDirection$1.RECEIVE) {
          var content = message.content;

          if (content && content.messageUId) {
            var removeMessage = _this11.deleteMessageByUId(list, content.messageUId);

            if (removeMessage) {
              willRemove.push(removeMessage);
            }
          }
        }
      });
      return willRemove;
    }
    /**
     * 按sentTime升序存入
     * @param messages IAReceivedMessage[] 要存入的消息列表
     * @returns
     */

  }, {
    key: "setLocalMessages",
    value: function setLocalMessages(conversation, messages, hasMore) {
      var result = [];
      var conversationType = conversation.conversationType,
          targetId = conversation.targetId,
          _conversation$channel = conversation.channelId,
          channelId = _conversation$channel === void 0 ? '' : _conversation$channel;
      var c = "".concat(conversationType, "&&").concat(targetId, "&&").concat(channelId);

      if (!this.localMessages[c]) {
        // 不存数据的情况下，hasMore设定为true，可以防止丢消息
        this.localMessages[c] = {
          list: [],
          hasMore: hasMore === undefined ? true : hasMore
        };
      } else if (hasMore !== undefined) {
        this.localMessages[c].hasMore = hasMore;
      }

      if (!messages.length) {
        return {
          "new": result
        };
      }

      var list = this.localMessages[c].list; // 收到对方的消息撤回通知，则在本地会话中清理要撤回的消息

      var willRemove = this.createWillRemoveList(messages, list); // 当前的会话的更新消息

      result = this.calculateUpdateMessage(messages, list, conversation);
      result.sort(function (a, b) {
        return a.sentTime - b.sentTime;
      });
      return {
        "new": result,
        remove: willRemove
      };
    }
    /**
     * 撤回消息
     * @param message
     * @returns IAReceivedMessage | null
     */

  }, {
    key: "recallMessage",
    value: function recallMessage(message) {
      var key = getConversationKey(message);
      var result = this.localMessages[key];

      if (!result) {
        return null;
      }

      var messages = result.list;

      if (messages && messages.length) {
        var index = messages.findIndex(function (m) {
          return m.messageUId === message.messageUId;
        });

        if (index !== -1) {
          // messages[index].messageType += '__RECALL'
          messages[index].messageType = 'RC:RcCmd';
          return messages[index];
        }

        return null;
      }

      return null;
    }
    /**
     * 删除消息
     * @param message
     * @returns boolean
     */

  }, {
    key: "deleteMessage",
    value: function deleteMessage(message) {
      var key = getConversationKey(message);
      var result = this.localMessages[key];

      if (!result) {
        return false;
      }

      var messages = result.list;

      if (messages && messages.length) {
        var index = messages.findIndex(function (m) {
          return m.messageUId === message.messageUId;
        });

        if (index !== -1) {
          this.logger.info(LogTagId.A_KIT_MSG_DELETE_O, JSON.stringify({
            index: index,
            message: messages[index]
          }));
          messages.splice(index, 1);
          return true;
        }

        return false;
      }

      return false;
    }
    /**
     * 根据消息UId删除本地消息
     * @param list
     * @param uid
     * @returns
     */

  }, {
    key: "deleteMessageByUId",
    value: function deleteMessageByUId(list, uid) {
      var index = list.findIndex(function (one) {
        return one.messageUId === uid;
      });

      if (index !== -1) {
        var message = list[index];
        list.splice(index, 1);
        this.logger.info(LogTagId.A_KIT_MSG_DELETE_O, JSON.stringify({
          index: index,
          message: list[index]
        }));
        return message;
      }

      return null;
    }
    /**
     * 插入消息
     * @param message
     * @returns void
     */

  }, {
    key: "insertMessage",
    value: function insertMessage(message) {
      var key = getConversationKey(message);
      var result = this.localMessages[key];

      if (!result) {
        this.localMessages[key] = {
          list: [message],
          hasMore: true
        };
        return;
      }

      var list = this.localMessages[key].list;
      var index = list.findIndex(function (one) {
        return one.sentTime > message.sentTime;
      });

      if (index === -1) {
        list.push(message);
      } else {
        list.splice(index, 0, message);
      }

      this.logger.info(LogTagId.A_KIT_MSG_INSERT_O, JSON.stringify({
        index: index,
        message: message
      }));
    }
    /**
     * 更新消息
     * @param message
     * @returns void
     */

  }, {
    key: "updateMessage",
    value: function updateMessage(message) {
      var key = getConversationKey(message);
      var result = this.localMessages[key];

      if (!result) {
        this.insertMessage(message);
        return;
      }

      var list = this.localMessages[key].list;
      var index = -1; // 首先考虑messageId，如果不存在messageId则再用messageUId来

      if (message.messageId) {
        index = list.findIndex(function (one) {
          return one.messageId === message.messageId;
        });
      }

      if (index === -1 && message.messageUId) {
        index = list.findIndex(function (one) {
          return one.messageUId === message.messageUId;
        });
      }

      if (index === -1) {
        this.insertMessage(message);
        return;
      }

      Object.keys(message).forEach(function (p) {
        if (message[p] !== undefined) {
          list[index][p] = message[p];
        }
      });
    }
    /**
     * 截取消息，保留最新的100条
     * @returns void
     */

  }, {
    key: "cutMessages",
    value: function cutMessages() {
      var key = getConversationKey(this._currentConversation);
      var result = this.localMessages[key];

      if (!result) {
        return;
      }

      if (result.list.length > 100) {
        result.list.splice(0, result.list.length - 100);
        result.hasMore = true;
      }
    }
    /**
     * disconnect 置空本地消息
     */

  }, {
    key: "clearLocalMessage",
    value: function clearLocalMessage() {
      this.localMessages = {};
    }
  }]);

  return MessageManager;
}(); // eslint-disable-next-line no-shadow


var Languages;

(function (Languages) {
  Languages["ZH_CN"] = "zh_CN";
  Languages["ZH_TW"] = "zh_TW";
  Languages["EN"] = "en";
})(Languages || (Languages = {}));

var storage;

var createStorage = function createStorage(w, _appkey, _currentUserId) {
  var storageKey = "imkit_".concat(_appkey, "_").concat(_currentUserId);
  storage = {
    set: function set(value, key) {
      var val = JSON.stringify(value);
      w.localStorage.setItem("".concat(storageKey, "_").concat(key), val);

      if (value === undefined || value === null) {
        w.localStorage.removeItem("".concat(storageKey, "_").concat(key));
      }
    },
    get: function get(key) {
      var item;

      try {
        item = JSON.parse(w.localStorage.getItem("".concat(storageKey, "_").concat(key)));
      } catch (e) {
        item = null;
      }

      return item;
    },
    remove: function remove(key) {
      w.localStorage.removeItem("".concat(storageKey, "_").concat(key));
    }
  }; // }

  return storage;
};

var ConversationStore = /*#__PURE__*/function () {
  function ConversationStore() {
    _classCallCheck(this, ConversationStore);

    this._conversationStorage = {};
  }

  _createClass(ConversationStore, [{
    key: "init",
    value: function init(_appkey, _currentUserId) {
      this._kitStorage = createStorage(window, _appkey, _currentUserId);
      this._conversationStorage = this._kitStorage.get('conversation') || {};
    }
  }, {
    key: "updateUnReadTime",
    value: function updateUnReadTime(time, type, targetId, channelId) {
      var key = this.getConversationKey(type, targetId, channelId);
      this._conversationStorage[key] = time;

      this._kitStorage.set(this._conversationStorage, 'conversation');
    }
  }, {
    key: "getUnReadTime",
    value: function getUnReadTime(type, targetId, channelId) {
      var key = this.getConversationKey(type, targetId, channelId);
      return this._conversationStorage[key] || 0;
    }
  }, {
    key: "data",
    get: function get() {
      return this._conversationStorage;
    }
  }, {
    key: "getConversationKey",
    value: function getConversationKey(type, targetId, channelId) {
      return "".concat(channelId, "_").concat(type, "_").concat(targetId);
    }
  }]);

  return ConversationStore;
}();

var LangStore = /*#__PURE__*/function () {
  function LangStore() {
    _classCallCheck(this, LangStore);

    this._LangStore = null;
  }

  _createClass(LangStore, [{
    key: "init",
    value: function init(_appkey, _currentUserId) {
      this._kitStorage = createStorage(window, _appkey, _currentUserId);
      this._LangStore = this._kitStorage.get('lang') || null;
    }
  }, {
    key: "setLang",
    value: function setLang(value) {
      this._LangStore = value;

      this._kitStorage.set(this._LangStore, 'lang');
    }
  }, {
    key: "getLang",
    value: function getLang() {
      var lang = this._LangStore && this._LangStore.lang ? this._LangStore.lang : Languages.ZH_CN;
      return lang;
    }
  }]);

  return LangStore;
}();

function createMessageId() {
  // eslint-disable-next-line no-bitwise
  return ~~(Math.random() * 0xffffff);
} // 需要排除的消息


function isExcludeMessage(messageType) {
  return ['RC:Delivered', 'RC:SRSMsg', 'RC:ReadNtf'].indexOf(messageType) !== -1;
}
/**
 * 是否初始化过
 */


var hasInit = false;

var Core = /*#__PURE__*/function (_EventEmitter$) {
  _inherits(Core, _EventEmitter$);

  var _super2 = _createSuper(Core);

  function Core() {
    var _this12;

    _classCallCheck(this, Core);

    _this12 = _super2.call(this);
    /**
     * 记录切换会话时的时间
     */

    _this12.switchTimes = {}; // 缓存已读回执

    _this12.receiptRequstCache = [];
    _this12._fileCache = {};

    if (!Core.INSTANCE) {
      _this12.conversationManager = new ConversationManager();
      _this12.messageManager = new MessageManager();
      _this12._conversationStorage = new ConversationStore();
      _this12._langStore = new LangStore();
      Core.INSTANCE = _assertThisInitialized(_this12);
    }

    return _this12;
  }

  _createClass(Core, [{
    key: "init",
    value: function init(opt) {
      var option = opt;

      if (hasInit) {
        this.logger.error(LogTagId.A_KIT_INIT_O, JSON.stringify({
          msg: '禁止多次初始化！'
        }));
      }

      if (!notEmptyString(option.appkey)) {
        this.logger.error(LogTagId.A_KIT_INIT_O, JSON.stringify({
          msg: '参数错误：appkey 为必传字段！',
          data: option
        }));
      }

      this._appkey = option.appkey;
      option.conversationPullCount = option.conversationPullCount ? option.conversationPullCount : 30;
      this.conversationManager.setPullCount({
        pullCount: option.conversationPullCount
      });
      this.customMessage = option.customMessage;
      this.customIntercept = option.customIntercept;
      this.conversationManager.customIntercept = this.customIntercept;
      this.customDisplayMessage = option.customDisplayMessage;
      this.messageManager.customIntercept = this.customIntercept;
      this.messageManager.customDisplayMessage = this.customDisplayMessage;
      this.conversationManager.customDisplayMessage = this.customDisplayMessage;
      this.logger = installPlugin({
        tag: 'IMKit',
        verify: function verify() {
          return true;
        },
        setup: function setup(context) {
          return context.createLogger('IMKit', 'IM');
        }
      }, {});

      if (option.logOutputLevel) {
        this.logger.setOutputLevel(option.logOutputLevel);
      }

      this.conversationManager.setLogger(this.logger);
      this.messageManager.setLogger(this.logger);
      this.service = new Service(option.service, this.logger);
      this.setListener();
      hasInit = true; // 初始化完毕

      this.emit(CoreEvent.INIT);
    }
  }, {
    key: "getTime",
    value: function getTime() {
      if (!this.startLocalTime || this.startServerTime) {
        this.startLocalTime = Date.now();
        this.startServerTime = getServerTime();
      }

      return Date.now() - this.startLocalTime + this.startServerTime;
    }
  }, {
    key: "currentConversation",
    get: function get() {
      return this._currentConversation;
    },
    set: function set(conversation) {
      this._currentConversation = conversation;
    }
  }, {
    key: "lang",
    get: function get() {
      var lang = this._langStore.getLang() ? this._langStore.getLang() : Languages.ZH_CN;
      return lang;
    },
    set: function set(language) {
      this._langStore.setLang(language);
    }
  }, {
    key: "selectConversation",
    value: function selectConversation(conversation) {
      var _this13 = this;

      if (this.currentConversation && isEqual(this.currentConversation, conversation)) {
        return;
      } // 如果会话不存在，则主动创建


      if (!this.conversationManager.findConversation(conversation)) {
        var newConversation = this.createConversation(conversation);
        this.emit(CoreEvent.UPDATE_CONVERSATION, [newConversation]);
      } // 存储当前切换的时间


      if (this.currentConversation) {
        var key = getConversationKey(this.currentConversation);
        this.switchTimes[key] = this.getTime(); // 截取当前会话下消息列表的长度，只保留最新的100条

        this.messageManager.cutMessages();
      }

      this.currentConversation = conversation;
      this.messageManager.currentConversation = this.currentConversation;
      this.emit(CoreEvent.SWITCH_CONVERSATION, this.currentConversation);
      this.receiptRequstCache.forEach(function (one) {
        // 切换会话的时候，直接将回执通知UI层处理
        if (isEqual(one.conversation, _this13.currentConversation)) {
          _this13.emit(CoreEvent.MESSAGE_RECEIPT_REQUEST, one);
        }
      });
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(language) {
      if (language && language.lang) {
        this._langStore.setLang(language);

        this.emit(CoreEvent.LANGUAGE_CHANGED, language);
        return;
      }

      this.logger.info(LogTagId.A_KIT_PARAM_ERROR_O, JSON.stringify({
        msg: '参数异常，切换语言失败'
      }));
    }
  }, {
    key: "filterInterceptMessage",
    value: function filterInterceptMessage(list) {
      var _this14 = this;

      var messages = list;

      if (this.customIntercept && typeof this.customIntercept.interceptMessage === 'function') {
        messages = messages.filter(function (message) {
          var isMatch = _this14.customIntercept.interceptMessage(message);

          return !isMatch;
        });
      }

      return messages;
    }
  }, {
    key: "filterWillDisplayMessages",
    value: function filterWillDisplayMessages(list) {
      var _this15 = this;

      var messages = list;

      if (this.customDisplayMessage && this.customDisplayMessage.willDisplayMessages && typeof this.customDisplayMessage.willDisplayMessages === 'function') {
        messages = messages.map(function (msg) {
          var message = msg;

          var content = _this15.customDisplayMessage.willDisplayMessages(message.content, message.conversationType, message.targetId, message.messageType);

          message.content = content;
          return message;
        });
      }

      return messages;
    }
  }, {
    key: "messageUnread",
    value: function messageUnread(messages) {
      messages.forEach(function (msg) {
        var message = msg;

        if (message.conversationType === ConversationType.PRIVATE) {
          if (message.receivedStatus === ReceivedStatus.READ) {
            message.receivedStatus = ReceivedStatus.UNREAD;
          }
        }
      });
      return messages;
    }
  }, {
    key: "setListener",
    value: function setListener() {
      var _this16 = this;

      addEventListener(Events.CONNECTED, function () {
        // 切换用户后清理内存态信息
        if (_this16._currentUsreId && _this16._currentUsreId !== getCurrentUserId()) {
          _this16.conversationManager.clearLocalConversation();

          _this16.messageManager.clearLocalMessage(); // 清空缓存中用户信息，防止切用户登入 getUserProfile 钩子没触发


          _this16.service.clearMyProfileCache();
        }

        _this16._currentUsreId = getCurrentUserId();

        _this16._conversationStorage.init(_this16._appkey, _this16._currentUsreId);

        _this16._langStore.init(_this16._appkey, _this16._currentUsreId);

        _this16.emit(CoreEvent.CONNECTED, true);

        _this16.emit(CoreEvent.LANGUAGE_CHANGED, {
          lang: _this16.lang
        });
      });
      addEventListener(Events.DISCONNECT, function () {
        _this16.currentConversation = null;

        _this16.emit(CoreEvent.SWITCH_CONVERSATION, _this16.currentConversation);

        _this16.emit(CoreEvent.CONNECTED, false);
      });
      addEventListener(Events.CONVERSATION, function (event) {
        _this16.logger.info(LogTagId.A_KIT_CONVERSATION_LISTENER_S, JSON.stringify(event));

        var updatedConversationList = event.conversationList; // 将用户要自己接管的会话排除掉

        if (_this16.customIntercept && typeof _this16.customIntercept.interceptConversation === 'function') {
          updatedConversationList = updatedConversationList.filter(function (one) {
            var isMatch = _this16.customIntercept.interceptConversation(one.conversation);

            return !isMatch;
          });
        } // 会话更新可能是由一些消息触发的


        updatedConversationList = updatedConversationList.filter(function (one) {
          if (one.updatedItems && one.updatedItems.latestMessage && one.updatedItems.latestMessage.val) {
            var messageType = one.updatedItems.latestMessage.val.messageType;
            return !isExcludeMessage(messageType);
          }

          return true;
        });

        if (updatedConversationList.length) {
          _this16.conversationManager.update(updatedConversationList);

          _this16.emit(CoreEvent.CONVERSATION, updatedConversationList);
        }
      });
      addEventListener(Events.MESSAGES, function (event) {
        _this16.logger.info(LogTagId.A_KIT_MESSAGE_LISTENER_S, JSON.stringify(event));

        var messages = event.messages; // 收到的新消息读取状态在sdk中已经被置为已读，需要重置回未读
        // 如果是多端同步消息需要清楚本地会话未读数

        messages = _this16.messageUnread(messages); // 将用户要接管的消息全部排除

        messages = _this16.filterInterceptMessage(messages); // 用户处理消息【供客户对消息进行加解密操作】

        messages = _this16.filterWillDisplayMessages(messages);
        messages = messages.filter(function (message) {
          return !isExcludeMessage(message.messageType);
        });

        if (!messages.length) {
          return;
        }

        var map = new Map();
        messages.forEach(function (message) {
          if (!map.has(message.conversationType + message.targetId + message.channelId)) {
            map.set(message.conversationType + message.targetId + message.channelId, messages.filter(function (msg) {
              return msg.conversationType === message.conversationType && msg.targetId === message.targetId && msg.channelId === message.channelId;
            }));
          }
        });
        map.forEach(function (value) {
          var con = {
            conversationType: value[0].conversationType,
            targetId: value[0].targetId,
            channelId: value[0].channelId
          };

          var localMessages = _this16.messageManager.setLocalMessages(con, value); // 收到新消息后，需要判断这些消息中是否有对应当前选中会话的消息


          if (_this16.currentConversation && localMessages["new"].length) {
            _this16.emit(CoreEvent.MESSAGES, localMessages["new"]);
          }

          if (localMessages.remove && localMessages.remove.length) {
            _this16.emit(CoreEvent.DELETE_MESSAGE, localMessages.remove);
          }
        });
      });
      addEventListener(Events.PULL_OFFLINE_MESSAGE_FINISHED, function () {
        _this16.emit(CoreEvent.PULL_OFFLINE_MESSAGE_FINISHED);
      });
      addEventListener(Events.TYPING_STATUS, function (event) {
        _this16.emit(CoreEvent.TYPING_STATUS, event);
      }); // 收到单聊已读回执

      addEventListener(Events.READ_RECEIPT_RECEIVED, function (event) {
        var conversation = event.conversation,
            sentTime = event.sentTime,
            messageUId = event.messageUId;

        var conversationResult = _this16.conversationManager.findConversation(conversation);

        if (conversationResult) {
          var targetConversation = conversationResult.source[conversationResult.index]; // 判断是否为最后一条消息，更新会话的latestMessage

          var latestMessage = targetConversation.latestMessage;

          if (latestMessage.sentTime === sentTime || latestMessage.messageUId === messageUId) {
            _this16.conversationManager.update([{
              conversation: targetConversation,
              updatedItems: {
                latestMessage: {
                  time: Date.now(),
                  val: _objectSpread(_objectSpread({}, latestMessage), {}, {
                    receivedStatus: ReceivedStatus.READ
                  })
                }
              }
            }]); // 抛出会话更新通知


            _this16.emit(CoreEvent.UPDATE_CONVERSATION, [targetConversation]);
          }
        } // 更新本地消息数据中的对应消息


        var messages = _this16.messageManager.getLocalMessage(conversation, 0, 0);

        var index = messages.list.findIndex(function (one) {
          return one.sentTime === sentTime || one.messageUId === messageUId;
        });

        if (index !== -1) {
          messages.list.forEach(function (msg) {
            var message = msg;
            message.receivedStatus = ReceivedStatus.READ;

            _this16.messageManager.updateMessage(message);

            _this16.emit(CoreEvent.UPDATE_MESSAGE, message);
          });
        } // 更新单聊已读状态


        _this16._conversationStorage.updateUnReadTime(sentTime, conversation.conversationType, conversation.targetId, conversation.channelId);

        _this16.emit(CoreEvent.READ_RECEIPT_RECEIVED, event);
      }); // 收到群组已读回执请求

      addEventListener(Events.MESSAGE_RECEIPT_REQUEST, function (event) {
        var conversation = event.conversation,
            messageUId = event.messageUId;

        if (isEqual(_this16.currentConversation, conversation)) {
          // 既是当前会话, 则直接抛出收到的数据通知UI端
          _this16.emit(CoreEvent.MESSAGE_RECEIPT_REQUEST, event);
        } else {
          var key = getConversationKey(conversation);

          if (_this16.switchTimes[key]) {
            var messages = _this16.messageManager.getLocalMessage(conversation, 0, 0); // 方案并不完美，在消息量较大的情况下，由于内存中存储的消息量较少，可能会造成查不到之前的消息


            var index = messages.list.findIndex(function (message) {
              return message.messageUId === messageUId && message.receivedTime < _this16.switchTimes[key];
            });

            if (index === -1) {
              // 将其进行缓存，待切换会话时传给消息列表
              _this16.receiptRequstCache.push(event);
            } else {
              // 表示已经读过这条消息，直接发送已读响应
              sendReadReceiptResponseV2(conversation.targetId, _defineProperty({}, event.senderUserId, [event.messageUId]), conversation.channelId);
            }
          } else {
            // 将其进行缓存，待切换会话时传给消息列表
            _this16.receiptRequstCache.push(event);
          }
        }
      }); // 收到群聊已读回执响应

      addEventListener(Events.MESSAGE_RECEIPT_RESPONSE, function (event) {
        _this16.emit(CoreEvent.MESSAGE_RECEIPT_RESPONSE, event);
      });
    }
    /**
     *
     * @param conversation 会话
     * @param start 开始时间，默认从最新一条的时间开始
     * @param count 获取数量，默认20条
     * @returns
     */

  }, {
    key: "getMessages",
    value: function getMessages(conversation) {
      var startTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

      var unReadTime = this._conversationStorage.getUnReadTime(conversation.conversationType, conversation.targetId, conversation.channelId);

      return this.messageManager.getMessages(conversation, unReadTime, startTime, count);
    }
  }, {
    key: "getConversation",
    value: function getConversation(option) {
      var _this17 = this;

      var tranceId = this.logger.createTraceId();
      this.logger.info(LogTagId.A_KIT_GET_CONVERSATION_T, JSON.stringify({
        option: option
      }), tranceId);
      var result = this.conversationManager.findConversation(option);

      if (result && result.index !== -1) {
        return this.getConversationProfile(option).then(function (profileList) {
          var profile = profileList;

          _this17.logger.info(LogTagId.A_KIT_GET_CONVERSATION_R, JSON.stringify({
            conversation: {
              conversationType: result.source[result.index].conversationType,
              targetId: result.source[result.index].targetId,
              channelId: result.source[result.index].channelId
            },
            profile: profile
          }), tranceId);

          return {
            conversation: result.source[result.index],
            profile: profile
          };
        });
      }

      this.logger.info(LogTagId.A_KIT_GET_CONVERSATION_R, 'resolve null');
      return Promise.resolve(null);
    }
  }, {
    key: "getConversationList",
    value: function getConversationList() {
      var _this18 = this;

      var more = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.conversationManager.getList(more, this._conversationStorage).then(function (conversationList) {
        // 整理出每个会话的三个属性
        var conversationOptions = conversationList.map(function (conversation) {
          return {
            conversationType: conversation.conversationType,
            targetId: conversation.targetId,
            channelId: conversation.channelId
          };
        });
        return _this18.service.getConversationProfile(conversationOptions).then(function (profileList) {
          return conversationList.map(function (conversation) {
            return {
              conversation: conversation,
              profile: profileList.find(function (profile) {
                if (profile) {
                  if (isEqual(profile, conversation)) {
                    return true;
                  }
                }

                return false;
              })
            };
          });
        })["catch"](function () {
          return conversationList.map(function (conversation) {
            return {
              conversation: conversation
            };
          });
        });
      });
    }
  }, {
    key: "createConversation",
    value: function createConversation(conversation) {
      return this.conversationManager.create(conversation);
    }
  }, {
    key: "_deleteConversation",
    value: function _deleteConversation(conversation) {
      // TODO 需要增加参数校验
      if (this.currentConversation && isEqual(conversation, this.currentConversation)) {
        this.currentConversation = null;
        this.emit(CoreEvent.SWITCH_CONVERSATION, this.currentConversation);
      }

      return this.conversationManager.remove(conversation);
    }
  }, {
    key: "removeConversation",
    value: function removeConversation(conversation) {
      var _this19 = this;

      this._deleteConversation(conversation).then(function () {
        _this19.emit(CoreEvent.CONVERSATION_INFO_CHANGED, conversation);
      });
    }
  }, {
    key: "setConversationToTop",
    value: function setConversationToTop(option, status) {
      return this.conversationManager.changeTopStatus(option, status);
    }
  }, {
    key: "setConversationNotificationStatus",
    value: function setConversationNotificationStatus(option, status) {
      return this.conversationManager.changeNotificationStatus(option, status);
    }
  }, {
    key: "referenceMessage",
    value: function referenceMessage(message) {
      this.emit(CoreEvent.REFERENCE_MESSAGE, message);
    }
  }, {
    key: "recallMessage",
    value: function recallMessage(message) {
      var _this20 = this;

      _recallMessage({
        conversationType: message.conversationType,
        targetId: message.targetId,
        channelId: message.channelId
      }, {
        messageUId: message.messageUId,
        sentTime: message.sentTime
      }).then(function (res) {
        if (res.code !== 0) {
          return;
        }

        var result = _this20.messageManager.recallMessage(message);

        if (result) {
          _this20.emit(CoreEvent.UPDATE_MESSAGE, result);
        }
      });
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(message) {
      var _this21 = this;

      deleteMessages({
        conversationType: message.conversationType,
        targetId: message.targetId,
        channelId: message.channelId
      }, [{
        messageUId: message.messageUId,
        sentTime: message.sentTime,
        messageDirection: message.messageDirection
      }]).then(function (res) {
        if (res.code !== 0) {
          return;
        }

        var result = _this21.messageManager.deleteMessage(message);

        if (result) {
          _this21.emit(CoreEvent.DELETE_MESSAGE, [message]);
        }
      });
    }
  }, {
    key: "registerMessageType",
    value: function registerMessageType(messageType, isPersited, isCounted, prototypes, isStatusMessage) {
      return _registerMessageType(messageType, isPersited, isCounted, prototypes, isStatusMessage);
    }
    /**
     * 发送文本消息
     * 在各个阶段，会抛出不同的事件
     * @param conversation
     * @param message
     * @param option
     */

  }, {
    key: "sendMessage",
    value: function sendMessage(conversation, msg, option) {
      var message = msg;
      var messageId = createMessageId();
      var messageContent = message.content;
      var preMessage = message; // 发送的是引用消息，则抛出关闭引用消息窗口

      if (message.messageType === MessageType.REFERENCE) {
        this.emit(CoreEvent.CLOSE_REFERENCE);
        preMessage = new ReferenceMessage$3(_objectSpread({}, messageContent));
      }

      if (message.messageType === MessageType.TextMessage) {
        preMessage = new TextMessage$1({
          content: messageContent.content
        });
      }

      if (message.messageType === MessageType.TextMessage || message.messageType === MessageType.REFERENCE) {
        message.content = this._willSendMessage(message.content, conversation.conversationType, conversation.targetId, message.messageType);
      }

      return this.decorateMessage(conversation, messageId, preMessage, _sendMessage(conversation, message, option));
    }
  }, {
    key: "sendImageMessage",
    value: function sendImageMessage(conversationOption, messageBody, hooks, options) {
      var _this22 = this;

      var msgBody = messageBody; // 使用闭包的方式保存messageId，方便消息回来后调用

      var messageId = createMessageId();
      this._fileCache[messageId] = msgBody;

      var decorate = function decorate(base64) {
        msgBody = _this22._willSendMessage(msgBody, conversationOption.conversationType, conversationOption.targetId, MessageType.IMAGE);
        return _this22.decorateMessage(conversationOption, messageId, new ImageMessage$1({
          content: base64,
          imageUri: ''
        }), _sendImageMessage(conversationOption, msgBody, {
          onProgress: function onProgress(progress) {
            _this22.emit(CoreEvent.UPLOAD_PROGRESS, {
              messageId: messageId,
              progress: progress
            });

            if (typeof hooks.onProgress === 'function') {
              hooks.onProgress(progress);
            }
          },
          onComplete: function onComplete(fileInfo) {
            _this22.emit(CoreEvent.UPLOAD_COMPLETE, {
              messageId: messageId,
              fileInfo: fileInfo
            });

            if (typeof hooks.onComplete === 'function') {
              hooks.onComplete(fileInfo);
            }
          }
        }, options));
      };

      return file2Base64(msgBody.file).then(function (base64) {
        decorate(base64);
      })["catch"](function () {
        decorate('');
      });
    }
  }, {
    key: "sendFileMessage",
    value: function sendFileMessage(conversationOption, messageBody, hooks, options) {
      var _this23 = this;

      var msgBody = messageBody;
      var messageId = createMessageId();
      var file = msgBody.file;
      this._fileCache[messageId] = file;
      msgBody = this._willSendMessage(msgBody, conversationOption.conversationType, conversationOption.targetId, MessageType.FILE);
      return this.decorateMessage(conversationOption, messageId, new FileMessage$1({
        name: file.name,
        size: file.size,
        type: file.type,
        fileUrl: ''
      }), _sendFileMessage(conversationOption, msgBody, {
        onProgress: function onProgress(progress) {
          _this23.emit(CoreEvent.UPLOAD_PROGRESS, {
            messageId: messageId,
            progress: progress
          });

          if (typeof hooks.onProgress === 'function') {
            hooks.onProgress(progress);
          }
        },
        onComplete: function onComplete(fileInfo) {
          _this23.emit(CoreEvent.UPLOAD_COMPLETE, {
            messageId: messageId,
            fileInfo: fileInfo
          });

          if (typeof hooks.onComplete === 'function') {
            hooks.onComplete(fileInfo);
          }
        }
      }, options));
    }
  }, {
    key: "resendMessage",
    value: function resendMessage(conversation, message) {
      // 删除之前失败消息
      this.messageManager.deleteMessage(message);
      this.emit(CoreEvent.DELETE_MESSAGE, [message]);
      var newMessage = null;
      var content = message.content;
      var file;
      var imgFile;
      var option;

      switch (message.messageType) {
        case 'RC:TxtMsg':
          option = null;

          if (content.mentionedInfo) {
            option = content.mentionedInfo;
            option.isMentioned = true;
          }

          newMessage = new TextMessage$1({
            content: content.content
          });
          this.sendMessage(conversation, newMessage, option);
          break;

        case 'RC:ImgMsg':
          imgFile = this._fileCache[message.messageId];
          this.sendImageMessage(conversation, imgFile, {
            onProgress: function onProgress() {// TODO
            },
            onComplete: function onComplete() {// TODO
            }
          });
          delete this._fileCache[message.messageId];
          break;

        case 'RC:FileMsg':
          file = this._fileCache[message.messageId];
          this.sendFileMessage(conversation, {
            file: file
          }, {
            onProgress: function onProgress() {// TODO
            },
            onComplete: function onComplete() {// TODO
            }
          });
          delete this._fileCache[message.messageId];
          break;

        case 'RC:ReferenceMsg':
          newMessage = new ReferenceMessage$3({
            referMsgUserId: content.referMsgUserId,
            referMsg: content.referMsg,
            content: content.content,
            objName: content.objName
          });
          this.sendMessage(conversation, newMessage, option);
          break;
      }
    }
    /**
     * 消息发送前回调
     * willSendMessage 初始化时有客户传递
     * @param content
     * @param conversationType
     * @param targetId
     * @param messageType
     * @returns
     */

  }, {
    key: "_willSendMessage",
    value: function _willSendMessage(content, conversationType, targetId, messageType) {
      var con = content;

      if (this.customDisplayMessage && this.customDisplayMessage.willSendMessage && typeof this.customDisplayMessage.willSendMessage === 'function') {
        con = this.customDisplayMessage.willSendMessage(con, conversationType, targetId, messageType);
      }

      return con;
    }
  }, {
    key: "sendMessageCallBack",
    value: function sendMessageCallBack(res, tempMessage, messageId, findResult, resultConversation) {
      var message = res.data ? res.data : tempMessage;
      message.messageId = messageId;

      if (message && message.content) {
        // 发送成功调用 willDisplayMessages 处理消息
        if (this.customDisplayMessage && this.customDisplayMessage.willDisplayMessages && typeof this.customDisplayMessage.willDisplayMessages === 'function') {
          message.content = this.customDisplayMessage.willDisplayMessages(message.content, message.conversationType, message.targetId, message.messageType);
        }
      }

      this.logger.info(LogTagId.A_KIT_SEND_MESSAGE_CALLBACK_S, JSON.stringify({
        code: res.code,
        messageUId: message.messageUId
      }));

      if (res.code === 0) {
        // 发送成功后 imlib 会自动通知会话更新
        // 只需要更新消息列表
        this.messageManager.updateMessage(message); // 消息发送成功的事件通知

        this.emit(CoreEvent.MESSAGE_SEND_SUCCESS, message);
        delete this._fileCache[message.messageId];
      } else {
        // 发送失败后，更新会话列表
        if (findResult) {
          // 由于消息发送失败， messageUId为空，借用这个字段标志消息状态
          message.messageUId = "fail_".concat(message.messageId);
        }

        this.messageManager.updateMessage(message); // 消息发送失败的事件通知

        this.emit(CoreEvent.MESSAGE_SEND_FAIL, message);
      }

      var updatedConversation = {
        conversation: resultConversation,
        updatedItems: {
          latestMessage: {
            time: Date.now(),
            val: message
          }
        }
      };
      this.conversationManager.update([updatedConversation]);
      this.emit(CoreEvent.UPDATE_CONVERSATION, [_objectSpread(_objectSpread({}, resultConversation), {}, {
        latestMessage: message
      })]);
      return res;
    }
    /**
     * 发送消息的装饰器
     * @param conversationOption
     * @param messageId
     * @param messageBody
     * @param action
     * @returns
     */

  }, {
    key: "decorateMessage",
    value: function decorateMessage(conversationOption, messageId, messageBody, action) {
      var _this24 = this;

      // 构建显示用的临时消息
      var tempMessage = {
        targetId: conversationOption.targetId,
        channelId: conversationOption.channelId,
        conversationType: conversationOption.conversationType,
        messageType: messageBody.messageType,
        content: messageBody.content,
        sentTime: Date.now(),
        messageDirection: MessageDirection.SEND,
        senderUserId: getCurrentUserId(),
        receivedTime: undefined,
        isPersited: messageBody.isPersited,
        isCounted: messageBody.isCounted,
        messageUId: "sending_".concat(messageId),
        isOffLineMessage: false,
        canIncludeExpansion: false,
        receivedStatus: ReceivedStatus.UNREAD,
        messageId: messageId
      }; // 插入临时消息

      this.messageManager.insertMessage(tempMessage); // 发出增加消息的事件

      this.emit(CoreEvent.MESSAGES, [tempMessage]); // 更新会话的最后一条消息

      var findResult = this.conversationManager.findConversation(conversationOption);
      var resultConversation = null;

      if (findResult) {
        resultConversation = findResult.source[findResult.index];
        var updatedConversation = {
          conversation: resultConversation,
          updatedItems: {
            latestMessage: {
              time: Date.now(),
              val: tempMessage
            }
          }
        };
        this.conversationManager.update([updatedConversation]);
        this.emit(CoreEvent.UPDATE_CONVERSATION, [_objectSpread(_objectSpread({}, resultConversation), {}, {
          latestMessage: tempMessage
        })]);
      } // 发出正在发送的事件通知


      this.emit(CoreEvent.MESSAGE_SENDING, tempMessage); // 发送消息

      return action.then(function (res) {
        return _this24.sendMessageCallBack(res, tempMessage, messageId, findResult, resultConversation);
      });
    }
  }, {
    key: "getConversationProfile",
    value: function getConversationProfile(conversationOption) {
      return this.service.getConversationProfile([conversationOption]).then(function (res) {
        if (!res || !res.length) {
          return null;
        }

        return res[0];
      });
    }
  }, {
    key: "getGroupMemberProfile",
    value: function getGroupMemberProfile(conversationOption, userId) {
      if (conversationOption.conversationType === ConversationType.GROUP) {
        if (!userId) return null;
        return this.service.getGroupMembers(conversationOption).then(function (members) {
          var index = members.findIndex(function (member) {
            return member.id === userId;
          });

          if (index !== -1) {
            return members[index];
          }

          return null;
        });
      }

      return null;
    }
  }, {
    key: "getGroupMembers",
    value: function getGroupMembers(conversation) {
      return this.service.getGroupMembers(conversation);
    }
  }, {
    key: "getMyProfile",
    value: function getMyProfile() {
      var id = getCurrentUserId();

      if (!id) {
        throw new Error('Unable to get the current user ID.');
      }

      return this.service.getUserProfile(id);
    }
    /**
     * 判断消息是否为用户类自定义消息
     * @param message IAReceivedMessage
     * @returns boolean
     */

  }, {
    key: "isCustomUserMessage",
    value: function isCustomUserMessage(message) {
      if (!this.customMessage) {
        return false;
      }

      var customUserMessage = this.customMessage.userMessage;
      return customUserMessage && customUserMessage[message.messageType] !== undefined;
    }
    /**
     * 生成自定义的用户类消息 message内容
     * @param message
     * @returns
     */

  }, {
    key: "createCustomUserMessageDom",
    value: function createCustomUserMessageDom(message) {
      if (!this.customMessage) {
        return null;
      }

      var customUserMessage = this.customMessage.userMessage;

      if (customUserMessage) {
        return customUserMessage[message.messageType](message);
      }

      return null;
    }
    /**
     * 判断消息是否为通知类自定义消息
     * @param message IAReceivedMessage
     * @returns boolean
     */

  }, {
    key: "isCustomNotifyMessage",
    value: function isCustomNotifyMessage(message) {
      if (!this.customMessage) {
        return false;
      }

      var customNotifyMessage = this.customMessage.notifyMessage;
      return customNotifyMessage && customNotifyMessage[message.messageType] !== undefined;
    }
    /**
     * 生成自定义的通知类消息的message内容
     * @param message
     * @returns
     */

  }, {
    key: "createCustomNotifyMessageDom",
    value: function createCustomNotifyMessageDom(message) {
      if (!this.customMessage) {
        return null;
      }

      var customNotifyMessage = this.customMessage.notifyMessage;

      if (customNotifyMessage) {
        return customNotifyMessage[message.messageType](message);
      }

      return null;
    }
    /**
    * 判断消息是传递会话 lastmessage 展示描述
    * @param message IAReceivedMessage
    * @returns boolean
    */

  }, {
    key: "isCustomLastMessage",
    value: function isCustomLastMessage(message) {
      if (!this.customMessage) {
        return false;
      }

      var customUserMessage = this.customMessage.lastMessage;
      return customUserMessage && customUserMessage[message.messageType] !== undefined;
    }
    /**
     * 生成自定义的通知类消息的message内容
     * @param message
     * @returns
     */

  }, {
    key: "createCustomLastMessageDom",
    value: function createCustomLastMessageDom(message) {
      if (!this.customMessage) {
        return null;
      }

      var customNotifyMessage = this.customMessage.lastMessage;

      if (customNotifyMessage) {
        return customNotifyMessage[message.messageType](message);
      }

      return null;
    }
  }, {
    key: "clearMessagesUnreadStatus",
    value: function clearMessagesUnreadStatus(conversation) {
      var _this25 = this;

      _clearMessagesUnreadStatus(conversation).then(function (_ref) {
        var code = _ref.code;
        var syncReadTime = conversation.latestMessage.sentTime;

        if (code === 0) {
          sendSyncReadStatusMessage(conversation, syncReadTime).then(function (syncReadRes) {
            if (syncReadRes.code !== 0) {
              _this25.logger.warn(LogTagId.A_KIT_SYNC_READ_E, JSON.stringify({
                msg: '同步会话未读数失败'
              }));
            }
          });
        }
      }); // 因为在开发过程中，发现清理未读数后，发现sdk并没有发出conversation事件，因此需要手动更新


      this.conversationManager.update([{
        conversation: conversation,
        updatedItems: {
          unreadMessageCount: {
            time: Date.now(),
            val: 0
          }
        }
      }]);
      this.emit(CoreEvent.UPDATE_CONVERSATION, [_objectSpread(_objectSpread({}, conversation), {}, {
        unreadMessageCount: 0
      })]);
    }
  }, {
    key: "saveTextMessageDraft",
    value: function saveTextMessageDraft(conversation, content) {
      var _this26 = this;

      _saveTextMessageDraft(conversation, content).then(function (res) {
        // 保存成功
        if (res.code === 0) {
          _this26.emit(CoreEvent.SWITCH_CONVERSATION, _this26.currentConversation);
        } else {
          // 草稿保存失败
          _this26.logger.info(LogTagId.A_KIT_SAVE_DRAFT_O, JSON.stringify({
            msg: '保存草稿失败',
            info: res.msg
          }));
        }
      });
    }
    /**
     * 更新用户信息
     * @param id
     * @param info
     */

  }, {
    key: "updateUserProfile",
    value: function updateUserProfile(info) {
      this.service.updateUserProfile(info);

      if (this.currentConversation) {
        this.emit(CoreEvent.USER_INFO_CHANGED, info);
      }
    }
    /**
     * 更新群组信息
     * @param conversation
     * @param info
     */

  }, {
    key: "updateGroupMembers",
    value: function updateGroupMembers(conversation, info) {
      this.service.updateGroupMembers(conversation, info); // 当前会话为修改会话通知群成员信息变更。

      if (this.currentConversation && conversation && isEqual(this.currentConversation, conversation)) {
        this.emit(CoreEvent.GROUP_INFO_CHANGED, info);
      }
    }
    /**
     * 更新会话信息
     * @param conversation
     * @param info
     */

  }, {
    key: "updateConversationProfile",
    value: function updateConversationProfile(conversation, info) {
      this.service.updateConversationProfile(conversation, info);

      if (this.currentConversation && conversation && isEqual(this.currentConversation, conversation)) {
        this.emit(CoreEvent.CONVERSATION_INFO_CHANGED, info);
      }
    }
    /**
     * 获取本地指定会话的已读时间
     * @since 5.6.5
     */

  }, {
    key: "getUnReadTime",
    value: function getUnReadTime(conversation) {
      return this._conversationStorage.getUnReadTime(conversation.conversationType, conversation.targetId, conversation.channelId);
    }
  }]);

  return Core;
}(EventEmitter$1); // 单例模式


Core.INSTANCE = null;
var core = new Core();
/* eslint-disable */

var DisabledMessageContextMenu;

(function (DisabledMessageContextMenu) {
  DisabledMessageContextMenu[DisabledMessageContextMenu["Forward"] = 0] = "Forward";
  DisabledMessageContextMenu[DisabledMessageContextMenu["Delete"] = 1] = "Delete";
  DisabledMessageContextMenu[DisabledMessageContextMenu["Recall"] = 2] = "Recall";
  DisabledMessageContextMenu[DisabledMessageContextMenu["Reference"] = 3] = "Reference";
  DisabledMessageContextMenu[DisabledMessageContextMenu["Copy"] = 4] = "Copy";
})(DisabledMessageContextMenu || (DisabledMessageContextMenu = {}));

var DisabledConversationontextMenu;

(function (DisabledConversationontextMenu) {
  DisabledConversationontextMenu[DisabledConversationontextMenu["Top"] = 0] = "Top";
  DisabledConversationontextMenu[DisabledConversationontextMenu["Notification"] = 1] = "Notification";
  DisabledConversationontextMenu[DisabledConversationontextMenu["Delete"] = 2] = "Delete";
})(DisabledConversationontextMenu || (DisabledConversationontextMenu = {})); // @ts-nocheck
// eslint-disable-next-line no-console


console.warn('IMKit版本信息', "12/4/2023, 2:03:45 PM", "7fa3aa91969f267cf69b526694539457b231ee3b", "5.6.7-alpha.1");

__addSDKVersion('IMKit', "5.6.7-alpha.1");

var atIndex = 0;
/**
 * 获取element的 selection
 */

function getWindowSelection(element) {
  if (element.tagName === 'IFRAME') {
    return element.contentWindow.getSelection();
  }

  return window.getSelection();
}
/**
 * 获取element所在的document
 */


function getDocument(element) {
  var iframe;

  if (element.tagName === 'IFRAME') {
    iframe = element;
  }

  if (!iframe) {
    return document;
  }

  if (iframe.contentDocument) {
    return iframe.contentDocument; // } else if (iframe.contentDocument) {
  }

  if (iframe.contentWindow) {
    return iframe.contentWindow.document;
  }

  return null;
}

function verifyConfigs(configs) {
  return configs;
}

function ensureEditable(container) {
  var ele = container;

  if (container.tagName === 'IFRAME') {
    ele = container.contentWindow.document;
    ele.contentEditable = true;
    return;
  }

  if (ele.getAttribute && ele.getAttribute('contenteditable') === undefined) {
    ele.setAttribute('contenteditable', true);
  }
}

function getPosition(el) {
  var bounding = el.getBoundingClientRect();
  return {
    left: bounding.left,
    top: bounding.top,
    bottom: bounding.bottom,
    right: bounding.right,
    x: bounding.x,
    y: bounding.y,
    width: bounding.width,
    height: bounding.height
  };
}

function parseHTML(html) {
  var fragment = document.createDocumentFragment();
  var node = document.createElement('div');
  node.innerHTML = html;

  while (node.firstChild) {
    fragment.appendChild(node.firstChild);
  }

  return fragment;
}
/**
 * 获取光标前的文本（对象）
 */


function getTextBeforeCursor(containerEl) {
  var precedingChar;

  var _getDocument = getDocument(containerEl),
      body = _getDocument.body;

  var sel = getWindowSelection(containerEl);

  if (sel.rangeCount > 0) {
    var range = sel.getRangeAt(0).cloneRange();
    range.collapse(true);
    range.setStart(body, 0);
    precedingChar = range.cloneContents();
  }

  return precedingChar;
}
/**
 * 获取光标后面的节点
 */


function getTextAfterCursor(containerEl) {
  var sel = getWindowSelection(containerEl);
  var precedingChar;

  if (sel.rangeCount > 0) {
    var _getDocument2 = getDocument(containerEl),
        body = _getDocument2.body;

    var range = sel.getRangeAt(0).cloneRange();
    range.collapse(false);
    range.setEnd(body, body.childNodes.length);
    precedingChar = range.cloneContents();
  }

  return precedingChar;
}
/**
 * 将光标放置到最后
 */


function placeCaretAtEnd(el) {
  el.focus();
  var doc = getDocument(el);
  var body = doc.body;

  if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
    var range = doc.createRange();
    range.selectNodeContents(body);
    range.collapse(false);
    var sel = getWindowSelection(el);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (typeof doc.body.createTextRange !== 'undefined') {
    var textRange = doc.body.createTextRange();
    textRange.moveToElementText(body);
    textRange.collapse(false);
    textRange.select();
  }
} // for contenteditable


var At = /*#__PURE__*/function () {
  function At(container, configs, locale) {
    _classCallCheck(this, At);

    // 确认容器可以用来编辑
    ensureEditable(container);
    this.container = container; // 验证参数

    this.configs = verifyConfigs(configs);
    this.triggers = this.configs.map(function (config) {
      return config.trigger;
    }); // 是否处于正在触发的过程中

    this.triggering = false;
    this.bindFuncs(); // 绑定按键keyup

    this.body = getDocument(container).body;
    this.body.addEventListener('keydown', this.checkKeyDown, false); // body.addEventListener('mouseup', this.checkMouse, false);

    this.locale = locale;
  }

  _createClass(At, [{
    key: "bindFuncs",
    value: function bindFuncs() {
      this.checkKeyDown = this.checkKeyDown.bind(this);
      this.onSelect = this.onSelect.bind(this);
      this.checkMouse = this.checkMouse.bind(this);
    }
  }, {
    key: "checkKeyDown",
    value: function checkKeyDown(event) {
      var key = event.key;
      var index = this.triggers.indexOf(key);

      if (index !== -1) {
        event.preventDefault();

        if (this.triggering) {
          return;
        }

        var config = this.configs[index];
        var html = "<span id='at_".concat(atIndex, "' class='at-span' data-trigger='@'>@</span>");
        var atObj = this.inserElement(html, atIndex);

        if (atObj) {
          this.currentIndex = atIndex;
          var position = getPosition(atObj);

          if (typeof config.onTrigger === 'function') {
            this.triggering = true;
            config.onTrigger(position, this.onSelect);
          }
        }
      } else if (event.keyCode === 8) {
        // 如果正在选择
        if (this.triggering) {
          event.preventDefault();
          this.cancelTrigger();
          return;
        }

        var selection = getWindowSelection(this.container);

        if (selection.rangeCount === 0) {
          return;
        }

        var _getDocument3 = getDocument(this.container),
            body = _getDocument3.body; // 判断当前是否处于一个@span中


        var range = selection.getRangeAt(0);
        var targetContainer = range.commonAncestorContainer;
        var parentNode = targetContainer.parentNode;

        if (parentNode && this.isAtNode(parentNode)) {
          var content = parentNode.childNodes[0].nodeValue.replace("@".concat(parentNode.getAttribute('data-name')), '');

          if (content.length === 0) {
            var child = null;
            var _node = parentNode.parentNode;

            if (parentNode.childElementCount) {
              var _parentNode$children = _slicedToArray(parentNode.children, 1);

              child = _parentNode$children[0];
            }

            parentNode.parentNode.removeChild(parentNode);

            if (child) {
              _node.appendChild(child);
            }

            event.preventDefault();
            return;
          }
        } // 判断光标前是否为一个@span


        var copyRange = selection.getRangeAt(0).cloneRange();
        copyRange.collapse(true);
        copyRange.setStart(body, 0);
        var beforeNodes = copyRange.cloneContents();
        var node = beforeNodes.lastChild;

        if (this.isAtNode(node)) {
          var target = body.querySelector("#".concat(node.id));

          var _content = target.childNodes[0].nodeValue.replace("@".concat(target.getAttribute('data-name')), '');

          if (_content.length === 0) {
            target.parentNode.removeChild(target);
            event.preventDefault();
          }
        }
      } else if (event.keyCode === 27) {
        if (this.triggering) {
          event.preventDefault();
          this.cancelTrigger();
        }
      }
    }
    /**
     * 取消操作
     */

  }, {
    key: "cancelTrigger",
    value: function cancelTrigger() {
      var doc = getDocument(this.container);
      var node = doc.querySelector("#at_".concat(this.currentIndex));

      if (node) {
        var isSelectUser = node.getAttribute('data-name');

        if (isSelectUser) {
          return;
        }

        var content = node.innerHTML;
        var parentNode = node.parentNode;
        parentNode.removeChild(node);
        parentNode.innerHTML += content;
        doc.body.blur();
      }

      this.triggering = false;
    }
  }, {
    key: "isAtNode",
    value: function isAtNode(node) {
      if (!node) {
        return false;
      }

      return node.nodeType === 1 && node.nodeName === 'SPAN' && node.getAttribute('data-trigger') !== undefined;
    }
  }, {
    key: "onSelect",
    value: function onSelect(selectedItem) {
      this.triggering = false;
      var doc = getDocument(this.container);
      var obj = doc.querySelector("#at_".concat(this.currentIndex));

      if (!obj) {
        this.cancelTrigger();
        return;
      }

      obj.setAttribute('data-name', selectedItem.value);
      obj.innerHTML = "@".concat(selectedItem.value);
      var id = selectedItem.value === this.locale.other.all ? 'all' : selectedItem.id;
      obj.setAttribute('data-id', id);
      atIndex++;
      doc.body.focus(); // 光标定位到obj的后面

      var range = doc.createRange();
      range.setStartAfter(obj.nextSibling || obj);
      range.collapse(true);
      var sel = getWindowSelection(this.container);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }, {
    key: "inserElement",
    value: function inserElement(html, indexAt) {
      var doc = getDocument(this.container);
      placeCaretAtEnd(doc.body);
      var node = parseHTML(html);
      var selection = getWindowSelection(this.container);
      var currentRange = selection.getRangeAt(0);
      currentRange.insertNode(node); // currentRange.collapse();
      // 将光标定位到@的后面

      var obj = doc.querySelector("#at_".concat(indexAt));
      selection.removeAllRanges();
      selection.selectAllChildren(obj);
      selection.collapseToEnd();
      return obj;
    }
  }, {
    key: "checkMouse",
    value: function checkMouse(e) {
      if (this.triggering) {
        e.preventDefault();
        return;
      }

      var a = getTextBeforeCursor(this.container); // let item
      // if (!-[1]) {
      //   item = parseHTML(a).lastChild
      // } else {

      var item = a.lastChild; // }

      if (item !== null && item.nodeType === 1 && item.nodeName === 'SPAN') {
        var id = item.id;
        this.currentIndex = item.id.substring(3); // 获取trigger类型

        var trigger = item.getAttribute('data-trigger');
        var index = this.triggers.indexOf(trigger);

        if (index !== -1) {
          // 找到dom
          var atObj = getDocument(this.container).querySelector("#".concat(id));

          if (atObj) {
            var config = this.configs[index];
            var position = getPosition(atObj);

            if (typeof config.onTrigger === 'function') {
              this.triggering = true;
              config.onTrigger(position, this.onSelect);
            }
          }
        }
      }
    }
    /**
     * 销毁对象
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this.body.removeEventListener('keydown', this.checkKeyDown, false); // this.container.removeEventListener('mouseup', this.checkMouse, false);
    }
  }]);

  return At;
}();

var zh_CN = {
  area: 'zh_CN',
  lang: '中文',
  // 会话列表
  conversation: {
    loading: '正在加载列表',
    forMore: '上拉获取更多',
    noData: '当前无会话',
    draft: '草稿',
    atMe: '有人@我',
    file: '文件',
    img: '图片',
    location: '位置消息',
    video: '短视频',
    audio: '语音消息',
    quote: '引用消息',
    yesterday: '昨天',
    before: '前天',
    top: '取消置顶',
    noTop: '置顶',
    inform: '允许消息通知',
    noInform: '消息免打扰',
    "delete": '删除',
    read: '已读',
    unread: '未读',
    recall: '撤回了一条消息',
    you: '你'
  },
  // 消息列表
  message: {
    history: '下拉获取历史消息',
    noHistory: '没有更多历史消息了',
    loading: '加载中...',
    completed: '加载完毕',
    noData: '新的一天，新的开始',
    year: '年',
    month: '月',
    day: '日',
    hour: '点',
    minute: '分',
    copy: '复制',
    quote: '引用',
    recall: '撤回',
    "delete": '删除',
    msgRecall: '撤回了一条消息',
    you: '你',
    opposite: '对方',
    file: '文件',
    location: '位置',
    nonsupport: '当前版本不支持查看此消息',
    forward: '转发',
    createGroup: '创建了群组',
    inviteGroup: function inviteGroup(targetUserDisplayNames) {
      return "\u9080\u8BF7 ".concat(targetUserDisplayNames, " \u52A0\u5165\u4E86\u7FA4\u7EC4");
    },
    removeGroupMember: function removeGroupMember(targetUserDisplayNames) {
      return "\u5C06 ".concat(targetUserDisplayNames, " \u79FB\u51FA\u4E86\u7FA4\u7EC4");
    },
    quitGroup: '退出了群组',
    dismiss: '解散了群组',
    rename: '修改群名称为'
  },
  // 消息编辑器
  messageEdit: {
    send: '发送',
    image: '图片',
    picError: '图片格式有误',
    file: '文件'
  },
  other: {
    unKnowMessage: '未知消息',
    all: '所有人'
  }
};
/* local lang i18 settings. */

var en = {
  area: 'en',
  lang: 'English',
  conversation: {
    loading: 'loading...',
    forMore: 'more',
    noData: 'empty',
    draft: 'draft',
    atMe: '@me',
    file: 'file',
    img: 'image',
    location: 'location',
    video: 'video',
    audio: 'audio',
    quote: 'quote',
    yesterday: 'yesterday',
    before: 'before',
    top: 'untop',
    noTop: 'top',
    inform: 'unmute',
    noInform: 'mute',
    "delete": 'delete',
    read: 'read',
    unread: 'unread',
    recall: 'recalled a message',
    you: 'You '
  },
  message: {
    history: 'more',
    noHistory: 'no more',
    loading: 'loading...',
    completed: 'completed',
    noData: 'empty',
    year: 'year ',
    month: 'month ',
    day: 'day',
    hour: 'hour',
    minute: 'minute',
    copy: 'copy',
    quote: 'quote',
    recall: 'recall',
    "delete": 'delete',
    msgRecall: 'recalled message',
    you: 'you',
    opposite: 'opposite',
    file: 'file',
    location: 'location',
    nonsupport: 'the current version does not support viewing this message',
    forward: 'forward',
    createGroup: 'created the group.',
    inviteGroup: function inviteGroup(targetUserDisplayNames) {
      return "invited ".concat(targetUserDisplayNames, " to join the group.");
    },
    removeGroupMember: function removeGroupMember(targetUserDisplayNames) {
      return "removed ".concat(targetUserDisplayNames, ". From the group chat.");
    },
    quitGroup: 'quitted the group.',
    dismiss: 'dismissed the group.',
    rename: 'changed the group name to '
  },
  messageEdit: {
    send: 'send',
    image: 'image',
    picError: 'image format is wrong',
    file: 'file'
  },
  other: {
    unKnowMessage: 'Unknown message',
    all: 'all people'
  }
};
/* eslint-disable camelcase */

var language = {
  zh_CN: zh_CN,
  en: en
};
var contentEditorCss = ".editor-content{width:calc(100% - 11em);height:100%;line-height:1.5;font-size:1.8em;overflow:auto;border:none}.editor-content:focus{border:none;outline:none}.post-btn{position:absolute;right:4em;bottom:5em}.post-btn button{font-size:2.4em;border:0.1em solid #aaaeb2;border-radius:0.5em;height:2.83333em;width:7em;background:#fff;color:#0099ff;outline:none}.post-btn button:disabled{border:0.1em solid #c7cbce;color:#c7cbce}";

var ContentEditor$1 = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ContentEditor$1, _HTMLElement);

  var _super3 = _createSuper(ContentEditor$1);

  function ContentEditor$1() {
    var _this27;

    _classCallCheck(this, ContentEditor$1);

    _this27 = _super3.call(this);

    _this27.__registerHost();

    attachShadow(_assertThisInitialized(_this27));
    _this27.post = createEvent(_assertThisInitialized(_this27), "post", 7);
    _this27.contentChange = createEvent(_assertThisInitialized(_this27), "contentChange", 7);
    _this27.inputContent = createEvent(_assertThisInitialized(_this27), "inputContent", 7);
    _this27.memberListVisible = false;
    _this27.hasContent = false;
    _this27.lang = core.lang; // 语言标识

    _this27.handleInput = _this27.handleInput.bind(_assertThisInitialized(_this27));
    _this27.handleKeyDown = _this27.handleKeyDown.bind(_assertThisInitialized(_this27));
    _this27.postHandler = _this27.postHandler.bind(_assertThisInitialized(_this27));
    _this27.handlePastContent = _this27.handlePastContent.bind(_assertThisInitialized(_this27));
    _this27.handleSelectMember = _this27.handleSelectMember.bind(_assertThisInitialized(_this27));
    _this27.handleCloseMemberList = _this27.handleCloseMemberList.bind(_assertThisInitialized(_this27));
    _this27.handleSwitchConversation = _this27.handleSwitchConversation.bind(_assertThisInitialized(_this27));
    _this27.handleLanguageChanged = _this27.handleLanguageChanged.bind(_assertThisInitialized(_this27));
    return _this27;
  } // 检测属性value的变化


  _createClass(ContentEditor$1, [{
    key: "validateWatchData",
    value: function validateWatchData(newValue, oldValue) {
      if (!oldValue || newValue.time !== oldValue.time) {
        var doc = getDocument(this.contentRef);
        doc.body.innerHTML = newValue.text;
        placeCaretAtEnd(this.contentRef);
      }
    }
  }, {
    key: "validateConversationData",
    value: function validateConversationData(newValue, oldValue) {
      // 存在oldValue，说明已经加载过了
      if (oldValue) {
        if (oldValue.conversationType !== ConversationType$1.GROUP) {
          if (newValue && newValue.conversationType === ConversationType$1.GROUP) {
            this.createAt();
          }
        } else if (newValue && newValue.conversationType !== ConversationType$1.GROUP) {
          if (this.at) {
            this.at.dispose();
          }
        }
      }
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.contentRef) {
        var doc = getDocument(this.contentRef); // 绑定粘贴事件

        if (doc) {
          doc.body.removeEventListener('paste', this.handlePastContent);
          doc.body.removeEventListener('input', this.handleInput);
          doc.body.removeEventListener('keydown', this.handleKeyDown);
        }
      }

      if (this.at) {
        this.at.dispose();
      }

      core.off(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      var _this28 = this;

      if (this.value) {
        var doc = getDocument(this.contentRef);
        doc.body.innerHTML = this.value.text;
      } // 只有群组使用@功能


      setTimeout(function () {
        // 第一次加载@功能
        if (_this28.conversation && _this28.conversation.conversationType === ConversationType$1.GROUP) {
          _this28.createAt();
        }

        var doc = getDocument(_this28.contentRef); // 绑定粘贴事件

        if (doc) {
          doc.body.addEventListener('paste', _this28.handlePastContent);
          doc.body.addEventListener('input', _this28.handleInput);
          doc.body.addEventListener('keydown', _this28.handleKeyDown);
          doc.designMode = 'on';
          doc.contentEditable = true;
          doc.body.style.margin = 0;
          doc.body.style.padding = 0;
          doc.body.style.wordBreak = 'break-all';
        }
      }, 500);
      core.on(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
    }
  }, {
    key: "handleInput",
    value: function handleInput() {
      var _this29 = this;

      this.checkContentLength();
      this.contentChangeHandler();

      if (!this.inputTimer) {
        this.inputContent.emit();
      }

      this.inputTimer = setTimeout(function () {
        clearTimeout(_this29.inputTimer);
        _this29.inputTimer = null;
      }, 5000);
    }
    /**
     * 检查是否有内容
     */

  }, {
    key: "checkContentLength",
    value: function checkContentLength() {
      var _this30 = this;

      if (this.checkContentTimer) {
        return;
      }

      this.checkContentTimer = setTimeout(function () {
        if (!getDocument(_this30.contentRef)) {
          return;
        }

        var content = getDocument(_this30.contentRef).body.innerHTML;
        content = content.trim();
        content = content.replace(/&nbsp;/g, '');
        content = content.replace(/<br>/g, '');

        if (content) {
          _this30.hasContent = true;
        } else {
          _this30.hasContent = false;
        }

        _this30.checkContentTimer = null;
      }, 400);
    }
  }, {
    key: "contentChangeHandler",
    value: function contentChangeHandler() {
      this.contentChange.emit(getDocument(this.contentRef).body.innerHTML);
    }
    /**
     * 处理粘贴内容
     */

  }, {
    key: "handlePastContent",
    value: function handlePastContent(event) {
      // 只读区剪贴板中的文本，不处理其他的文件内容
      var paste = (event.clipboardData || window.clipboardData).getData('text');
      var selection = getWindowSelection(this.contentRef);
      if (!selection.rangeCount) return;
      selection.deleteFromDocument();
      var range = selection.getRangeAt(0);
      var node = document.createTextNode(paste);
      range.insertNode(node);
      range.setStartAfter(node);
      range.collapse(true);
      event.preventDefault();
      this.checkContentLength();
    }
    /**
     * 发出消息
     */

  }, {
    key: "postHandler",
    value: function postHandler() {
      var doc = getDocument(this.contentRef);
      this.post.emit(doc.body.innerHTML); // 发出后清空

      doc.body.innerHTML = '';
      this.hasContent = false;
      if (this.at) this.at.triggering = false;
    }
    /**
     * 处理检测按键
     */

  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this31 = this;

      if (e.keyCode === 8) {
        // at 清除元素和按键通知异步问题。 TODO：待优化
        setTimeout(function () {
          _this31.contentChangeHandler();
        });
      }

      if (e.keyCode === 13) {
        e.preventDefault(); // shift换行

        if (e.shiftKey) {
          var selection = getWindowSelection(this.contentRef);
          var range = selection.getRangeAt(0);
          var contents = getTextAfterCursor(this.contentRef); // 过滤空节点

          var elements = Array.prototype.filter.call(contents.childNodes, function (node) {
            return !(node.nodeName === '#text' && !node.data);
          }); // 后面没节点了

          if (!elements.length) {
            var node = document.createElement('br');
            range.insertNode(node);
          }

          var lastNode = document.createElement('br');
          range.insertNode(lastNode);
          range.collapse(false);
          return;
        }

        this.memberListVisible = false; // 发送消息

        this.postHandler();
      }

      this.checkContentLength();
    }
  }, {
    key: "createAt",
    value: function createAt() {
      var self = this;
      this.at = new At(this.contentRef, [{
        trigger: '@',
        onTrigger: function onTrigger(position, handleSelect) {
          var rect = self.contentRef.getBoundingClientRect(); // 触发@

          self.targetRect = {
            width: position.width,
            height: position.height,
            x: position.x + rect.x,
            y: position.y + rect.y
          };
          self.memberListVisible = true;
          self.atItemSelect = handleSelect;
        },
        onCancel: function onCancel() {
          self.memberListVisible = false;
        }
      }], this.locale);
    }
  }, {
    key: "handleSelectMember",
    value: function handleSelectMember(event) {
      var data = event.detail;
      this.atItemSelect(data);
      this.memberListVisible = false;
      this.contentChange.emit(getDocument(this.contentRef).body.innerHTML);
    }
  }, {
    key: "handleCloseMemberList",
    value: function handleCloseMemberList(event) {
      if (!event.detail && this.at) {
        this.at.cancelTrigger();
      }

      this.memberListVisible = false;
    }
  }, {
    key: "handleSwitchConversation",
    value: function handleSwitchConversation() {
      this.handleCloseMemberList({});
      this.checkContentLength();
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "render",
    value: function render() {
      var _this32 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var locale = this.locale;
      return h(Fragment, null, h("iframe", {
        "class": "editor-content",
        contentEditable: "true",
        ref: function ref(el) {
          _this32.contentRef = el;
          return _this32.contentRef;
        }
      }), h("div", {
        "class": "post-btn"
      }, h("button", {
        disabled: !this.hasContent,
        onClick: this.postHandler
      }, locale.messageEdit.send)), h("member-list", {
        conversation: this.conversation,
        visible: this.memberListVisible,
        targetRect: this.targetRect,
        onSelectMember: this.handleSelectMember,
        onClose: this.handleCloseMemberList
      }));
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "value": ["validateWatchData"],
        "conversation": ["validateConversationData"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return contentEditorCss;
    }
  }]);

  return ContentEditor$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var conversationContextMenuCss = ".context-menu{font-size:2em;position:fixed;top:0;left:0;z-index:1;min-width:7em;background:#ffffff;border-radius:0.5em}.context-menu-box-shadow{-webkit-box-shadow:0px 0px 15px 3px rgb(100 102 109 / 19%);box-shadow:0px 0px 15px 3px rgb(100 102 109 / 19%)}.context-menu ul{list-style:none;margin:0;padding:0}.context-menu li{list-style:none;text-align:center;background:#fff;height:3em;line-height:3em;cursor:pointer;padding:0 1em;color:#111f2c}.context-menu li:hover,.context-menu li.hover{background:#f2f8ff}";

var ConversationContextMenu$1 = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ConversationContextMenu$1, _HTMLElement2);

  var _super4 = _createSuper(ConversationContextMenu$1);

  function ConversationContextMenu$1() {
    var _this33;

    _classCallCheck(this, ConversationContextMenu$1);

    _this33 = _super4.call(this);

    _this33.__registerHost();

    _this33.hide = createEvent(_assertThisInitialized(_this33), "hide", 7);
    _this33.topStatusChange = createEvent(_assertThisInitialized(_this33), "topStatusChange", 7);
    _this33.notificationStatusChange = createEvent(_assertThisInitialized(_this33), "notificationStatusChange", 7);
    _this33["delete"] = createEvent(_assertThisInitialized(_this33), "delete", 7);
    _this33.position = {
      top: 0,
      left: 0
    };
    _this33.visible = false;
    _this33.topStatus = false;
    _this33.notificationStatus = false;
    _this33.lang = core.lang; // 语言标识

    _this33.handleHide = _this33.handleHide.bind(_assertThisInitialized(_this33));
    _this33.topStatusChangeHandler = _this33.topStatusChangeHandler.bind(_assertThisInitialized(_this33));
    _this33.notificationStatusHandler = _this33.notificationStatusHandler.bind(_assertThisInitialized(_this33));
    _this33.deleteHandler = _this33.deleteHandler.bind(_assertThisInitialized(_this33));
    _this33.handleLanguageChanged = _this33.handleLanguageChanged.bind(_assertThisInitialized(_this33));
    return _this33;
  }

  _createClass(ConversationContextMenu$1, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      document.body.addEventListener('mouseup', this.handleHide, false);
      window.addEventListener('blur', this.handleHide, false);
      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.body.removeEventListener('mouseup', this.handleHide, false);
      window.removeEventListener('blur', this.handleHide, false);
    }
  }, {
    key: "handleHide",
    value: function handleHide(e) {
      if (e.button !== 0) {
        return;
      }

      this.hide.emit();
    }
  }, {
    key: "topStatusChangeHandler",
    value: function topStatusChangeHandler() {
      this.topStatusChange.emit(!this.topStatus);
    }
  }, {
    key: "notificationStatusHandler",
    value: function notificationStatusHandler() {
      this.notificationStatusChange.emit(!this.notificationStatus);
    }
  }, {
    key: "deleteHandler",
    value: function deleteHandler() {
      this["delete"].emit();
    }
  }, {
    key: "createCustomMenu",
    value: function createCustomMenu() {
      var _this34 = this;

      if (!this.customMenu || !this.conversation) {
        return [];
      }

      var result = [];
      this.customMenu.forEach(function (menu) {
        var name = menu.name(_this34.conversation);

        if (name) {
          result.push({
            name: name,
            callback: function callback() {
              return menu.callback(_this34.conversation);
            }
          });
        }
      });
      return result;
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "getContextMenuCalss",
    value: function getContextMenuCalss(menuNum) {
      var contextMenuBoxShadow = '';

      if (menuNum > 0) {
        contextMenuBoxShadow = 'context-menu-box-shadow';
      }

      return contextMenuBoxShadow;
    }
  }, {
    key: "getContextMenuStyle",
    value: function getContextMenuStyle(menuHeight) {
      return {
        'z-index': this.visible ? '1' : '-1',
        display: 'block',
        opacity: this.visible ? '1' : '0',
        left: "".concat(this.position ? this.position.left : 0, "px"),
        top: "".concat(this.calculateTop(menuHeight), "px")
      };
    }
  }, {
    key: "calculateTop",
    value: function calculateTop(menuHeight) {
      var clientHeight = document.documentElement.clientHeight;

      if (this.position) {
        return clientHeight - this.position.top < menuHeight ? this.position.top - menuHeight : this.position.top;
      }

      return 0;
    }
    /**
     *  计算按钮个数与高度
     * @returns
     */

  }, {
    key: "calculateMenu",
    value: function calculateMenu(customMenu) {
      var menuNum = 0;
      menuNum += customMenu.length;
      var menuHeight = 0;

      if (this.contextMenu) {
        var menuElement = this.contextMenu.childNodes[0];
        var elementLength = menuElement.children.length;

        if (elementLength > 0) {
          menuNum += elementLength;
          menuHeight = menuElement.childNodes[0].clientHeight * menuNum;
        }
      }

      return {
        menuNum: menuNum,
        menuHeight: menuHeight
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this35 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var locale = this.locale;
      var customMenu = this.createCustomMenu();

      var _this$calculateMenu = this.calculateMenu(customMenu),
          menuNum = _this$calculateMenu.menuNum,
          menuHeight = _this$calculateMenu.menuHeight;

      return h("div", {
        "class": "".concat(this.getContextMenuCalss(menuNum), " context-menu"),
        style: this.getContextMenuStyle(menuHeight),
        ref: function ref(el) {
          _this35.contextMenu = el;
          return _this35.contextMenu;
        }
      }, h("ul", null, !this.disableMenu.includes(DisabledConversationontextMenu.Top) ? h("li", {
        onClick: this.topStatusChangeHandler
      }, this.topStatus ? locale.conversation.top : locale.conversation.noTop) : null, !this.disableMenu.includes(DisabledConversationontextMenu.Notification) ? h("li", {
        onClick: this.notificationStatusHandler
      }, this.notificationStatus ? locale.conversation.inform : locale.conversation.noInform) : null, !this.disableMenu.includes(DisabledConversationontextMenu.Delete) ? h("li", {
        onClick: this.deleteHandler
      }, locale.conversation["delete"]) : null, customMenu.map(function (menu) {
        return h("li", {
          key: "".concat(_this35.conversation.targetId, "_").concat(menu.name),
          onClick: menu.callback
        }, menu.name);
      })));
    }
  }], [{
    key: "style",
    get: function get() {
      return conversationContextMenuCss;
    }
  }]);

  return ConversationContextMenu$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var fileHeader = {
  '/9j': {
    type: 'image',
    suffix: 'JPG'
  },
  iVB: {
    type: 'image',
    suffix: 'PNG'
  },
  Qk0: {
    type: 'image',
    suffix: 'BMP'
  },
  SUk: {
    type: 'image',
    suffix: 'TIFF'
  },
  JVB: {
    type: 'image',
    suffix: 'PDF'
  },
  UEs: {
    type: 'image',
    suffix: 'OFD'
  },
  IyF: {
    type: 'audio',
    suffix: 'AMR'
  }
};
/**
 * 根据base64的前三个字符判断文件格式
 * @param base64
 * @returns base64 string
 */

function addBase64head(base64, errotBase64Str) {
  if (!isString(base64)) {
    return errotBase64Str || '';
  }

  if (base64.startsWith('data:/') || base64.startsWith('http')) {
    return base64;
  }

  var head = base64.substr(0, 3);

  if (fileHeader[head]) {
    return "data:".concat(fileHeader[head].type, "/").concat(fileHeader[head].suffix.toLowerCase(), ";base64,").concat(base64);
  } // 直接返回


  return base64;
}

function judgeDay(sourceDate) {
  var targetDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var year = sourceDate.getFullYear();
  var month = sourceDate.getMonth() + 1;
  var day = sourceDate.getDate();
  var d1 = new Date("".concat(year, "/").concat(month, "/").concat(day)).getTime();
  var y = targetDate.getFullYear();
  var m = targetDate.getMonth() + 1;
  var d = targetDate.getDate();
  var d2 = new Date("".concat(y, "/").concat(m, "/").concat(d)).getTime();
  var iday = (d1 - d2) / 1000 / 60 / 60 / 24;
  return iday;
} // 格式化时间


function formatTime(time, f, locale) {
  if (!time) {
    return null;
  }

  var date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = "".concat(date.getHours());

  if (hour.length < 2) {
    hour = "0".concat(hour);
  }

  var minute = "".concat(date.getMinutes());

  if (minute.length < 2) {
    minute = "0".concat(minute);
  }

  var now = new Date();
  var dValue = judgeDay(date);

  if (dValue === -1) {
    var yesterday = locale.conversation.yesterday;
    return "".concat(yesterday);
  }

  if (now.getFullYear() === year) {
    if (now.toDateString() === date.toDateString()) {
      return "".concat(hour, ":").concat(minute);
    }

    return "".concat(month, "/").concat(day);
  }

  return locale.area === 'zh_CN' ? "".concat(year, "/").concat(month, "/").concat(day) : "".concat(month, "/").concat(day, "/").concat(year);
}

function delHtmlTag(str) {
  // 正则去掉所有的html标记
  return str.replace(/<[^>]+>/g, '');
}

function deepClone(target) {
  var result;

  if (_typeof(target) === 'object') {
    if (Array.isArray(target)) {
      result = [];
      Object.keys(target).forEach(function (i) {
        result.push(deepClone(target[i]));
      });
    } else if (target === null) {
      result = null;
    } else if (target instanceof RegExp) {
      result = target;
    } else {
      result = {};
      Object.keys(target).forEach(function (i) {
        result[i] = deepClone(target[i]);
      });
    }
  } else {
    result = target;
  }

  return result;
}

function formatTextMessage(content) {
  var TextMessageContent = content;

  if (!isString(TextMessageContent)) {
    TextMessageContent = '';
  } // eslint-disable-next-line max-len


  var urlReg = /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/g; // 简单的过滤

  TextMessageContent = TextMessageContent.replace('<', '&lt;');
  TextMessageContent = TextMessageContent.replace('>', '&gt;');

  if (urlReg.test(TextMessageContent)) {
    TextMessageContent = TextMessageContent.replace(urlReg, function (a) {
      var prefix = '';

      if (a.indexOf('http:') < 0 && a.indexOf('https:') < 0) {
        prefix = '//';
      }

      return "<a target=\"_blank\" class=\"url-wrap\" href=\"".concat(prefix).concat(a, "\">").concat(a, "</a>");
    });
  }

  return TextMessageContent;
}
/**
 * 检查参数是否为字符串
 * 只做类型检查，不做长度检查，故当字符串长度为 0，结果依然为 true
 * @param value
 */


var isString = function isString(value) {
  return typeof value === 'string';
};

var conversationItemCss = ".conversation-item.top-item::after{content:\" \";display:block;width:0;height:0;border-top:2em solid #4790ee;border-right:2em solid transparent;position:absolute;left:0;top:0}.conversation-item{height:10.4em;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:0 2em 0 2em;position:relative;text-align:left}.conversation-item:hover{background:#f3f3f3}.conversation-item.hover{background:#f1f1f1}.conversation-item .user-avatar{width:6.4em;height:6.4em;margin:0 2em 0 0;position:relative}.avatar-image{background:#4790ee;border-radius:50%;width:6.4em;height:6.4em;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.conversation-item .user-avatar img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.conversation-item .user-avatar .message-count{position:absolute;right:0;top:0;height:2em;line-height:2em;background-color:#ff4141;color:#fff;border-radius:1em;text-align:center;font-size:1.1em;min-width:2em;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 0.6em}.conversation-info{-ms-flex-positive:1;flex-grow:1;width:calc(100% - 10em)}.info-block{-ms-flex-positive:0;flex-grow:0;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;margin:0 0 0.6em;width:100%}.info-block:last-child{margin:0}.user-name{font-size:2.2em;font-weight:400;color:#111f2c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:49%}.latest-message{color:#a0a5ab;font-size:1.6em;line-height:1.6em;width:calc(100% - 2.2em);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.latest-message>div{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center;font-size:1.25em;line-height:1.25em}.latest-message>div .ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;width:100%}.latest-message-ellipsis{width:100%}.last-time{color:#c7cbce;height:1.3333em;line-height:1.3333em;text-align:right;font-size:1.8em}.notification{height:2em;line-height:2em}.notification span{width:2em;height:2em;display:inline-block}.notification .disable{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjdweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjcgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5YWN5omT5omwPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAxX+S8muivneWIl+ihqOamguiniCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwMS4wMDAwMDAsIC02MzguMDAwMDAwKSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IuWFjeaJk+aJsCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDAxLjQwMDAwMCwgNjM4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgeD0iMCIgeT0iMCIgd2lkdGg9IjI2IiBoZWlnaHQ9IjI2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNy4zMTI1LDEyLjQ2ODUgTDE3LjYxOTUsMTguNjg3NSBMMTguNjg3NSwxOC42ODc1IEMxOS41ODQ5NjI3LDE4LjY4NzUgMjAuMzEyNSwxOS40MTUwMzczIDIwLjMxMjUsMjAuMzEyNSBDMjAuMzEyNSwyMS4yMDk5NjI3IDE5LjU4NDk2MjcsMjEuOTM3NSAxOC42ODc1LDIxLjkzNzUgTDYuNSwyMS45Mzc1IEM1LjYwMjUzNzI4LDIxLjkzNzUgNC44NzUsMjEuMjA5OTYyNyA0Ljg3NSwyMC4zMTI1IEM0Ljg3NSwxOS40MTUwMzczIDUuNjAyNTM3MjgsMTguNjg3NSA2LjUsMTguNjg3NSBMNy4zMTI1LDE4LjY4NzUgTDcuMzEyNSwxMi40Njg1IFogTTEyLjU5Mzc1LDQuMDYyNSBDMTMuMjY2ODQ3LDQuMDYyNSAxMy44MTI1LDQuNjA4MTUyOTYgMTMuODEyNSw1LjI4MTI1IEwxMy44MTI5ODE0LDUuODI4OTMzMzYgQzE2LjE0MTkzMjYsNi4zNzkzMDM1MyAxNy44NzUsOC40NzE2MzY5NyAxNy44NzUsMTAuOTY4NzUgTDE3Ljg3Mzk1NTQsMTQuOTYwNSBMMjIuMDU1OTU1NCwxNy40MjI1MjIxIEwyMS4yMjExOTk5LDE4Ljg5NjgyNzMgTDQuMTgwOTU1NDMsOC44NjQ5Mzk1MSBMNS4wMTU3MTA5Miw3LjM5MDYzNDM2IEw3LjcwMjgwMTc2LDguOTcyNTIwMjggQzguMzQwNzUxODksNy40MTEwOTUyMiA5LjcwNDY4NjA3LDYuMjIzMzQ3OTMgMTEuMzc1MDgyNiw1LjgyODgwMDExIEwxMS4zNzUsNS4yODEyNSBDMTEuMzc1LDQuNjA4MTUyOTYgMTEuOTIwNjUzLDQuMDYyNSAxMi41OTM3NSw0LjA2MjUgWiIgaWQ9IuW9oueKtue7k+WQiCIgZmlsbD0iI0QxRDFEMSI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=);background-repeat:no-repeat;background-size:contain}.latest-message .fail{}.latest-message .sending::before,.latest-message .fail::before{content:\" \";display:inline-block;background-size:contain;background-repeat:no-repeat;vertical-align:middle;width:1.3em;height:1.3em;margin:0 0.2em 0 0}.latest-message .sending::before{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjdweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjcgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5q2j5Zyo5Y+R6YCBPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAyX+WNleiBii3ljZXogYrlkJHkuIrmu5rliqjml7YtbG9hZGluZyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNC4wMDAwMDAsIC01MzQuMDAwMDAwKSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hOWkh+S7vS00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjQwMDAwMCwgNDc1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Iuato+WcqOWPkemAgSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA0LjAwMDAwMCwgNTkuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgeD0iMCIgeT0iMCIgd2lkdGg9IjI2IiBoZWlnaHQ9IjI2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0yNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDQuMDAwMDAwKSIgZmlsbD0iI0Q4RDhEOCI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05Ljg1NzE0Mjg2LDAgTDkuODU3MTQyODYsNC45MDkwOTA5MSBMMTUuNjA3MTQyOSw0LjkwOTA5MDkxIEwxNS42MDcxNDI5LDEzLjkwOTA5MDkgTDkuODU3MTQyODYsMTMuOTA5MDkwOSBMOS44NTcxNDI4NiwxOCBMMCw5LjAyNzU5MzU1IEw5Ljg1NzE0Mjg2LDAgWiBNMTkuNzE0Mjg1Nyw0LjkwOTA5MDkxIEwxOS43MTQyODU3LDEzLjkwOTA5MDkgTDE3LjI1LDEzLjkwOTA5MDkgTDE3LjI1LDQuOTA5MDkwOTEgTDE5LjcxNDI4NTcsNC45MDkwOTA5MSBaIE0yMyw0LjkwOTA5MDkxIEwyMywxMy45MDkwOTA5IEwyMS4zNTcxNDI5LDEzLjkwOTA5MDkgTDIxLjM1NzE0MjksNC45MDkwOTA5MSBMMjMsNC45MDkwOTA5MSBaIiBpZD0i5b2i54q257uT5ZCIIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}.latest-message .fail::before{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjUgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5oSf5Y+55Y+3PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAyX+WNleiBii3ljZXogYrlkJHkuIrmu5rliqjml7YtbG9hZGluZyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNC4wMDAwMDAsIC02MzkuMDAwMDAwKSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IuaEn+WPueWPtyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA0LjQwMDAwMCwgNjM5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uELTI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUwMDAwMCwgMS41MDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiNGRjQxNDEiIGN4PSIxMC41IiBjeT0iMTAuNSIgcj0iMTAuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgZmlsbD0iI0ZGRkZGRiIgeD0iOS43NSIgeT0iNS4yNSIgd2lkdGg9IjEuNSIgaGVpZ2h0PSI3LjUiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiNGRkZGRkYiIGN4PSIxMC41IiBjeT0iMTUiIHI9IjEiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}.mentioned{color:red}.latest-message i{font-style:normal}";

var ConversationItem$1 = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(ConversationItem$1, _HTMLElement3);

  var _super5 = _createSuper(ConversationItem$1);

  function ConversationItem$1() {
    var _this36;

    _classCallCheck(this, ConversationItem$1);

    _this36 = _super5.call(this);

    _this36.__registerHost();

    _this36.selectConversation = createEvent(_assertThisInitialized(_this36), "selectConversation", 7);
    _this36.isHover = false;
    _this36.draft = '';
    _this36.lang = core.lang; // 语言标识先取本地存储

    _this36.getStyleClass = function (message) {
      var styleClass = '';

      if (message.messageDirection === MessageDirection$1.SEND) {
        if (message.messageUId.startsWith('fail_')) {
          // 发送失败
          styleClass = 'fail';
        }

        if (message.messageUId.startsWith('sending_')) {
          // 正在发送
          styleClass = 'sending';
        }
      }

      return styleClass;
    };

    _this36.getMessageContent = function (message, locale) {
      var messageContent = ''; // 统一处理最后一条消息展示为 【XXX】格式的消息类型

      var messageTypeList = {
        'RC:ImgMsg': "[".concat(locale.conversation.img, "]"),
        'RC:FileMsg': "[".concat(locale.conversation.file, "]"),
        'RC:SightMsg': "[".concat(locale.conversation.video, "]"),
        'RC:HQVCMsg': "[".concat(locale.conversation.audio, "]"),
        'RC:ReferenceMsg': "[".concat(locale.conversation.quote, "]"),
        'RC:LBSMsg': "[".concat(locale.conversation.location, "]")
      };

      if (messageTypeList[message.messageType]) {
        messageContent = messageTypeList[message.messageType];
      }

      switch (message.messageType) {
        case MessageType$1.TEXT:
          messageContent = message.content.content;
          break;

        case MessageType$1.RECALL_MESSAGE_TYPE:
          messageContent = _this36.getRecallMessageContent(message, locale);
          break;

        case 'RC:GrpNtf':
          messageContent = setGroupNtfContent(locale, message.content);
          break;

        case 'RC:InfoNtf':
          messageContent = message.content.message;
          break;

        default:
          if (core.isCustomLastMessage(message)) {
            messageContent = core.createCustomLastMessageDom(message) ? core.createCustomLastMessageDom(message) : '';
          }

      }

      return messageContent;
    };

    _this36.selectHandler = _this36.selectHandler.bind(_assertThisInitialized(_this36));
    _this36.handleSwitchConversation = _this36.handleSwitchConversation.bind(_assertThisInitialized(_this36));
    _this36.handleLanguageChanged = _this36.handleLanguageChanged.bind(_assertThisInitialized(_this36));
    _this36.handleInfoChanged = _this36.handleInfoChanged.bind(_assertThisInitialized(_this36));
    return _this36;
  }

  _createClass(ConversationItem$1, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.on(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.on(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleInfoChanged);
      core.on(CoreEvent.GROUP_INFO_CHANGED, this.handleInfoChanged);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      core.off(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.on(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.off(CoreEvent.GROUP_INFO_CHANGED, this.handleInfoChanged);
      core.off(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleInfoChanged);
    }
  }, {
    key: "handleSwitchConversation",
    value: function handleSwitchConversation() {
      var _this37 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;

      if (core.currentConversation && isEqual(core.currentConversation, this.data.conversation)) {
        this.draft = '';
      } else {
        // 防止切换用户时，初始化成功就调用草稿导致报错
        var status = getConnectionStatus();
        if (status !== RCConnectionStatus.CONNECTED) return;
        getTextMessageDraft(this.data.conversation).then(function (result) {
          if (result.code === 0) {
            if (result.data) {
              var div = document.createElement('div');
              div.innerHTML = result.data;
              var draft = "[".concat(_this37.locale.conversation.draft, "]");
              _this37.draft = h("span", null, h("i", {
                style: {
                  color: 'red'
                }
              }, draft, ' '), ' ', div.innerText);
              return;
            }
          }

          _this37.draft = '';
        });
      }
    }
  }, {
    key: "handleInfoChanged",
    value: function handleInfoChanged() {
      var message = this.data.conversation.latestMessage || null;

      if (message && message.messageType === MessageType$1.RECALL_MESSAGE_TYPE) {
        this.getProfile(message);
      }
    }
  }, {
    key: "getProfile",
    value: function getProfile(message) {
      var recall = this.locale.conversation.recall;
      var isSendUser = message.messageDirection === MessageDirection$1.SEND;

      if (message.conversationType === ConversationType$1.PRIVATE && !isSendUser) {
        this.getConversationProfile(message, recall);
      } else if (message.conversationType === ConversationType$1.GROUP) {
        this.getGroupMemberProfile(message, recall, isSendUser);
      }
    }
  }, {
    key: "getConversationProfile",
    value: function getConversationProfile(message, recall) {
      var _this38 = this;

      core.getConversationProfile({
        targetId: message.targetId,
        conversationType: ConversationType$1.PRIVATE,
        channelId: message.channelId
      }).then(function (res) {
        var prefix = res ? res.name : message.senderUserId;
        _this38.nameRef.innerText = "".concat(prefix, " ").concat(recall);
      });
    }
  }, {
    key: "getGroupMemberProfile",
    value: function getGroupMemberProfile(message, recall, isSendUser) {
      var _this39 = this;

      var prefix = '';
      core.getGroupMemberProfile({
        targetId: message.targetId,
        conversationType: ConversationType$1.GROUP,
        channelId: message.channelId
      }, message.senderUserId).then(function (res) {
        if (!isSendUser) {
          prefix = res ? res.groupNickname || res.name || message.senderUserId : message.senderUserId;
        }

        _this39.nameRef.innerText = "".concat(prefix, " ").concat(recall);
      });
    }
  }, {
    key: "getRecallMessageContent",
    value: function getRecallMessageContent(message, locale) {
      var isSendUser;
      var prefix;
      var recall = locale.conversation.recall;
      var you = locale.conversation.you;
      isSendUser = message.messageDirection === MessageDirection$1.SEND;
      prefix = isSendUser ? you : '';
      this.getProfile(message);
      return prefix + recall;
    }
  }, {
    key: "getLatestMessage",
    value: function getLatestMessage(message, locale) {
      var _this40 = this;

      if (!message) {
        return '';
      }

      var mentionedInfo = ''; // 未读数不为 0，并且不是当前会话才展示 @ 信息

      var isShowAtMe = this.data.conversation.unreadMessageCount !== 0 && (!core.currentConversation || !isEqual(core.currentConversation, this.data.conversation));

      if (isShowAtMe && this.data.conversation.hasMentioned) {
        var atMe = "[".concat(locale.conversation.atMe, "]");
        mentionedInfo = h("span", {
          "class": "mentioned"
        }, atMe);
      }

      var styleClass = this.getStyleClass(message);
      var receivedStatus = "[".concat(locale.conversation.unread, "]"); // 发送状态判断, 增加获取本地会话已读未读时间判断

      var unReadTime = core.getUnReadTime({
        conversationType: message.conversationType,
        targetId: message.targetId,
        channelId: message.channelId
      });

      if (message.messageDirection === MessageDirection$1.SEND && message.conversationType === ConversationType$1.PRIVATE && message.messageType !== 'polyfill' && message.sentTime <= unReadTime && message.receivedStatus !== ReceivedStatus$1.UNREAD) {
        receivedStatus = "[".concat(locale.conversation.read, "]");
      }

      var messageContent = this.getMessageContent(message, locale);

      if (!isString(messageContent)) {
        messageContent = '';
        core.logger.info(LogTagId.A_KIT_MESSAGE_E, JSON.stringify({
          msg: 'Message structure parsing exception ',
          message: message
        }));
      } // 去掉换行格式


      messageContent = messageContent.replace(/[\r\n]/g, '');

      if (this.nameRef) {
        this.nameRef.innerText = " ".concat(messageContent);
      }

      return h("div", {
        "class": "".concat(styleClass, " latest-message-ellipsis")
      }, h("span", {
        "class": "ellipsis"
      }, mentionedInfo, message.conversationType === ConversationType$1.PRIVATE && message.messageDirection === MessageDirection$1.SEND && message.messageType !== MessageType$1.RECALL_MESSAGE_TYPE ? receivedStatus : '', h("span", {
        ref: function ref(el) {
          _this40.nameRef = el;
          return _this40.nameRef;
        }
      }, " ".concat(messageContent))));
    }
  }, {
    key: "selectHandler",
    value: function selectHandler(e) {
      if (e.button === 2) {
        return;
      }

      core.logger.info(LogTagId.A_KIT_SELECT_HANDLER_O, JSON.stringify({
        tag: 'selectHandler',
        data: {
          conversationType: this.data.conversation.conversationType,
          targetId: this.data.conversation.targetId,
          channelId: this.data.conversation.channelId
        }
      }));
      this.selectConversation.emit({
        conversationType: this.data.conversation.conversationType,
        targetId: this.data.conversation.targetId,
        channelId: this.data.conversation.channelId
      });
    }
  }, {
    key: "conversationFormatTime",
    value: function conversationFormatTime(lastMessage, locale) {
      if (!lastMessage) {
        return null;
      }

      return formatTime(lastMessage.sentTime, {
        hour: ':',
        minute: ''
      }, locale);
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
      this.handleSwitchConversation();
    }
  }, {
    key: "render",
    value: function render() {
      var _data$profile, _data$profile2, _data$profile3;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var data = this.data,
          isHover = this.isHover,
          locale = this.locale;
      return h("div", {
        "class": "conversation-item ".concat(data.conversation.isTop ? 'top-item' : 'untop-item').concat(isHover ? ' hover' : ''),
        key: "".concat(data.conversation.targetId, "&&").concat(data.conversation.conversationType, "&&").concat(data.conversation.channelId),
        onClick: this.selectHandler
      }, h("div", {
        "class": "user-avatar"
      }, h("div", {
        "class": "avatar-image"
      }, (_data$profile = data.profile) !== null && _data$profile !== void 0 && _data$profile.portraitUri ? h("img", {
        src: data.profile.portraitUri
      }) : null), data.conversation.unreadMessageCount ? h("span", {
        "class": "message-count"
      }, data.conversation.notificationStatus === NotificationStatus.OPEN && this.hideNotificUnreadCount ? '' : data.conversation.unreadMessageCount) : null), h("div", {
        "class": "conversation-info"
      }, h("div", {
        "class": "info-block"
      }, h("div", {
        "class": "user-name"
      }, h("span", null, (_data$profile2 = data.profile) !== null && _data$profile2 !== void 0 && _data$profile2.name ? (_data$profile3 = data.profile) === null || _data$profile3 === void 0 ? void 0 : _data$profile3.name : data.conversation.targetId)), h("div", {
        "class": "last-time"
      }, this.conversationFormatTime(data.conversation.latestMessage, locale))), h("div", {
        "class": "info-block"
      }, h("div", {
        "class": "latest-message"
      }, h("div", null, this.draft ? this.draft : this.getLatestMessage(data.conversation.latestMessage, locale))), h("div", {
        "class": "notification"
      }, data.conversation.notificationStatus === NotificationStatus.OPEN ? h("span", {
        "class": "disable"
      }) : null))));
    }
  }], [{
    key: "style",
    get: function get() {
      return conversationItemCss;
    }
  }]);

  return ConversationItem$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
/*!
 * better-scroll / core
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

var propertiesConfig$2 = [{
  sourceKey: 'scroller.scrollBehaviorX.currentPos',
  key: 'x'
}, {
  sourceKey: 'scroller.scrollBehaviorY.currentPos',
  key: 'y'
}, {
  sourceKey: 'scroller.scrollBehaviorX.hasScroll',
  key: 'hasHorizontalScroll'
}, {
  sourceKey: 'scroller.scrollBehaviorY.hasScroll',
  key: 'hasVerticalScroll'
}, {
  sourceKey: 'scroller.scrollBehaviorX.contentSize',
  key: 'scrollerWidth'
}, {
  sourceKey: 'scroller.scrollBehaviorY.contentSize',
  key: 'scrollerHeight'
}, {
  sourceKey: 'scroller.scrollBehaviorX.maxScrollPos',
  key: 'maxScrollX'
}, {
  sourceKey: 'scroller.scrollBehaviorY.maxScrollPos',
  key: 'maxScrollY'
}, {
  sourceKey: 'scroller.scrollBehaviorX.minScrollPos',
  key: 'minScrollX'
}, {
  sourceKey: 'scroller.scrollBehaviorY.minScrollPos',
  key: 'minScrollY'
}, {
  sourceKey: 'scroller.scrollBehaviorX.movingDirection',
  key: 'movingDirectionX'
}, {
  sourceKey: 'scroller.scrollBehaviorY.movingDirection',
  key: 'movingDirectionY'
}, {
  sourceKey: 'scroller.scrollBehaviorX.direction',
  key: 'directionX'
}, {
  sourceKey: 'scroller.scrollBehaviorY.direction',
  key: 'directionY'
}, {
  sourceKey: 'scroller.actions.enabled',
  key: 'enabled'
}, {
  sourceKey: 'scroller.animater.pending',
  key: 'pending'
}, {
  sourceKey: 'scroller.animater.stop',
  key: 'stop'
}, {
  sourceKey: 'scroller.scrollTo',
  key: 'scrollTo'
}, {
  sourceKey: 'scroller.scrollBy',
  key: 'scrollBy'
}, {
  sourceKey: 'scroller.scrollToElement',
  key: 'scrollToElement'
}, {
  sourceKey: 'scroller.resetPosition',
  key: 'resetPosition'
}];

function warn$1(msg) {
  console.error("[BScroll warn]: " + msg);
} // ssr support


var inBrowser$3 = typeof window !== 'undefined';
var ua$3 = inBrowser$3 && navigator.userAgent.toLowerCase();
var isWeChatDevTools = !!(ua$3 && /wechatdevtools/.test(ua$3));
var isAndroid = ua$3 && ua$3.indexOf('android') > 0;
/* istanbul ignore next */

var isIOSBadVersion = function () {
  if (typeof ua$3 === 'string') {
    var regex = /os (\d\d?_\d(_\d)?)/;
    var matches = regex.exec(ua$3);
    if (!matches) return false;
    var parts = matches[1].split('_').map(function (item) {
      return parseInt(item, 10);
    }); // ios version >= 13.4 issue 982

    return !!(parts[0] === 13 && parts[1] >= 4);
  }

  return false;
}();
/* istanbul ignore next */


var supportsPassive$1 = false;
/* istanbul ignore next */

if (inBrowser$3) {
  var EventName$3 = 'test-passive';

  try {
    var opts$3 = {};
    Object.defineProperty(opts$3, 'passive', {
      get: function get() {
        supportsPassive$1 = true;
      }
    }); // https://github.com/facebook/flow/issues/285

    window.addEventListener(EventName$3, function () {}, opts$3);
  } catch (e) {}
}

function getNow() {
  return window.performance && window.performance.now && window.performance.timing ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
}

var extend$3 = function extend$3(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
};

function isUndef(v) {
  return v === undefined || v === null;
}

function between(x, min, max) {
  if (x < min) {
    return min;
  }

  if (x > max) {
    return max;
  }

  return x;
}

var elementStyle$3 = inBrowser$3 && document.createElement('div').style;

var vendor$3 = function () {
  /* istanbul ignore if  */
  if (!inBrowser$3) {
    return false;
  }

  var transformNames = [{
    key: 'standard',
    value: 'transform'
  }, {
    key: 'webkit',
    value: 'webkitTransform'
  }, {
    key: 'Moz',
    value: 'MozTransform'
  }, {
    key: 'O',
    value: 'OTransform'
  }, {
    key: 'ms',
    value: 'msTransform'
  }];

  for (var _i = 0, transformNames_1 = transformNames; _i < transformNames_1.length; _i++) {
    var obj = transformNames_1[_i];

    if (elementStyle$3[obj.value] !== undefined) {
      return obj.key;
    }
  }
  /* istanbul ignore next  */


  return false;
}();
/* istanbul ignore next  */


function prefixStyle$3(style) {
  if (vendor$3 === false) {
    return style;
  }

  if (vendor$3 === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }

    return style;
  }

  return vendor$3 + style.charAt(0).toUpperCase() + style.substr(1);
}

function getElement(el) {
  return typeof el === 'string' ? document.querySelector(el) : el;
}

function addEvent$1(el, type, fn, capture) {
  var useCapture = supportsPassive$1 ? {
    passive: false,
    capture: !!capture
  } : !!capture;
  el.addEventListener(type, fn, useCapture);
}

function removeEvent$1(el, type, fn, capture) {
  el.removeEventListener(type, fn, {
    capture: !!capture
  });
}

function offset(el) {
  var left = 0;
  var top = 0;

  while (el) {
    left -= el.offsetLeft;
    top -= el.offsetTop;
    el = el.offsetParent;
  }

  return {
    left: left,
    top: top
  };
}

vendor$3 && vendor$3 !== 'standard' ? '-' + vendor$3.toLowerCase() + '-' : '';
var transform$3 = prefixStyle$3('transform');
var transition$3 = prefixStyle$3('transition');
var hasPerspective = inBrowser$3 && prefixStyle$3('perspective') in elementStyle$3; // fix issue #361

var hasTouch = inBrowser$3 && ('ontouchstart' in window || isWeChatDevTools);
var hasTransition = inBrowser$3 && transition$3 in elementStyle$3;
var style = {
  transform: transform$3,
  transition: transition$3,
  transitionTimingFunction: prefixStyle$3('transitionTimingFunction'),
  transitionDuration: prefixStyle$3('transitionDuration'),
  transitionDelay: prefixStyle$3('transitionDelay'),
  transformOrigin: prefixStyle$3('transformOrigin'),
  transitionEnd: prefixStyle$3('transitionEnd'),
  transitionProperty: prefixStyle$3('transitionProperty')
};
var eventTypeMap$1 = {
  touchstart: 1,
  touchmove: 1,
  touchend: 1,
  touchcancel: 1,
  mousedown: 2,
  mousemove: 2,
  mouseup: 2
};

function getRect(el) {
  /* istanbul ignore if  */
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

function preventDefaultExceptionFn$2(el, exceptions) {
  for (var i in exceptions) {
    if (exceptions[i].test(el[i])) {
      return true;
    }
  }

  return false;
}

var tagExceptionFn$1 = preventDefaultExceptionFn$2;

function tap(e, eventName) {
  var ev = document.createEvent('Event');
  ev.initEvent(eventName, true, true);
  ev.pageX = e.pageX;
  ev.pageY = e.pageY;
  e.target.dispatchEvent(ev);
}

function click(e, event) {
  if (event === void 0) {
    event = 'click';
  }

  var eventSource;

  if (e.type === 'mouseup') {
    eventSource = e;
  } else if (e.type === 'touchend' || e.type === 'touchcancel') {
    eventSource = e.changedTouches[0];
  }

  var posSrc = {};

  if (eventSource) {
    posSrc.screenX = eventSource.screenX || 0;
    posSrc.screenY = eventSource.screenY || 0;
    posSrc.clientX = eventSource.clientX || 0;
    posSrc.clientY = eventSource.clientY || 0;
  }

  var ev;
  var bubbles = true;
  var cancelable = true;
  var ctrlKey = e.ctrlKey,
      shiftKey = e.shiftKey,
      altKey = e.altKey,
      metaKey = e.metaKey;
  var pressedKeysMap = {
    ctrlKey: ctrlKey,
    shiftKey: shiftKey,
    altKey: altKey,
    metaKey: metaKey
  };

  if (typeof MouseEvent !== 'undefined') {
    try {
      ev = new MouseEvent(event, extend$3(_assign({
        bubbles: bubbles,
        cancelable: cancelable
      }, pressedKeysMap), posSrc));
    } catch (e) {
      /* istanbul ignore next */
      createEvent();
    }
  } else {
    createEvent();
  }

  function createEvent() {
    ev = document.createEvent('Event');
    ev.initEvent(event, bubbles, cancelable);
    extend$3(ev, posSrc);
  } // forwardedTouchEvent set to true in case of the conflict with fastclick


  ev.forwardedTouchEvent = true;
  ev._constructed = true;
  e.target.dispatchEvent(ev);
}

function dblclick(e) {
  click(e, 'dblclick');
}

var ease$1 = {
  // easeOutQuint
  swipe: {
    style: 'cubic-bezier(0.23, 1, 0.32, 1)',
    fn: function fn(t) {
      return 1 + --t * t * t * t * t;
    }
  },
  // easeOutQuard
  swipeBounce: {
    style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    fn: function fn(t) {
      return t * (2 - t);
    }
  },
  // easeOutQuart
  bounce: {
    style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    fn: function fn(t) {
      return 1 - --t * t * t * t;
    }
  }
};
var DEFAULT_INTERVAL = 1000 / 60;
var windowCompat = inBrowser$3 && window;
/* istanbul ignore next */

function noop$1() {}

var requestAnimationFrame = function () {
  /* istanbul ignore if  */
  if (!inBrowser$3) {
    return noop$1;
  }

  return windowCompat.requestAnimationFrame || windowCompat.webkitRequestAnimationFrame || windowCompat.mozRequestAnimationFrame || windowCompat.oRequestAnimationFrame || // if all else fails, use setTimeout
  function (callback) {
    return window.setTimeout(callback, callback.interval || DEFAULT_INTERVAL); // make interval as precise as possible.
  };
}();

var cancelAnimationFrame = function () {
  /* istanbul ignore if  */
  if (!inBrowser$3) {
    return noop$1;
  }

  return windowCompat.cancelAnimationFrame || windowCompat.webkitCancelAnimationFrame || windowCompat.mozCancelAnimationFrame || windowCompat.oCancelAnimationFrame || function (id) {
    window.clearTimeout(id);
  };
}();
/* istanbul ignore next */


var noop = function noop(val) {};

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

var getProperty = function getProperty(obj, key) {
  var keys = key.split('.');

  for (var i = 0; i < keys.length - 1; i++) {
    obj = obj[keys[i]];
    if (_typeof(obj) !== 'object' || !obj) return;
  }

  var lastKey = keys.pop();

  if (typeof obj[lastKey] === 'function') {
    return function () {
      return obj[lastKey].apply(obj, arguments);
    };
  } else {
    return obj[lastKey];
  }
};

var setProperty = function setProperty(obj, key, value) {
  var keys = key.split('.');
  var temp;

  for (var i = 0; i < keys.length - 1; i++) {
    temp = keys[i];
    if (!obj[temp]) obj[temp] = {};
    obj = obj[temp];
  }

  obj[keys.pop()] = value;
};

function propertiesProxy(target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter() {
    return getProperty(this, sourceKey);
  };

  sharedPropertyDefinition.set = function proxySetter(val) {
    setProperty(this, sourceKey, val);
  };

  Object.defineProperty(target, key, sharedPropertyDefinition);
}

var EventEmitter =
/** @class */
function () {
  function EventEmitter(names) {
    this.events = {};
    this.eventTypes = {};
    this.registerType(names);
  }

  EventEmitter.prototype.on = function (type, fn, context) {
    if (context === void 0) {
      context = this;
    }

    this.hasType(type);

    if (!this.events[type]) {
      this.events[type] = [];
    }

    this.events[type].push([fn, context]);
    return this;
  };

  EventEmitter.prototype.once = function (type, fn, context) {
    var _this = this;

    if (context === void 0) {
      context = this;
    }

    this.hasType(type);

    var magic = function magic() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      _this.off(type, magic);

      var ret = fn.apply(context, args);

      if (ret === true) {
        return ret;
      }
    };

    magic.fn = fn;
    this.on(type, magic);
    return this;
  };

  EventEmitter.prototype.off = function (type, fn) {
    if (!type && !fn) {
      this.events = {};
      return this;
    }

    if (type) {
      this.hasType(type);

      if (!fn) {
        this.events[type] = [];
        return this;
      }

      var events = this.events[type];

      if (!events) {
        return this;
      }

      var count = events.length;

      while (count--) {
        if (events[count][0] === fn || events[count][0] && events[count][0].fn === fn) {
          events.splice(count, 1);
        }
      }

      return this;
    }
  };

  EventEmitter.prototype.trigger = function (type) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    this.hasType(type);
    var events = this.events[type];

    if (!events) {
      return;
    }

    var len = events.length;

    var eventsCopy = __spreadArrays(events);

    var ret;

    for (var i = 0; i < len; i++) {
      var event_1 = eventsCopy[i];
      var fn = event_1[0],
          context = event_1[1];

      if (fn) {
        ret = fn.apply(context, args);

        if (ret === true) {
          return ret;
        }
      }
    }
  };

  EventEmitter.prototype.registerType = function (names) {
    var _this = this;

    names.forEach(function (type) {
      _this.eventTypes[type] = type;
    });
  };

  EventEmitter.prototype.destroy = function () {
    this.events = {};
    this.eventTypes = {};
  };

  EventEmitter.prototype.hasType = function (type) {
    var types = this.eventTypes;
    var isType = types[type] === type;

    if (!isType) {
      warn$1("EventEmitter has used unknown event type: \"" + type + "\", should be oneof [" + ("" + Object.keys(types).map(function (_) {
        return JSON.stringify(_);
      })) + "]");
    }
  };

  return EventEmitter;
}();

var EventRegister$1 =
/** @class */
function () {
  function EventRegister(wrapper, events) {
    this.wrapper = wrapper;
    this.events = events;
    this.addDOMEvents();
  }

  EventRegister.prototype.destroy = function () {
    this.removeDOMEvents();
    this.events = [];
  };

  EventRegister.prototype.addDOMEvents = function () {
    this.handleDOMEvents(addEvent$1);
  };

  EventRegister.prototype.removeDOMEvents = function () {
    this.handleDOMEvents(removeEvent$1);
  };

  EventRegister.prototype.handleDOMEvents = function (eventOperation) {
    var _this = this;

    var wrapper = this.wrapper;
    this.events.forEach(function (event) {
      eventOperation(wrapper, event.name, _this, !!event.capture);
    });
  };

  EventRegister.prototype.handleEvent = function (e) {
    var eventType = e.type;
    this.events.some(function (event) {
      if (event.name === eventType) {
        event.handler(e);
        return true;
      }

      return false;
    });
  };

  return EventRegister;
}();

var CustomOptions =
/** @class */
function () {
  function CustomOptions() {}

  return CustomOptions;
}();

var OptionsConstructor =
/** @class */
function (_super) {
  __extends(OptionsConstructor, _super);

  function OptionsConstructor() {
    var _this = _super.call(this) || this;

    _this.startX = 0;
    _this.startY = 0;
    _this.scrollX = false;
    _this.scrollY = true;
    _this.freeScroll = false;
    _this.directionLockThreshold = 0;
    _this.eventPassthrough = ""
    /* None */
    ;
    _this.click = false;
    _this.dblclick = false;
    _this.tap = '';
    _this.bounce = {
      top: true,
      bottom: true,
      left: true,
      right: true
    };
    _this.bounceTime = 800;
    _this.momentum = true;
    _this.momentumLimitTime = 300;
    _this.momentumLimitDistance = 15;
    _this.swipeTime = 2500;
    _this.swipeBounceTime = 500;
    _this.deceleration = 0.0015;
    _this.flickLimitTime = 200;
    _this.flickLimitDistance = 100;
    _this.resizePolling = 60;
    _this.probeType = 0
    /* Default */
    ;
    _this.stopPropagation = false;
    _this.preventDefault = true;
    _this.preventDefaultException = {
      tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO)$/
    };
    _this.tagException = {
      tagName: /^TEXTAREA$/
    };
    _this.HWCompositing = true;
    _this.useTransition = true;
    _this.bindToWrapper = false;
    _this.bindToTarget = false;
    _this.disableMouse = hasTouch;
    _this.disableTouch = !hasTouch;
    _this.autoBlur = true;
    _this.autoEndDistance = 5;
    _this.outOfBoundaryDampingFactor = 1 / 3;
    _this.specifiedIndexAsContent = 0;
    _this.quadrant = 1
    /* First */
    ;
    return _this;
  }

  OptionsConstructor.prototype.merge = function (options) {
    if (!options) return this;

    for (var key in options) {
      if (key === 'bounce') {
        this.bounce = this.resolveBounce(options[key]);
        continue;
      }

      this[key] = options[key];
    }

    return this;
  };

  OptionsConstructor.prototype.process = function () {
    this.translateZ = this.HWCompositing && hasPerspective ? ' translateZ(1px)' : '';
    this.useTransition = this.useTransition && hasTransition;
    this.preventDefault = !this.eventPassthrough && this.preventDefault; // If you want eventPassthrough I have to lock one of the axes

    this.scrollX = this.eventPassthrough === "horizontal"
    /* Horizontal */
    ? false : this.scrollX;
    this.scrollY = this.eventPassthrough === "vertical"
    /* Vertical */
    ? false : this.scrollY; // With eventPassthrough we also need lockDirection mechanism

    this.freeScroll = this.freeScroll && !this.eventPassthrough; // force true when freeScroll is true

    this.scrollX = this.freeScroll ? true : this.scrollX;
    this.scrollY = this.freeScroll ? true : this.scrollY;
    this.directionLockThreshold = this.eventPassthrough ? 0 : this.directionLockThreshold;
    return this;
  };

  OptionsConstructor.prototype.resolveBounce = function (bounceOptions) {
    var DEFAULT_BOUNCE = {
      top: true,
      right: true,
      bottom: true,
      left: true
    };
    var NEGATED_BOUNCE = {
      top: false,
      right: false,
      bottom: false,
      left: false
    };
    var ret;

    if (_typeof(bounceOptions) === 'object') {
      ret = extend$3(DEFAULT_BOUNCE, bounceOptions);
    } else {
      ret = bounceOptions ? DEFAULT_BOUNCE : NEGATED_BOUNCE;
    }

    return ret;
  };

  return OptionsConstructor;
}(CustomOptions);

var ActionsHandler =
/** @class */
function () {
  function ActionsHandler(wrapper, options) {
    this.wrapper = wrapper;
    this.options = options;
    this.hooks = new EventEmitter(['beforeStart', 'start', 'move', 'end', 'click']);
    this.handleDOMEvents();
  }

  ActionsHandler.prototype.handleDOMEvents = function () {
    var _a = this.options,
        bindToWrapper = _a.bindToWrapper,
        disableMouse = _a.disableMouse,
        disableTouch = _a.disableTouch,
        click = _a.click;
    var wrapper = this.wrapper;
    var target = bindToWrapper ? wrapper : window;
    var wrapperEvents = [];
    var targetEvents = [];
    var shouldRegisterTouch = !disableTouch;
    var shouldRegisterMouse = !disableMouse;

    if (click) {
      wrapperEvents.push({
        name: 'click',
        handler: this.click.bind(this),
        capture: true
      });
    }

    if (shouldRegisterTouch) {
      wrapperEvents.push({
        name: 'touchstart',
        handler: this.start.bind(this)
      });
      targetEvents.push({
        name: 'touchmove',
        handler: this.move.bind(this)
      }, {
        name: 'touchend',
        handler: this.end.bind(this)
      }, {
        name: 'touchcancel',
        handler: this.end.bind(this)
      });
    }

    if (shouldRegisterMouse) {
      wrapperEvents.push({
        name: 'mousedown',
        handler: this.start.bind(this)
      });
      targetEvents.push({
        name: 'mousemove',
        handler: this.move.bind(this)
      }, {
        name: 'mouseup',
        handler: this.end.bind(this)
      });
    }

    this.wrapperEventRegister = new EventRegister$1(wrapper, wrapperEvents);
    this.targetEventRegister = new EventRegister$1(target, targetEvents);
  };

  ActionsHandler.prototype.beforeHandler = function (e, type) {
    var _a = this.options,
        preventDefault = _a.preventDefault,
        stopPropagation = _a.stopPropagation,
        preventDefaultException = _a.preventDefaultException;
    var preventDefaultConditions = {
      start: function start() {
        return preventDefault && !preventDefaultExceptionFn$2(e.target, preventDefaultException);
      },
      end: function end() {
        return preventDefault && !preventDefaultExceptionFn$2(e.target, preventDefaultException);
      },
      move: function move() {
        return preventDefault;
      }
    };

    if (preventDefaultConditions[type]()) {
      e.preventDefault();
    }

    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  ActionsHandler.prototype.setInitiated = function (type) {
    if (type === void 0) {
      type = 0;
    }

    this.initiated = type;
  };

  ActionsHandler.prototype.start = function (e) {
    var _eventType = eventTypeMap$1[e.type];

    if (this.initiated && this.initiated !== _eventType) {
      return;
    }

    this.setInitiated(_eventType); // if textarea or other html tags in options.tagException is manipulated
    // do not make bs scroll

    if (tagExceptionFn$1(e.target, this.options.tagException)) {
      this.setInitiated();
      return;
    } // only allow mouse left button


    if (_eventType === 2
    /* Mouse */
    && e.button !== 0
    /* Left */
    ) return;

    if (this.hooks.trigger(this.hooks.eventTypes.beforeStart, e)) {
      return;
    }

    this.beforeHandler(e, 'start');
    var point = e.touches ? e.touches[0] : e;
    this.pointX = point.pageX;
    this.pointY = point.pageY;
    this.hooks.trigger(this.hooks.eventTypes.start, e);
  };

  ActionsHandler.prototype.move = function (e) {
    if (eventTypeMap$1[e.type] !== this.initiated) {
      return;
    }

    this.beforeHandler(e, 'move');
    var point = e.touches ? e.touches[0] : e;
    var deltaX = point.pageX - this.pointX;
    var deltaY = point.pageY - this.pointY;
    this.pointX = point.pageX;
    this.pointY = point.pageY;

    if (this.hooks.trigger(this.hooks.eventTypes.move, {
      deltaX: deltaX,
      deltaY: deltaY,
      e: e
    })) {
      return;
    } // auto end when out of viewport


    var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
    var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    var pX = this.pointX - scrollLeft;
    var pY = this.pointY - scrollTop;
    var autoEndDistance = this.options.autoEndDistance;

    if (pX > document.documentElement.clientWidth - autoEndDistance || pY > document.documentElement.clientHeight - autoEndDistance || pX < autoEndDistance || pY < autoEndDistance) {
      this.end(e);
    }
  };

  ActionsHandler.prototype.end = function (e) {
    if (eventTypeMap$1[e.type] !== this.initiated) {
      return;
    }

    this.setInitiated();
    this.beforeHandler(e, 'end');
    this.hooks.trigger(this.hooks.eventTypes.end, e);
  };

  ActionsHandler.prototype.click = function (e) {
    this.hooks.trigger(this.hooks.eventTypes.click, e);
  };

  ActionsHandler.prototype.setContent = function (content) {
    if (content !== this.wrapper) {
      this.wrapper = content;
      this.rebindDOMEvents();
    }
  };

  ActionsHandler.prototype.rebindDOMEvents = function () {
    this.wrapperEventRegister.destroy();
    this.targetEventRegister.destroy();
    this.handleDOMEvents();
  };

  ActionsHandler.prototype.destroy = function () {
    this.wrapperEventRegister.destroy();
    this.targetEventRegister.destroy();
    this.hooks.destroy();
  };

  return ActionsHandler;
}();

var translaterMetaData = {
  x: ['translateX', 'px'],
  y: ['translateY', 'px']
};

var Translater =
/** @class */
function () {
  function Translater(content) {
    this.setContent(content);
    this.hooks = new EventEmitter(['beforeTranslate', 'translate']);
  }

  Translater.prototype.getComputedPosition = function () {
    var cssStyle = window.getComputedStyle(this.content, null);
    var matrix = cssStyle[style.transform].split(')')[0].split(', ');
    var x = +(matrix[12] || matrix[4]) || 0;
    var y = +(matrix[13] || matrix[5]) || 0;
    return {
      x: x,
      y: y
    };
  };

  Translater.prototype.translate = function (point) {
    var transformStyle = [];
    Object.keys(point).forEach(function (key) {
      if (!translaterMetaData[key]) {
        return;
      }

      var transformFnName = translaterMetaData[key][0];

      if (transformFnName) {
        var transformFnArgUnit = translaterMetaData[key][1];
        var transformFnArg = point[key];
        transformStyle.push(transformFnName + "(" + transformFnArg + transformFnArgUnit + ")");
      }
    });
    this.hooks.trigger(this.hooks.eventTypes.beforeTranslate, transformStyle, point);
    this.style[style.transform] = transformStyle.join(' ');
    this.hooks.trigger(this.hooks.eventTypes.translate, point);
  };

  Translater.prototype.setContent = function (content) {
    if (this.content !== content) {
      this.content = content;
      this.style = content.style;
    }
  };

  Translater.prototype.destroy = function () {
    this.hooks.destroy();
  };

  return Translater;
}();

var Base =
/** @class */
function () {
  function Base(content, translater, options) {
    this.translater = translater;
    this.options = options;
    this.timer = 0;
    this.hooks = new EventEmitter(['move', 'end', 'beforeForceStop', 'forceStop', 'callStop', 'time', 'timeFunction']);
    this.setContent(content);
  }

  Base.prototype.translate = function (endPoint) {
    this.translater.translate(endPoint);
  };

  Base.prototype.setPending = function (pending) {
    this.pending = pending;
  };

  Base.prototype.setForceStopped = function (forceStopped) {
    this.forceStopped = forceStopped;
  };

  Base.prototype.setCallStop = function (called) {
    this.callStopWhenPending = called;
  };

  Base.prototype.setContent = function (content) {
    if (this.content !== content) {
      this.content = content;
      this.style = content.style;
      this.stop();
    }
  };

  Base.prototype.clearTimer = function () {
    if (this.timer) {
      cancelAnimationFrame(this.timer);
      this.timer = 0;
    }
  };

  Base.prototype.destroy = function () {
    this.hooks.destroy();
    cancelAnimationFrame(this.timer);
  };

  return Base;
}(); // iOS 13.6 - 14.x, window.getComputedStyle sometimes will get wrong transform value
// when bs use transition mode
// eg: translateY -100px -> -200px, when the last frame which is about to scroll to -200px
// window.getComputedStyle(this.content) will calculate transformY to be -100px(startPoint)
// it is weird
// so we should validate position caculated by 'window.getComputedStyle'


var isValidPostion = function isValidPostion(startPoint, endPoint, currentPos, prePos) {
  var computeDirection = function computeDirection(endValue, startValue) {
    var delta = endValue - startValue;
    var direction = delta > 0 ? -1
    /* Negative */
    : delta < 0 ? 1
    /* Positive */
    : 0
    /* Default */
    ;
    return direction;
  };

  var directionX = computeDirection(endPoint.x, startPoint.x);
  var directionY = computeDirection(endPoint.y, startPoint.y);
  var deltaX = currentPos.x - prePos.x;
  var deltaY = currentPos.y - prePos.y;
  return directionX * deltaX <= 0 && directionY * deltaY <= 0;
};

var Transition =
/** @class */
function (_super) {
  __extends(Transition, _super);

  function Transition() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Transition.prototype.startProbe = function (startPoint, endPoint) {
    var _this = this;

    var prePos = startPoint;

    var probe = function probe() {
      var pos = _this.translater.getComputedPosition();

      if (isValidPostion(startPoint, endPoint, pos, prePos)) {
        _this.hooks.trigger(_this.hooks.eventTypes.move, pos);
      } // call bs.stop() should not dispatch end hook again.
      // forceStop hook will do this.

      /* istanbul ignore if  */


      if (!_this.pending) {
        if (_this.callStopWhenPending) {
          _this.callStopWhenPending = false;
        } else {
          // transition ends should dispatch end hook.
          _this.hooks.trigger(_this.hooks.eventTypes.end, pos);
        }
      }

      prePos = pos;

      if (_this.pending) {
        _this.timer = requestAnimationFrame(probe);
      }
    }; // when manually call bs.stop(), then bs.scrollTo()
    // we should reset callStopWhenPending to dispatch end hook


    if (this.callStopWhenPending) {
      this.setCallStop(false);
    }

    cancelAnimationFrame(this.timer);
    probe();
  };

  Transition.prototype.transitionTime = function (time) {
    if (time === void 0) {
      time = 0;
    }

    this.style[style.transitionDuration] = time + 'ms';
    this.hooks.trigger(this.hooks.eventTypes.time, time);
  };

  Transition.prototype.transitionTimingFunction = function (easing) {
    this.style[style.transitionTimingFunction] = easing;
    this.hooks.trigger(this.hooks.eventTypes.timeFunction, easing);
  };

  Transition.prototype.transitionProperty = function () {
    this.style[style.transitionProperty] = style.transform;
  };

  Transition.prototype.move = function (startPoint, endPoint, time, easingFn) {
    this.setPending(time > 0);
    this.transitionTimingFunction(easingFn);
    this.transitionProperty();
    this.transitionTime(time);
    this.translate(endPoint);
    var isRealtimeProbeType = this.options.probeType === 3
    /* Realtime */
    ;

    if (time && isRealtimeProbeType) {
      this.startProbe(startPoint, endPoint);
    } // if we change content's transformY in a tick
    // such as: 0 -> 50px -> 0
    // transitionend will not be triggered
    // so we forceupdate by reflow


    if (!time) {
      this._reflow = this.content.offsetHeight;

      if (isRealtimeProbeType) {
        this.hooks.trigger(this.hooks.eventTypes.move, endPoint);
      }

      this.hooks.trigger(this.hooks.eventTypes.end, endPoint);
    }
  };

  Transition.prototype.doStop = function () {
    var pending = this.pending;
    this.setForceStopped(false);
    this.setCallStop(false); // still in transition

    if (pending) {
      this.setPending(false);
      cancelAnimationFrame(this.timer);

      var _a = this.translater.getComputedPosition(),
          x = _a.x,
          y = _a.y;

      this.transitionTime();
      this.translate({
        x: x,
        y: y
      });
      this.setForceStopped(true);
      this.setCallStop(true);
      this.hooks.trigger(this.hooks.eventTypes.forceStop, {
        x: x,
        y: y
      });
    }

    return pending;
  };

  Transition.prototype.stop = function () {
    var stopFromTransition = this.doStop();

    if (stopFromTransition) {
      this.hooks.trigger(this.hooks.eventTypes.callStop);
    }
  };

  return Transition;
}(Base);

var Animation =
/** @class */
function (_super) {
  __extends(Animation, _super);

  function Animation() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Animation.prototype.move = function (startPoint, endPoint, time, easingFn) {
    // time is 0
    if (!time) {
      this.translate(endPoint);

      if (this.options.probeType === 3
      /* Realtime */
      ) {
        this.hooks.trigger(this.hooks.eventTypes.move, endPoint);
      }

      this.hooks.trigger(this.hooks.eventTypes.end, endPoint);
      return;
    }

    this.animate(startPoint, endPoint, time, easingFn);
  };

  Animation.prototype.animate = function (startPoint, endPoint, duration, easingFn) {
    var _this = this;

    var startTime = getNow();
    var destTime = startTime + duration;
    var isRealtimeProbeType = this.options.probeType === 3
    /* Realtime */
    ;

    var step = function step() {
      var now = getNow(); // js animation end

      if (now >= destTime) {
        _this.translate(endPoint);

        if (isRealtimeProbeType) {
          _this.hooks.trigger(_this.hooks.eventTypes.move, endPoint);
        }

        _this.hooks.trigger(_this.hooks.eventTypes.end, endPoint);

        return;
      }

      now = (now - startTime) / duration;
      var easing = easingFn(now);
      var newPoint = {};
      Object.keys(endPoint).forEach(function (key) {
        var startValue = startPoint[key];
        var endValue = endPoint[key];
        newPoint[key] = (endValue - startValue) * easing + startValue;
      });

      _this.translate(newPoint);

      if (isRealtimeProbeType) {
        _this.hooks.trigger(_this.hooks.eventTypes.move, newPoint);
      }

      if (_this.pending) {
        _this.timer = requestAnimationFrame(step);
      } // call bs.stop() should not dispatch end hook again.
      // forceStop hook will do this.

      /* istanbul ignore if  */


      if (!_this.pending) {
        if (_this.callStopWhenPending) {
          _this.callStopWhenPending = false;
        } else {
          // raf ends should dispatch end hook.
          _this.hooks.trigger(_this.hooks.eventTypes.end, endPoint);
        }
      }
    };

    this.setPending(true); // when manually call bs.stop(), then bs.scrollTo()
    // we should reset callStopWhenPending to dispatch end hook

    if (this.callStopWhenPending) {
      this.setCallStop(false);
    }

    cancelAnimationFrame(this.timer);
    step();
  };

  Animation.prototype.doStop = function () {
    var pending = this.pending;
    this.setForceStopped(false);
    this.setCallStop(false); // still in requestFrameAnimation

    if (pending) {
      this.setPending(false);
      cancelAnimationFrame(this.timer);
      var pos = this.translater.getComputedPosition();
      this.setForceStopped(true);
      this.setCallStop(true);
      this.hooks.trigger(this.hooks.eventTypes.forceStop, pos);
    }

    return pending;
  };

  Animation.prototype.stop = function () {
    var stopFromAnimation = this.doStop();

    if (stopFromAnimation) {
      this.hooks.trigger(this.hooks.eventTypes.callStop);
    }
  };

  return Animation;
}(Base);

function createAnimater(element, translater, options) {
  var useTransition = options.useTransition;
  var animaterOptions = {};
  Object.defineProperty(animaterOptions, 'probeType', {
    enumerable: true,
    configurable: false,
    get: function get() {
      return options.probeType;
    }
  });

  if (useTransition) {
    return new Transition(element, translater, animaterOptions);
  } else {
    return new Animation(element, translater, animaterOptions);
  }
}

var Behavior =
/** @class */
function () {
  function Behavior(wrapper, content, options) {
    this.wrapper = wrapper;
    this.options = options;
    this.hooks = new EventEmitter(['beforeComputeBoundary', 'computeBoundary', 'momentum', 'end', 'ignoreHasScroll']);
    this.refresh(content);
  }

  Behavior.prototype.start = function () {
    this.dist = 0;
    this.setMovingDirection(0
    /* Default */
    );
    this.setDirection(0
    /* Default */
    );
  };

  Behavior.prototype.move = function (delta) {
    delta = this.hasScroll ? delta : 0;
    this.setMovingDirection(delta);
    return this.performDampingAlgorithm(delta, this.options.outOfBoundaryDampingFactor);
  };

  Behavior.prototype.setMovingDirection = function (delta) {
    this.movingDirection = delta > 0 ? -1
    /* Negative */
    : delta < 0 ? 1
    /* Positive */
    : 0
    /* Default */
    ;
  };

  Behavior.prototype.setDirection = function (delta) {
    this.direction = delta > 0 ? -1
    /* Negative */
    : delta < 0 ? 1
    /* Positive */
    : 0
    /* Default */
    ;
  };

  Behavior.prototype.performDampingAlgorithm = function (delta, dampingFactor) {
    var newPos = this.currentPos + delta; // Slow down or stop if outside of the boundaries

    if (newPos > this.minScrollPos || newPos < this.maxScrollPos) {
      if (newPos > this.minScrollPos && this.options.bounces[0] || newPos < this.maxScrollPos && this.options.bounces[1]) {
        newPos = this.currentPos + delta * dampingFactor;
      } else {
        newPos = newPos > this.minScrollPos ? this.minScrollPos : this.maxScrollPos;
      }
    }

    return newPos;
  };

  Behavior.prototype.end = function (duration) {
    var momentumInfo = {
      duration: 0
    };
    var absDist = Math.abs(this.currentPos - this.startPos); // start momentum animation if needed

    if (this.options.momentum && duration < this.options.momentumLimitTime && absDist > this.options.momentumLimitDistance) {
      var wrapperSize = this.direction === -1
      /* Negative */
      && this.options.bounces[0] || this.direction === 1
      /* Positive */
      && this.options.bounces[1] ? this.wrapperSize : 0;
      momentumInfo = this.hasScroll ? this.momentum(this.currentPos, this.startPos, duration, this.maxScrollPos, this.minScrollPos, wrapperSize, this.options) : {
        destination: this.currentPos,
        duration: 0
      };
    } else {
      this.hooks.trigger(this.hooks.eventTypes.end, momentumInfo);
    }

    return momentumInfo;
  };

  Behavior.prototype.momentum = function (current, start, time, lowerMargin, upperMargin, wrapperSize, options) {
    if (options === void 0) {
      options = this.options;
    }

    var distance = current - start;
    var speed = Math.abs(distance) / time;
    var deceleration = options.deceleration,
        swipeBounceTime = options.swipeBounceTime,
        swipeTime = options.swipeTime;
    var duration = Math.min(swipeTime, speed * 2 / deceleration);
    var momentumData = {
      destination: current + speed * speed / deceleration * (distance < 0 ? -1 : 1),
      duration: duration,
      rate: 15
    };
    this.hooks.trigger(this.hooks.eventTypes.momentum, momentumData, distance);

    if (momentumData.destination < lowerMargin) {
      momentumData.destination = wrapperSize ? Math.max(lowerMargin - wrapperSize / 4, lowerMargin - wrapperSize / momentumData.rate * speed) : lowerMargin;
      momentumData.duration = swipeBounceTime;
    } else if (momentumData.destination > upperMargin) {
      momentumData.destination = wrapperSize ? Math.min(upperMargin + wrapperSize / 4, upperMargin + wrapperSize / momentumData.rate * speed) : upperMargin;
      momentumData.duration = swipeBounceTime;
    }

    momentumData.destination = Math.round(momentumData.destination);
    return momentumData;
  };

  Behavior.prototype.updateDirection = function () {
    var absDist = this.currentPos - this.absStartPos;
    this.setDirection(absDist);
  };

  Behavior.prototype.refresh = function (content) {
    var _a = this.options.rect,
        size = _a.size,
        position = _a.position;
    var isWrapperStatic = window.getComputedStyle(this.wrapper, null).position === 'static'; // Force reflow

    var wrapperRect = getRect(this.wrapper); // use client is more fair than offset

    this.wrapperSize = this.wrapper[size === 'width' ? 'clientWidth' : 'clientHeight'];
    this.setContent(content);
    var contentRect = getRect(this.content);
    this.contentSize = contentRect[size];
    this.relativeOffset = contentRect[position];
    /* istanbul ignore if  */

    if (isWrapperStatic) {
      this.relativeOffset -= wrapperRect[position];
    }

    this.computeBoundary();
    this.setDirection(0
    /* Default */
    );
  };

  Behavior.prototype.setContent = function (content) {
    if (content !== this.content) {
      this.content = content;
      this.resetState();
    }
  };

  Behavior.prototype.resetState = function () {
    this.currentPos = 0;
    this.startPos = 0;
    this.dist = 0;
    this.setDirection(0
    /* Default */
    );
    this.setMovingDirection(0
    /* Default */
    );
    this.resetStartPos();
  };

  Behavior.prototype.computeBoundary = function () {
    this.hooks.trigger(this.hooks.eventTypes.beforeComputeBoundary);
    var boundary = {
      minScrollPos: 0,
      maxScrollPos: this.wrapperSize - this.contentSize
    };

    if (boundary.maxScrollPos < 0) {
      boundary.maxScrollPos -= this.relativeOffset;

      if (this.options.specifiedIndexAsContent === 0) {
        boundary.minScrollPos = -this.relativeOffset;
      }
    }

    this.hooks.trigger(this.hooks.eventTypes.computeBoundary, boundary);
    this.minScrollPos = boundary.minScrollPos;
    this.maxScrollPos = boundary.maxScrollPos;
    this.hasScroll = this.options.scrollable && this.maxScrollPos < this.minScrollPos;

    if (!this.hasScroll && this.minScrollPos < this.maxScrollPos) {
      this.maxScrollPos = this.minScrollPos;
      this.contentSize = this.wrapperSize;
    }
  };

  Behavior.prototype.updatePosition = function (pos) {
    this.currentPos = pos;
  };

  Behavior.prototype.getCurrentPos = function () {
    return this.currentPos;
  };

  Behavior.prototype.checkInBoundary = function () {
    var position = this.adjustPosition(this.currentPos);
    var inBoundary = position === this.getCurrentPos();
    return {
      position: position,
      inBoundary: inBoundary
    };
  }; // adjust position when out of boundary


  Behavior.prototype.adjustPosition = function (pos) {
    if (!this.hasScroll && !this.hooks.trigger(this.hooks.eventTypes.ignoreHasScroll)) {
      pos = this.minScrollPos;
    } else if (pos > this.minScrollPos) {
      pos = this.minScrollPos;
    } else if (pos < this.maxScrollPos) {
      pos = this.maxScrollPos;
    }

    return pos;
  };

  Behavior.prototype.updateStartPos = function () {
    this.startPos = this.currentPos;
  };

  Behavior.prototype.updateAbsStartPos = function () {
    this.absStartPos = this.currentPos;
  };

  Behavior.prototype.resetStartPos = function () {
    this.updateStartPos();
    this.updateAbsStartPos();
  };

  Behavior.prototype.getAbsDist = function (delta) {
    this.dist += delta;
    return Math.abs(this.dist);
  };

  Behavior.prototype.destroy = function () {
    this.hooks.destroy();
  };

  return Behavior;
}();

var _a, _b, _c, _d;

var PassthroughHandlers = (_a = {}, _a["yes"
/* Yes */
] = function (e) {
  return true;
}, _a["no"
/* No */
] = function (e) {
  e.preventDefault();
  return false;
}, _a);
var DirectionMap = (_b = {}, _b["horizontal"
/* Horizontal */
] = (_c = {}, _c["yes"
/* Yes */
] = "horizontal"
/* Horizontal */
, _c["no"
/* No */
] = "vertical"
/* Vertical */
, _c), _b["vertical"
/* Vertical */
] = (_d = {}, _d["yes"
/* Yes */
] = "vertical"
/* Vertical */
, _d["no"
/* No */
] = "horizontal"
/* Horizontal */
, _d), _b);

var DirectionLockAction =
/** @class */
function () {
  function DirectionLockAction(directionLockThreshold, freeScroll, eventPassthrough) {
    this.directionLockThreshold = directionLockThreshold;
    this.freeScroll = freeScroll;
    this.eventPassthrough = eventPassthrough;
    this.reset();
  }

  DirectionLockAction.prototype.reset = function () {
    this.directionLocked = ""
    /* Default */
    ;
  };

  DirectionLockAction.prototype.checkMovingDirection = function (absDistX, absDistY, e) {
    this.computeDirectionLock(absDistX, absDistY);
    return this.handleEventPassthrough(e);
  };

  DirectionLockAction.prototype.adjustDelta = function (deltaX, deltaY) {
    if (this.directionLocked === "horizontal"
    /* Horizontal */
    ) {
      deltaY = 0;
    } else if (this.directionLocked === "vertical"
    /* Vertical */
    ) {
      deltaX = 0;
    }

    return {
      deltaX: deltaX,
      deltaY: deltaY
    };
  };

  DirectionLockAction.prototype.computeDirectionLock = function (absDistX, absDistY) {
    // If you are scrolling in one direction, lock it
    if (this.directionLocked === ""
    /* Default */
    && !this.freeScroll) {
      if (absDistX > absDistY + this.directionLockThreshold) {
        this.directionLocked = "horizontal"
        /* Horizontal */
        ; // lock horizontally
      } else if (absDistY >= absDistX + this.directionLockThreshold) {
        this.directionLocked = "vertical"
        /* Vertical */
        ; // lock vertically
      } else {
        this.directionLocked = "none"
        /* None */
        ; // no lock
      }
    }
  };

  DirectionLockAction.prototype.handleEventPassthrough = function (e) {
    var handleMap = DirectionMap[this.directionLocked];

    if (handleMap) {
      if (this.eventPassthrough === handleMap["yes"
      /* Yes */
      ]) {
        return PassthroughHandlers["yes"
        /* Yes */
        ](e);
      } else if (this.eventPassthrough === handleMap["no"
      /* No */
      ]) {
        return PassthroughHandlers["no"
        /* No */
        ](e);
      }
    }

    return false;
  };

  return DirectionLockAction;
}();

var applyQuadrantTransformation = function applyQuadrantTransformation(deltaX, deltaY, quadrant) {
  if (quadrant === 2
  /* Second */
  ) {
    return [deltaY, -deltaX];
  } else if (quadrant === 3
  /* Third */
  ) {
    return [-deltaX, -deltaY];
  } else if (quadrant === 4
  /* Forth */
  ) {
    return [-deltaY, deltaX];
  } else {
    return [deltaX, deltaY];
  }
};

var ScrollerActions =
/** @class */
function () {
  function ScrollerActions(scrollBehaviorX, scrollBehaviorY, actionsHandler, animater, options) {
    this.hooks = new EventEmitter(['start', 'beforeMove', 'scrollStart', 'scroll', 'beforeEnd', 'end', 'scrollEnd', 'contentNotMoved', 'detectMovingDirection', 'coordinateTransformation']);
    this.scrollBehaviorX = scrollBehaviorX;
    this.scrollBehaviorY = scrollBehaviorY;
    this.actionsHandler = actionsHandler;
    this.animater = animater;
    this.options = options;
    this.directionLockAction = new DirectionLockAction(options.directionLockThreshold, options.freeScroll, options.eventPassthrough);
    this.enabled = true;
    this.bindActionsHandler();
  }

  ScrollerActions.prototype.bindActionsHandler = function () {
    var _this = this; // [mouse|touch]start event


    this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.start, function (e) {
      if (!_this.enabled) return true;
      return _this.handleStart(e);
    }); // [mouse|touch]move event

    this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.move, function (_a) {
      var deltaX = _a.deltaX,
          deltaY = _a.deltaY,
          e = _a.e;
      if (!_this.enabled) return true;

      var _b = applyQuadrantTransformation(deltaX, deltaY, _this.options.quadrant),
          transformateDeltaX = _b[0],
          transformateDeltaY = _b[1];

      var transformateDeltaData = {
        deltaX: transformateDeltaX,
        deltaY: transformateDeltaY
      };

      _this.hooks.trigger(_this.hooks.eventTypes.coordinateTransformation, transformateDeltaData);

      return _this.handleMove(transformateDeltaData.deltaX, transformateDeltaData.deltaY, e);
    }); // [mouse|touch]end event

    this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.end, function (e) {
      if (!_this.enabled) return true;
      return _this.handleEnd(e);
    }); // click

    this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.click, function (e) {
      // handle native click event
      if (_this.enabled && !e._constructed) {
        _this.handleClick(e);
      }
    });
  };

  ScrollerActions.prototype.handleStart = function (e) {
    var timestamp = getNow();
    this.fingerMoved = false;
    this.contentMoved = false;
    this.startTime = timestamp;
    this.directionLockAction.reset();
    this.scrollBehaviorX.start();
    this.scrollBehaviorY.start(); // force stopping last transition or animation

    this.animater.doStop();
    this.scrollBehaviorX.resetStartPos();
    this.scrollBehaviorY.resetStartPos();
    this.hooks.trigger(this.hooks.eventTypes.start, e);
  };

  ScrollerActions.prototype.handleMove = function (deltaX, deltaY, e) {
    if (this.hooks.trigger(this.hooks.eventTypes.beforeMove, e)) {
      return;
    }

    var absDistX = this.scrollBehaviorX.getAbsDist(deltaX);
    var absDistY = this.scrollBehaviorY.getAbsDist(deltaY);
    var timestamp = getNow(); // We need to move at least momentumLimitDistance pixels
    // for the scrolling to initiate

    if (this.checkMomentum(absDistX, absDistY, timestamp)) {
      return true;
    }

    if (this.directionLockAction.checkMovingDirection(absDistX, absDistY, e)) {
      this.actionsHandler.setInitiated();
      return true;
    }

    var delta = this.directionLockAction.adjustDelta(deltaX, deltaY);
    var prevX = this.scrollBehaviorX.getCurrentPos();
    var newX = this.scrollBehaviorX.move(delta.deltaX);
    var prevY = this.scrollBehaviorY.getCurrentPos();
    var newY = this.scrollBehaviorY.move(delta.deltaY);

    if (this.hooks.trigger(this.hooks.eventTypes.detectMovingDirection)) {
      return;
    }

    if (!this.fingerMoved) {
      this.fingerMoved = true;
    }

    var positionChanged = newX !== prevX || newY !== prevY;

    if (!this.contentMoved && !positionChanged) {
      this.hooks.trigger(this.hooks.eventTypes.contentNotMoved);
    }

    if (!this.contentMoved && positionChanged) {
      this.contentMoved = true;
      this.hooks.trigger(this.hooks.eventTypes.scrollStart);
    }

    if (this.contentMoved && positionChanged) {
      this.animater.translate({
        x: newX,
        y: newY
      });
      this.dispatchScroll(timestamp);
    }
  };

  ScrollerActions.prototype.dispatchScroll = function (timestamp) {
    // dispatch scroll in interval time
    if (timestamp - this.startTime > this.options.momentumLimitTime) {
      // refresh time and starting position to initiate a momentum
      this.startTime = timestamp;
      this.scrollBehaviorX.updateStartPos();
      this.scrollBehaviorY.updateStartPos();

      if (this.options.probeType === 1
      /* Throttle */
      ) {
        this.hooks.trigger(this.hooks.eventTypes.scroll, this.getCurrentPos());
      }
    } // dispatch scroll all the time


    if (this.options.probeType > 1
    /* Throttle */
    ) {
      this.hooks.trigger(this.hooks.eventTypes.scroll, this.getCurrentPos());
    }
  };

  ScrollerActions.prototype.checkMomentum = function (absDistX, absDistY, timestamp) {
    return timestamp - this.endTime > this.options.momentumLimitTime && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance;
  };

  ScrollerActions.prototype.handleEnd = function (e) {
    if (this.hooks.trigger(this.hooks.eventTypes.beforeEnd, e)) {
      return;
    }

    var currentPos = this.getCurrentPos();
    this.scrollBehaviorX.updateDirection();
    this.scrollBehaviorY.updateDirection();

    if (this.hooks.trigger(this.hooks.eventTypes.end, e, currentPos)) {
      return true;
    }

    currentPos = this.ensureIntegerPos(currentPos);
    this.animater.translate(currentPos);
    this.endTime = getNow();
    var duration = this.endTime - this.startTime;
    this.hooks.trigger(this.hooks.eventTypes.scrollEnd, currentPos, duration);
  };

  ScrollerActions.prototype.ensureIntegerPos = function (currentPos) {
    this.ensuringInteger = true;
    var x = currentPos.x,
        y = currentPos.y;
    var _a = this.scrollBehaviorX,
        minScrollPosX = _a.minScrollPos,
        maxScrollPosX = _a.maxScrollPos;
    var _b = this.scrollBehaviorY,
        minScrollPosY = _b.minScrollPos,
        maxScrollPosY = _b.maxScrollPos;
    x = x > 0 ? Math.ceil(x) : Math.floor(x);
    y = y > 0 ? Math.ceil(y) : Math.floor(y);
    x = between(x, maxScrollPosX, minScrollPosX);
    y = between(y, maxScrollPosY, minScrollPosY);
    return {
      x: x,
      y: y
    };
  };

  ScrollerActions.prototype.handleClick = function (e) {
    if (!preventDefaultExceptionFn$2(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  ScrollerActions.prototype.getCurrentPos = function () {
    return {
      x: this.scrollBehaviorX.getCurrentPos(),
      y: this.scrollBehaviorY.getCurrentPos()
    };
  };

  ScrollerActions.prototype.refresh = function () {
    this.endTime = 0;
  };

  ScrollerActions.prototype.destroy = function () {
    this.hooks.destroy();
  };

  return ScrollerActions;
}();

function createActionsHandlerOptions(bsOptions) {
  var options = ['click', 'bindToWrapper', 'disableMouse', 'disableTouch', 'preventDefault', 'stopPropagation', 'tagException', 'preventDefaultException', 'autoEndDistance'].reduce(function (prev, cur) {
    prev[cur] = bsOptions[cur];
    return prev;
  }, {});
  return options;
}

function createBehaviorOptions(bsOptions, extraProp, bounces, rect) {
  var options = ['momentum', 'momentumLimitTime', 'momentumLimitDistance', 'deceleration', 'swipeBounceTime', 'swipeTime', 'outOfBoundaryDampingFactor', 'specifiedIndexAsContent'].reduce(function (prev, cur) {
    prev[cur] = bsOptions[cur];
    return prev;
  }, {}); // add extra property

  options.scrollable = !!bsOptions[extraProp];
  options.bounces = bounces;
  options.rect = rect;
  return options;
}

function bubbling(source, target, events) {
  events.forEach(function (event) {
    var sourceEvent;
    var targetEvent;

    if (typeof event === 'string') {
      sourceEvent = targetEvent = event;
    } else {
      sourceEvent = event.source;
      targetEvent = event.target;
    }

    source.on(sourceEvent, function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return target.trigger.apply(target, __spreadArrays([targetEvent], args));
    });
  });
}

function isSamePoint(startPoint, endPoint) {
  // keys of startPoint and endPoint should be equal
  var keys = Object.keys(startPoint);

  for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
    var key = keys_1[_i];
    if (startPoint[key] !== endPoint[key]) return false;
  }

  return true;
}

var MIN_SCROLL_DISTANCE = 1;

var Scroller =
/** @class */
function () {
  function Scroller(wrapper, content, options) {
    this.wrapper = wrapper;
    this.content = content;
    this.resizeTimeout = 0;
    this.hooks = new EventEmitter(['beforeStart', 'beforeMove', 'beforeScrollStart', 'scrollStart', 'scroll', 'beforeEnd', 'scrollEnd', 'resize', 'touchEnd', 'end', 'flick', 'scrollCancel', 'momentum', 'scrollTo', 'minDistanceScroll', 'scrollToElement', 'beforeRefresh']);
    this.options = options;
    var _a = this.options.bounce,
        left = _a.left,
        right = _a.right,
        top = _a.top,
        bottom = _a.bottom; // direction X

    this.scrollBehaviorX = new Behavior(wrapper, content, createBehaviorOptions(options, 'scrollX', [left, right], {
      size: 'width',
      position: 'left'
    })); // direction Y

    this.scrollBehaviorY = new Behavior(wrapper, content, createBehaviorOptions(options, 'scrollY', [top, bottom], {
      size: 'height',
      position: 'top'
    }));
    this.translater = new Translater(this.content);
    this.animater = createAnimater(this.content, this.translater, this.options);
    this.actionsHandler = new ActionsHandler(this.options.bindToTarget ? this.content : wrapper, createActionsHandlerOptions(this.options));
    this.actions = new ScrollerActions(this.scrollBehaviorX, this.scrollBehaviorY, this.actionsHandler, this.animater, this.options);
    var resizeHandler = this.resize.bind(this);
    this.resizeRegister = new EventRegister$1(window, [{
      name: 'orientationchange',
      handler: resizeHandler
    }, {
      name: 'resize',
      handler: resizeHandler
    }]);
    this.registerTransitionEnd();
    this.init();
  }

  Scroller.prototype.init = function () {
    var _this = this;

    this.bindTranslater();
    this.bindAnimater();
    this.bindActions(); // enable pointer events when scrolling ends

    this.hooks.on(this.hooks.eventTypes.scrollEnd, function () {
      _this.togglePointerEvents(true);
    });
  };

  Scroller.prototype.registerTransitionEnd = function () {
    this.transitionEndRegister = new EventRegister$1(this.content, [{
      name: style.transitionEnd,
      handler: this.transitionEnd.bind(this)
    }]);
  };

  Scroller.prototype.bindTranslater = function () {
    var _this = this;

    var hooks = this.translater.hooks;
    hooks.on(hooks.eventTypes.beforeTranslate, function (transformStyle) {
      if (_this.options.translateZ) {
        transformStyle.push(_this.options.translateZ);
      }
    }); // disable pointer events when scrolling

    hooks.on(hooks.eventTypes.translate, function (pos) {
      var prevPos = _this.getCurrentPos();

      _this.updatePositions(pos); // scrollEnd will dispatch when scroll is force stopping in touchstart handler
      // so in touchend handler, don't toggle pointer-events


      if (_this.actions.ensuringInteger === true) {
        _this.actions.ensuringInteger = false;
        return;
      } // a valid translate


      if (pos.x !== prevPos.x || pos.y !== prevPos.y) {
        _this.togglePointerEvents(false);
      }
    });
  };

  Scroller.prototype.bindAnimater = function () {
    var _this = this; // reset position


    this.animater.hooks.on(this.animater.hooks.eventTypes.end, function (pos) {
      if (!_this.resetPosition(_this.options.bounceTime)) {
        _this.animater.setPending(false);

        _this.hooks.trigger(_this.hooks.eventTypes.scrollEnd, pos);
      }
    });
    bubbling(this.animater.hooks, this.hooks, [{
      source: this.animater.hooks.eventTypes.move,
      target: this.hooks.eventTypes.scroll
    }, {
      source: this.animater.hooks.eventTypes.forceStop,
      target: this.hooks.eventTypes.scrollEnd
    }]);
  };

  Scroller.prototype.bindActions = function () {
    var _this = this;

    var actions = this.actions;
    bubbling(actions.hooks, this.hooks, [{
      source: actions.hooks.eventTypes.start,
      target: this.hooks.eventTypes.beforeStart
    }, {
      source: actions.hooks.eventTypes.start,
      target: this.hooks.eventTypes.beforeScrollStart
    }, {
      source: actions.hooks.eventTypes.beforeMove,
      target: this.hooks.eventTypes.beforeMove
    }, {
      source: actions.hooks.eventTypes.scrollStart,
      target: this.hooks.eventTypes.scrollStart
    }, {
      source: actions.hooks.eventTypes.scroll,
      target: this.hooks.eventTypes.scroll
    }, {
      source: actions.hooks.eventTypes.beforeEnd,
      target: this.hooks.eventTypes.beforeEnd
    }]);
    actions.hooks.on(actions.hooks.eventTypes.end, function (e, pos) {
      _this.hooks.trigger(_this.hooks.eventTypes.touchEnd, pos);

      if (_this.hooks.trigger(_this.hooks.eventTypes.end, pos)) {
        return true;
      } // check if it is a click operation


      if (!actions.fingerMoved) {
        _this.hooks.trigger(_this.hooks.eventTypes.scrollCancel);

        if (_this.checkClick(e)) {
          return true;
        }
      } // reset if we are outside of the boundaries


      if (_this.resetPosition(_this.options.bounceTime, ease$1.bounce)) {
        _this.animater.setForceStopped(false);

        return true;
      }
    });
    actions.hooks.on(actions.hooks.eventTypes.scrollEnd, function (pos, duration) {
      var deltaX = Math.abs(pos.x - _this.scrollBehaviorX.startPos);
      var deltaY = Math.abs(pos.y - _this.scrollBehaviorY.startPos);

      if (_this.checkFlick(duration, deltaX, deltaY)) {
        _this.animater.setForceStopped(false);

        _this.hooks.trigger(_this.hooks.eventTypes.flick);

        return;
      }

      if (_this.momentum(pos, duration)) {
        _this.animater.setForceStopped(false);

        return;
      }

      if (actions.contentMoved) {
        _this.hooks.trigger(_this.hooks.eventTypes.scrollEnd, pos);
      }

      if (_this.animater.forceStopped) {
        _this.animater.setForceStopped(false);
      }
    });
  };

  Scroller.prototype.checkFlick = function (duration, deltaX, deltaY) {
    var flickMinMovingDistance = 1; // distinguish flick from click

    if (this.hooks.events.flick.length > 1 && duration < this.options.flickLimitTime && deltaX < this.options.flickLimitDistance && deltaY < this.options.flickLimitDistance && (deltaY > flickMinMovingDistance || deltaX > flickMinMovingDistance)) {
      return true;
    }
  };

  Scroller.prototype.momentum = function (pos, duration) {
    var meta = {
      time: 0,
      easing: ease$1.swiper,
      newX: pos.x,
      newY: pos.y
    }; // start momentum animation if needed

    var momentumX = this.scrollBehaviorX.end(duration);
    var momentumY = this.scrollBehaviorY.end(duration);
    meta.newX = isUndef(momentumX.destination) ? meta.newX : momentumX.destination;
    meta.newY = isUndef(momentumY.destination) ? meta.newY : momentumY.destination;
    meta.time = Math.max(momentumX.duration, momentumY.duration);
    this.hooks.trigger(this.hooks.eventTypes.momentum, meta, this); // when x or y changed, do momentum animation now!

    if (meta.newX !== pos.x || meta.newY !== pos.y) {
      // change easing function when scroller goes out of the boundaries
      if (meta.newX > this.scrollBehaviorX.minScrollPos || meta.newX < this.scrollBehaviorX.maxScrollPos || meta.newY > this.scrollBehaviorY.minScrollPos || meta.newY < this.scrollBehaviorY.maxScrollPos) {
        meta.easing = ease$1.swipeBounce;
      }

      this.scrollTo(meta.newX, meta.newY, meta.time, meta.easing);
      return true;
    }
  };

  Scroller.prototype.checkClick = function (e) {
    var cancelable = {
      preventClick: this.animater.forceStopped
    }; // we scrolled less than momentumLimitDistance pixels

    if (this.hooks.trigger(this.hooks.eventTypes.checkClick)) {
      this.animater.setForceStopped(false);
      return true;
    }

    if (!cancelable.preventClick) {
      var _dblclick = this.options.dblclick;
      var dblclickTrigged = false;

      if (_dblclick && this.lastClickTime) {
        var _a = _dblclick.delay,
            delay = _a === void 0 ? 300 : _a;

        if (getNow() - this.lastClickTime < delay) {
          dblclickTrigged = true;
          dblclick(e);
        }
      }

      if (this.options.tap) {
        tap(e, this.options.tap);
      }

      if (this.options.click && !preventDefaultExceptionFn$2(e.target, this.options.preventDefaultException)) {
        click(e);
      }

      this.lastClickTime = dblclickTrigged ? null : getNow();
      return true;
    }

    return false;
  };

  Scroller.prototype.resize = function () {
    var _this = this;

    if (!this.actions.enabled) {
      return;
    } // fix a scroll problem under Android condition

    /* istanbul ignore if  */


    if (isAndroid) {
      this.wrapper.scrollTop = 0;
    }

    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = window.setTimeout(function () {
      _this.hooks.trigger(_this.hooks.eventTypes.resize);
    }, this.options.resizePolling);
  };
  /* istanbul ignore next */


  Scroller.prototype.transitionEnd = function (e) {
    if (e.target !== this.content || !this.animater.pending) {
      return;
    }

    var animater = this.animater;
    animater.transitionTime();

    if (!this.resetPosition(this.options.bounceTime, ease$1.bounce)) {
      this.animater.setPending(false);

      if (this.options.probeType !== 3
      /* Realtime */
      ) {
        this.hooks.trigger(this.hooks.eventTypes.scrollEnd, this.getCurrentPos());
      }
    }
  };

  Scroller.prototype.togglePointerEvents = function (enabled) {
    if (enabled === void 0) {
      enabled = true;
    }

    var el = this.content.children.length ? this.content.children : [this.content];
    var pointerEvents = enabled ? 'auto' : 'none';

    for (var i = 0; i < el.length; i++) {
      var node = el[i]; // ignore BetterScroll instance's wrapper DOM

      /* istanbul ignore if  */

      if (node.isBScrollContainer) {
        continue;
      }

      node.style.pointerEvents = pointerEvents;
    }
  };

  Scroller.prototype.refresh = function (content) {
    var contentChanged = this.setContent(content);
    this.hooks.trigger(this.hooks.eventTypes.beforeRefresh);
    this.scrollBehaviorX.refresh(content);
    this.scrollBehaviorY.refresh(content);

    if (contentChanged) {
      this.translater.setContent(content);
      this.animater.setContent(content);
      this.transitionEndRegister.destroy();
      this.registerTransitionEnd();

      if (this.options.bindToTarget) {
        this.actionsHandler.setContent(content);
      }
    }

    this.actions.refresh();
    this.wrapperOffset = offset(this.wrapper);
  };

  Scroller.prototype.setContent = function (content) {
    var contentChanged = content !== this.content;

    if (contentChanged) {
      this.content = content;
    }

    return contentChanged;
  };

  Scroller.prototype.scrollBy = function (deltaX, deltaY, time, easing) {
    if (time === void 0) {
      time = 0;
    }

    var _a = this.getCurrentPos(),
        x = _a.x,
        y = _a.y;

    easing = !easing ? ease$1.bounce : easing;
    deltaX += x;
    deltaY += y;
    this.scrollTo(deltaX, deltaY, time, easing);
  };

  Scroller.prototype.scrollTo = function (x, y, time, easing, extraTransform) {
    if (time === void 0) {
      time = 0;
    }

    if (easing === void 0) {
      easing = ease$1.bounce;
    }

    if (extraTransform === void 0) {
      extraTransform = {
        start: {},
        end: {}
      };
    }

    var easingFn = this.options.useTransition ? easing.style : easing.fn;
    var currentPos = this.getCurrentPos();

    var startPoint = _assign({
      x: currentPos.x,
      y: currentPos.y
    }, extraTransform.start);

    var endPoint = _assign({
      x: x,
      y: y
    }, extraTransform.end);

    this.hooks.trigger(this.hooks.eventTypes.scrollTo, endPoint); // it is an useless move

    if (isSamePoint(startPoint, endPoint)) return;
    var deltaX = Math.abs(endPoint.x - startPoint.x);
    var deltaY = Math.abs(endPoint.y - startPoint.y); // considering of browser compatibility for decimal transform value
    // force translating immediately

    if (deltaX < MIN_SCROLL_DISTANCE && deltaY < MIN_SCROLL_DISTANCE) {
      time = 0;
      this.hooks.trigger(this.hooks.eventTypes.minDistanceScroll);
    }

    this.animater.move(startPoint, endPoint, time, easingFn);
  };

  Scroller.prototype.scrollToElement = function (el, time, offsetX, offsetY, easing) {
    var targetEle = getElement(el);
    var pos = offset(targetEle);

    var getOffset = function getOffset(offset, size, wrapperSize) {
      if (typeof offset === 'number') {
        return offset;
      } // if offsetX/Y are true we center the element to the screen


      return offset ? Math.round(size / 2 - wrapperSize / 2) : 0;
    };

    offsetX = getOffset(offsetX, targetEle.offsetWidth, this.wrapper.offsetWidth);
    offsetY = getOffset(offsetY, targetEle.offsetHeight, this.wrapper.offsetHeight);

    var getPos = function getPos(pos, wrapperPos, offset, scrollBehavior) {
      pos -= wrapperPos;
      pos = scrollBehavior.adjustPosition(pos - offset);
      return pos;
    };

    pos.left = getPos(pos.left, this.wrapperOffset.left, offsetX, this.scrollBehaviorX);
    pos.top = getPos(pos.top, this.wrapperOffset.top, offsetY, this.scrollBehaviorY);

    if (this.hooks.trigger(this.hooks.eventTypes.scrollToElement, targetEle, pos)) {
      return;
    }

    this.scrollTo(pos.left, pos.top, time, easing);
  };

  Scroller.prototype.resetPosition = function (time, easing) {
    if (time === void 0) {
      time = 0;
    }

    if (easing === void 0) {
      easing = ease$1.bounce;
    }

    var _a = this.scrollBehaviorX.checkInBoundary(),
        x = _a.position,
        xInBoundary = _a.inBoundary;

    var _b = this.scrollBehaviorY.checkInBoundary(),
        y = _b.position,
        yInBoundary = _b.inBoundary;

    if (xInBoundary && yInBoundary) {
      return false;
    }
    /* istanbul ignore if  */


    if (isIOSBadVersion) {
      // fix ios 13.4 bouncing
      // see it in issues 982
      this.reflow();
    } // out of boundary


    this.scrollTo(x, y, time, easing);
    return true;
  };
  /* istanbul ignore next */


  Scroller.prototype.reflow = function () {
    this._reflow = this.content.offsetHeight;
  };

  Scroller.prototype.updatePositions = function (pos) {
    this.scrollBehaviorX.updatePosition(pos.x);
    this.scrollBehaviorY.updatePosition(pos.y);
  };

  Scroller.prototype.getCurrentPos = function () {
    return this.actions.getCurrentPos();
  };

  Scroller.prototype.enable = function () {
    this.actions.enabled = true;
  };

  Scroller.prototype.disable = function () {
    cancelAnimationFrame(this.animater.timer);
    this.actions.enabled = false;
  };

  Scroller.prototype.destroy = function () {
    var _this = this;

    var keys = ['resizeRegister', 'transitionEndRegister', 'actionsHandler', 'actions', 'hooks', 'animater', 'translater', 'scrollBehaviorX', 'scrollBehaviorY'];
    keys.forEach(function (key) {
      return _this[key].destroy();
    });
  };

  return Scroller;
}();

var BScrollConstructor =
/** @class */
function (_super) {
  __extends(BScrollConstructor, _super);

  function BScrollConstructor(el, options) {
    var _this = _super.call(this, ['refresh', 'contentChanged', 'enable', 'disable', 'beforeScrollStart', 'scrollStart', 'scroll', 'scrollEnd', 'scrollCancel', 'touchEnd', 'flick', 'destroy']) || this;

    var wrapper = getElement(el);

    if (!wrapper) {
      warn$1('Can not resolve the wrapper DOM.');
      return _this;
    }

    _this.plugins = {};
    _this.options = new OptionsConstructor().merge(options).process();

    if (!_this.setContent(wrapper).valid) {
      return _this;
    }

    _this.hooks = new EventEmitter(['refresh', 'enable', 'disable', 'destroy', 'beforeInitialScrollTo', 'contentChanged']);

    _this.init(wrapper);

    return _this;
  }

  BScrollConstructor.use = function (ctor) {
    var name = ctor.pluginName;
    var installed = BScrollConstructor.plugins.some(function (plugin) {
      return ctor === plugin.ctor;
    });
    if (installed) return BScrollConstructor;

    if (isUndef(name)) {
      warn$1("Plugin Class must specify plugin's name in static property by 'pluginName' field.");
      return BScrollConstructor;
    }

    BScrollConstructor.pluginsMap[name] = true;
    BScrollConstructor.plugins.push({
      name: name,
      applyOrder: ctor.applyOrder,
      ctor: ctor
    });
    return BScrollConstructor;
  };

  BScrollConstructor.prototype.setContent = function (wrapper) {
    var contentChanged = false;
    var valid = true;
    var content = wrapper.children[this.options.specifiedIndexAsContent];

    if (!content) {
      warn$1('The wrapper need at least one child element to be content element to scroll.');
      valid = false;
    } else {
      contentChanged = this.content !== content;

      if (contentChanged) {
        this.content = content;
      }
    }

    return {
      valid: valid,
      contentChanged: contentChanged
    };
  };

  BScrollConstructor.prototype.init = function (wrapper) {
    var _this = this;

    this.wrapper = wrapper; // mark wrapper to recognize bs instance by DOM attribute

    wrapper.isBScrollContainer = true;
    this.scroller = new Scroller(wrapper, this.content, this.options);
    this.scroller.hooks.on(this.scroller.hooks.eventTypes.resize, function () {
      _this.refresh();
    });
    this.eventBubbling();
    this.handleAutoBlur();
    this.enable();
    this.proxy(propertiesConfig$2);
    this.applyPlugins(); // maybe boundary has changed, should refresh

    this.refreshWithoutReset(this.content);
    var _a = this.options,
        startX = _a.startX,
        startY = _a.startY;
    var position = {
      x: startX,
      y: startY
    }; // maybe plugins want to control scroll position

    if (this.hooks.trigger(this.hooks.eventTypes.beforeInitialScrollTo, position)) {
      return;
    }

    this.scroller.scrollTo(position.x, position.y);
  };

  BScrollConstructor.prototype.applyPlugins = function () {
    var _this = this;

    var options = this.options;
    BScrollConstructor.plugins.sort(function (a, b) {
      var _a;

      var applyOrderMap = (_a = {}, _a["pre"
      /* Pre */
      ] = -1, _a["post"
      /* Post */
      ] = 1, _a);
      var aOrder = a.applyOrder ? applyOrderMap[a.applyOrder] : 0;
      var bOrder = b.applyOrder ? applyOrderMap[b.applyOrder] : 0;
      return aOrder - bOrder;
    }).forEach(function (item) {
      var ctor = item.ctor;

      if (options[item.name] && typeof ctor === 'function') {
        _this.plugins[item.name] = new ctor(_this);
      }
    });
  };

  BScrollConstructor.prototype.handleAutoBlur = function () {
    /* istanbul ignore if  */
    if (this.options.autoBlur) {
      this.on(this.eventTypes.beforeScrollStart, function () {
        var activeElement = document.activeElement;

        if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
          activeElement.blur();
        }
      });
    }
  };

  BScrollConstructor.prototype.eventBubbling = function () {
    bubbling(this.scroller.hooks, this, [this.eventTypes.beforeScrollStart, this.eventTypes.scrollStart, this.eventTypes.scroll, this.eventTypes.scrollEnd, this.eventTypes.scrollCancel, this.eventTypes.touchEnd, this.eventTypes.flick]);
  };

  BScrollConstructor.prototype.refreshWithoutReset = function (content) {
    this.scroller.refresh(content);
    this.hooks.trigger(this.hooks.eventTypes.refresh, content);
    this.trigger(this.eventTypes.refresh, content);
  };

  BScrollConstructor.prototype.proxy = function (propertiesConfig) {
    var _this = this;

    propertiesConfig.forEach(function (_a) {
      var key = _a.key,
          sourceKey = _a.sourceKey;
      propertiesProxy(_this, sourceKey, key);
    });
  };

  BScrollConstructor.prototype.refresh = function () {
    var _a = this.setContent(this.wrapper),
        contentChanged = _a.contentChanged,
        valid = _a.valid;

    if (valid) {
      var content = this.content;
      this.refreshWithoutReset(content);

      if (contentChanged) {
        this.hooks.trigger(this.hooks.eventTypes.contentChanged, content);
        this.trigger(this.eventTypes.contentChanged, content);
      }

      this.scroller.resetPosition();
    }
  };

  BScrollConstructor.prototype.enable = function () {
    this.scroller.enable();
    this.hooks.trigger(this.hooks.eventTypes.enable);
    this.trigger(this.eventTypes.enable);
  };

  BScrollConstructor.prototype.disable = function () {
    this.scroller.disable();
    this.hooks.trigger(this.hooks.eventTypes.disable);
    this.trigger(this.eventTypes.disable);
  };

  BScrollConstructor.prototype.destroy = function () {
    this.hooks.trigger(this.hooks.eventTypes.destroy);
    this.trigger(this.eventTypes.destroy);
    this.scroller.destroy();
  };

  BScrollConstructor.prototype.eventRegister = function (names) {
    this.registerType(names);
  };

  BScrollConstructor.plugins = [];
  BScrollConstructor.pluginsMap = {};
  return BScrollConstructor;
}(EventEmitter);

function createBScroll(el, options) {
  var bs = new BScrollConstructor(el, options);
  return bs;
}

createBScroll.use = BScrollConstructor.use;
createBScroll.plugins = BScrollConstructor.plugins;
createBScroll.pluginsMap = BScrollConstructor.pluginsMap;
var BScroll = createBScroll;
/*!
 * better-scroll / pull-up
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
// ssr support

var inBrowser$2 = typeof window !== 'undefined';
var ua$2 = inBrowser$2 && navigator.userAgent.toLowerCase();
!!(ua$2 && /wechatdevtools/.test(ua$2));
ua$2 && ua$2.indexOf('android') > 0;
/* istanbul ignore next */

(function () {
  if (typeof ua$2 === 'string') {
    var regex = /os (\d\d?_\d(_\d)?)/;
    var matches = regex.exec(ua$2);
    if (!matches) return false;
    var parts = matches[1].split('_').map(function (item) {
      return parseInt(item, 10);
    }); // ios version >= 13.4 issue 982

    return !!(parts[0] === 13 && parts[1] >= 4);
  }

  return false;
})();
/* istanbul ignore next */


if (inBrowser$2) {
  var EventName$2 = 'test-passive';

  try {
    var opts$2 = {};
    Object.defineProperty(opts$2, 'passive', {
      get: function get() {}
    }); // https://github.com/facebook/flow/issues/285

    window.addEventListener(EventName$2, function () {}, opts$2);
  } catch (e) {}
}

var extend$2 = function extend$2(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
};

var elementStyle$2 = inBrowser$2 && document.createElement('div').style;

var vendor$2 = function () {
  /* istanbul ignore if  */
  if (!inBrowser$2) {
    return false;
  }

  var transformNames = [{
    key: 'standard',
    value: 'transform'
  }, {
    key: 'webkit',
    value: 'webkitTransform'
  }, {
    key: 'Moz',
    value: 'MozTransform'
  }, {
    key: 'O',
    value: 'OTransform'
  }, {
    key: 'ms',
    value: 'msTransform'
  }];

  for (var _i = 0, transformNames_1 = transformNames; _i < transformNames_1.length; _i++) {
    var obj = transformNames_1[_i];

    if (elementStyle$2[obj.value] !== undefined) {
      return obj.key;
    }
  }
  /* istanbul ignore next  */


  return false;
}();
/* istanbul ignore next  */


function prefixStyle$2(style) {
  if (vendor$2 === false) {
    return style;
  }

  if (vendor$2 === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }

    return style;
  }

  return vendor$2 + style.charAt(0).toUpperCase() + style.substr(1);
}

vendor$2 && vendor$2 !== 'standard' ? '-' + vendor$2.toLowerCase() + '-' : '';
var transform$2 = prefixStyle$2('transform');
var transition$2 = prefixStyle$2('transition');
inBrowser$2 && prefixStyle$2('perspective') in elementStyle$2;
({
  transform: transform$2,
  transition: transition$2,
  transitionTimingFunction: prefixStyle$2('transitionTimingFunction'),
  transitionDuration: prefixStyle$2('transitionDuration'),
  transitionDelay: prefixStyle$2('transitionDelay'),
  transformOrigin: prefixStyle$2('transformOrigin'),
  transitionEnd: prefixStyle$2('transitionEnd'),
  transitionProperty: prefixStyle$2('transitionProperty')
});
var sourcePrefix$1 = 'plugins.pullUpLoad';
var propertiesMap$1 = [{
  key: 'finishPullUp',
  name: 'finishPullUp'
}, {
  key: 'openPullUp',
  name: 'openPullUp'
}, {
  key: 'closePullUp',
  name: 'closePullUp'
}, {
  key: 'autoPullUpLoad',
  name: 'autoPullUpLoad'
}];
var propertiesConfig$1 = propertiesMap$1.map(function (item) {
  return {
    key: item.key,
    sourceKey: sourcePrefix$1 + "." + item.name
  };
});
var PULL_UP_HOOKS_NAME = 'pullingUp';

var PullUp =
/** @class */
function () {
  function PullUp(scroll) {
    this.scroll = scroll;
    this.pulling = false;
    this.watching = false;
    this.init();
  }

  PullUp.prototype.init = function () {
    this.handleBScroll();
    this.handleOptions(this.scroll.options.pullUpLoad);
    this.handleHooks();
    this.watch();
  };

  PullUp.prototype.handleBScroll = function () {
    this.scroll.registerType([PULL_UP_HOOKS_NAME]);
    this.scroll.proxy(propertiesConfig$1);
  };

  PullUp.prototype.handleOptions = function (userOptions) {
    if (userOptions === void 0) {
      userOptions = {};
    }

    userOptions = userOptions === true ? {} : userOptions;
    var defaultOptions = {
      threshold: 0
    };
    this.options = extend$2(defaultOptions, userOptions);
    this.scroll.options.probeType = 3
    /* Realtime */
    ;
  };

  PullUp.prototype.handleHooks = function () {
    var _this = this;

    this.hooksFn = [];
    var scrollBehaviorY = this.scroll.scroller.scrollBehaviorY;
    this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.contentChanged, function () {
      _this.finishPullUp();
    });
    this.registerHooks(scrollBehaviorY.hooks, scrollBehaviorY.hooks.eventTypes.computeBoundary, function (boundary) {
      // content is smaller than wrapper
      if (boundary.maxScrollPos > 0) {
        // allow scrolling when content is not full of wrapper
        boundary.maxScrollPos = -1;
      }
    });
  };

  PullUp.prototype.registerHooks = function (hooks, name, handler) {
    hooks.on(name, handler, this);
    this.hooksFn.push([hooks, name, handler]);
  };

  PullUp.prototype.watch = function () {
    if (this.watching) {
      return;
    }

    this.watching = true;
    this.registerHooks(this.scroll, this.scroll.eventTypes.scroll, this.checkPullUp);
  };

  PullUp.prototype.unwatch = function () {
    this.watching = false;
    this.scroll.off(this.scroll.eventTypes.scroll, this.checkPullUp);
  };

  PullUp.prototype.checkPullUp = function (pos) {
    var _this = this;

    var threshold = this.options.threshold;

    if (this.scroll.movingDirectionY === 1
    /* Positive */
    && pos.y <= this.scroll.maxScrollY + threshold) {
      this.pulling = true; // must reset pulling after scrollEnd

      this.scroll.once(this.scroll.eventTypes.scrollEnd, function () {
        _this.pulling = false;
      });
      this.unwatch();
      this.scroll.trigger(PULL_UP_HOOKS_NAME);
    }
  };

  PullUp.prototype.finishPullUp = function () {
    var _this = this; // reset Direction, fix #936


    this.scroll.scroller.scrollBehaviorY.setMovingDirection(0
    /* Default */
    );

    if (this.pulling) {
      this.scroll.once(this.scroll.eventTypes.scrollEnd, function () {
        _this.watch();
      });
    } else {
      this.watch();
    }
  }; // allow 'true' type is compat for beta version implements


  PullUp.prototype.openPullUp = function (config) {
    if (config === void 0) {
      config = {};
    }

    this.handleOptions(config);
    this.watch();
  };

  PullUp.prototype.closePullUp = function () {
    this.unwatch();
  };

  PullUp.prototype.autoPullUpLoad = function () {
    var threshold = this.options.threshold;
    var scrollBehaviorY = this.scroll.scroller.scrollBehaviorY;

    if (this.pulling || !this.watching) {
      return;
    } // simulate a pullUp action


    var NEGATIVE_VALUE = -1;
    var outOfBoundaryPos = scrollBehaviorY.maxScrollPos + threshold + NEGATIVE_VALUE;
    this.scroll.scroller.scrollBehaviorY.setMovingDirection(NEGATIVE_VALUE);
    this.scroll.scrollTo(this.scroll.x, outOfBoundaryPos, this.scroll.options.bounceTime);
  };

  PullUp.pluginName = 'pullUpLoad';
  return PullUp;
}();
/*!
 * better-scroll / mouse-wheel
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */


function warn(msg) {
  console.error("[BScroll warn]: " + msg);
} // ssr support


var inBrowser$1 = typeof window !== 'undefined';
var ua$1 = inBrowser$1 && navigator.userAgent.toLowerCase();
!!(ua$1 && /wechatdevtools/.test(ua$1));
ua$1 && ua$1.indexOf('android') > 0;
/* istanbul ignore next */

(function () {
  if (typeof ua$1 === 'string') {
    var regex = /os (\d\d?_\d(_\d)?)/;
    var matches = regex.exec(ua$1);
    if (!matches) return false;
    var parts = matches[1].split('_').map(function (item) {
      return parseInt(item, 10);
    }); // ios version >= 13.4 issue 982

    return !!(parts[0] === 13 && parts[1] >= 4);
  }

  return false;
})();
/* istanbul ignore next */


var supportsPassive = false;
/* istanbul ignore next */

if (inBrowser$1) {
  var EventName$1 = 'test-passive';

  try {
    var opts$1 = {};
    Object.defineProperty(opts$1, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    }); // https://github.com/facebook/flow/issues/285

    window.addEventListener(EventName$1, function () {}, opts$1);
  } catch (e) {}
}

var extend$1 = function extend$1(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
};

var elementStyle$1 = inBrowser$1 && document.createElement('div').style;

var vendor$1 = function () {
  /* istanbul ignore if  */
  if (!inBrowser$1) {
    return false;
  }

  var transformNames = [{
    key: 'standard',
    value: 'transform'
  }, {
    key: 'webkit',
    value: 'webkitTransform'
  }, {
    key: 'Moz',
    value: 'MozTransform'
  }, {
    key: 'O',
    value: 'OTransform'
  }, {
    key: 'ms',
    value: 'msTransform'
  }];

  for (var _i = 0, transformNames_1 = transformNames; _i < transformNames_1.length; _i++) {
    var obj = transformNames_1[_i];

    if (elementStyle$1[obj.value] !== undefined) {
      return obj.key;
    }
  }
  /* istanbul ignore next  */


  return false;
}();
/* istanbul ignore next  */


function prefixStyle$1(style) {
  if (vendor$1 === false) {
    return style;
  }

  if (vendor$1 === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }

    return style;
  }

  return vendor$1 + style.charAt(0).toUpperCase() + style.substr(1);
}

function addEvent(el, type, fn, capture) {
  var useCapture = supportsPassive ? {
    passive: false,
    capture: !!capture
  } : !!capture;
  el.addEventListener(type, fn, useCapture);
}

function removeEvent(el, type, fn, capture) {
  el.removeEventListener(type, fn, {
    capture: !!capture
  });
}

vendor$1 && vendor$1 !== 'standard' ? '-' + vendor$1.toLowerCase() + '-' : '';
var transform$1 = prefixStyle$1('transform');
var transition$1 = prefixStyle$1('transition');
inBrowser$1 && prefixStyle$1('perspective') in elementStyle$1;
({
  transform: transform$1,
  transition: transition$1,
  transitionTimingFunction: prefixStyle$1('transitionTimingFunction'),
  transitionDuration: prefixStyle$1('transitionDuration'),
  transitionDelay: prefixStyle$1('transitionDelay'),
  transformOrigin: prefixStyle$1('transformOrigin'),
  transitionEnd: prefixStyle$1('transitionEnd'),
  transitionProperty: prefixStyle$1('transitionProperty')
});

function preventDefaultExceptionFn$1(el, exceptions) {
  for (var i in exceptions) {
    if (exceptions[i].test(el[i])) {
      return true;
    }
  }

  return false;
}

var EventRegister =
/** @class */
function () {
  function EventRegister(wrapper, events) {
    this.wrapper = wrapper;
    this.events = events;
    this.addDOMEvents();
  }

  EventRegister.prototype.destroy = function () {
    this.removeDOMEvents();
    this.events = [];
  };

  EventRegister.prototype.addDOMEvents = function () {
    this.handleDOMEvents(addEvent);
  };

  EventRegister.prototype.removeDOMEvents = function () {
    this.handleDOMEvents(removeEvent);
  };

  EventRegister.prototype.handleDOMEvents = function (eventOperation) {
    var _this = this;

    var wrapper = this.wrapper;
    this.events.forEach(function (event) {
      eventOperation(wrapper, event.name, _this, !!event.capture);
    });
  };

  EventRegister.prototype.handleEvent = function (e) {
    var eventType = e.type;
    this.events.some(function (event) {
      if (event.name === eventType) {
        event.handler(e);
        return true;
      }

      return false;
    });
  };

  return EventRegister;
}();

var MouseWheel =
/** @class */
function () {
  function MouseWheel(scroll) {
    this.scroll = scroll;
    this.wheelEndTimer = 0;
    this.wheelMoveTimer = 0;
    this.wheelStart = false;
    this.init();
  }

  MouseWheel.prototype.init = function () {
    this.handleBScroll();
    this.handleOptions();
    this.handleHooks();
    this.registerEvent();
  };

  MouseWheel.prototype.handleBScroll = function () {
    this.scroll.registerType(['alterOptions', 'mousewheelStart', 'mousewheelMove', 'mousewheelEnd']);
  };

  MouseWheel.prototype.handleOptions = function () {
    var userOptions = this.scroll.options.mouseWheel === true ? {} : this.scroll.options.mouseWheel;
    var defaultOptions = {
      speed: 20,
      invert: false,
      easeTime: 300,
      discreteTime: 400,
      throttleTime: 0,
      dampingFactor: 0.1
    };
    this.mouseWheelOpt = extend$1(defaultOptions, userOptions);
  };

  MouseWheel.prototype.handleHooks = function () {
    this.hooksFn = [];
    this.registerHooks(this.scroll.hooks, 'destroy', this.destroy);
  };

  MouseWheel.prototype.registerEvent = function () {
    this.eventRegister = new EventRegister(this.scroll.scroller.wrapper, [{
      name: 'wheel',
      handler: this.wheelHandler.bind(this)
    }, {
      name: 'mousewheel',
      handler: this.wheelHandler.bind(this)
    }, {
      name: 'DOMMouseScroll',
      handler: this.wheelHandler.bind(this)
    }]);
  };

  MouseWheel.prototype.registerHooks = function (hooks, name, handler) {
    hooks.on(name, handler, this);
    this.hooksFn.push([hooks, name, handler]);
  };

  MouseWheel.prototype.wheelHandler = function (e) {
    if (!this.scroll.enabled) {
      return;
    }

    this.beforeHandler(e); // start

    if (!this.wheelStart) {
      this.wheelStartHandler(e);
      this.wheelStart = true;
    } // move


    var delta = this.getWheelDelta(e);
    this.wheelMoveHandler(delta); // end

    this.wheelEndDetector(delta);
  };

  MouseWheel.prototype.wheelStartHandler = function (e) {
    this.cleanCache();
    var _a = this.scroll.scroller,
        scrollBehaviorX = _a.scrollBehaviorX,
        scrollBehaviorY = _a.scrollBehaviorY;
    scrollBehaviorX.setMovingDirection(0
    /* Default */
    );
    scrollBehaviorY.setMovingDirection(0
    /* Default */
    );
    scrollBehaviorX.setDirection(0
    /* Default */
    );
    scrollBehaviorY.setDirection(0
    /* Default */
    );
    this.scroll.trigger(this.scroll.eventTypes.alterOptions, this.mouseWheelOpt);
    this.scroll.trigger(this.scroll.eventTypes.mousewheelStart);
  };

  MouseWheel.prototype.cleanCache = function () {
    this.deltaCache = [];
  };

  MouseWheel.prototype.wheelMoveHandler = function (delta) {
    var _this = this;

    var _a = this.mouseWheelOpt,
        throttleTime = _a.throttleTime,
        dampingFactor = _a.dampingFactor;

    if (throttleTime && this.wheelMoveTimer) {
      this.deltaCache.push(delta);
    } else {
      var cachedDelta = this.deltaCache.reduce(function (prev, current) {
        return {
          x: prev.x + current.x,
          y: prev.y + current.y
        };
      }, {
        x: 0,
        y: 0
      });
      this.cleanCache();
      var _b = this.scroll.scroller,
          scrollBehaviorX = _b.scrollBehaviorX,
          scrollBehaviorY = _b.scrollBehaviorY;
      scrollBehaviorX.setMovingDirection(-delta.directionX);
      scrollBehaviorY.setMovingDirection(-delta.directionY);
      scrollBehaviorX.setDirection(delta.x);
      scrollBehaviorY.setDirection(delta.y); // when out of boundary, perform a damping scroll

      var newX = scrollBehaviorX.performDampingAlgorithm(Math.round(delta.x) + cachedDelta.x, dampingFactor);
      var newY = scrollBehaviorY.performDampingAlgorithm(Math.round(delta.y) + cachedDelta.x, dampingFactor);

      if (!this.scroll.trigger(this.scroll.eventTypes.mousewheelMove, {
        x: newX,
        y: newY
      })) {
        var easeTime = this.getEaseTime();

        if (newX !== this.scroll.x || newY !== this.scroll.y) {
          this.scroll.scrollTo(newX, newY, easeTime);
        }
      }

      if (throttleTime) {
        this.wheelMoveTimer = window.setTimeout(function () {
          _this.wheelMoveTimer = 0;
        }, throttleTime);
      }
    }
  };

  MouseWheel.prototype.wheelEndDetector = function (delta) {
    var _this = this;

    window.clearTimeout(this.wheelEndTimer);
    this.wheelEndTimer = window.setTimeout(function () {
      _this.wheelStart = false;
      window.clearTimeout(_this.wheelMoveTimer);
      _this.wheelMoveTimer = 0;

      _this.scroll.trigger(_this.scroll.eventTypes.mousewheelEnd, delta);
    }, this.mouseWheelOpt.discreteTime);
  };

  MouseWheel.prototype.getWheelDelta = function (e) {
    var _a = this.mouseWheelOpt,
        speed = _a.speed,
        invert = _a.invert;
    var wheelDeltaX = 0;
    var wheelDeltaY = 0;
    var direction = invert ? -1
    /* Negative */
    : 1
    /* Positive */
    ;

    switch (true) {
      case 'deltaX' in e:
        if (e.deltaMode === 1) {
          wheelDeltaX = -e.deltaX * speed;
          wheelDeltaY = -e.deltaY * speed;
        } else {
          wheelDeltaX = -e.deltaX;
          wheelDeltaY = -e.deltaY;
        }

        break;

      case 'wheelDeltaX' in e:
        wheelDeltaX = e.wheelDeltaX / 120 * speed;
        wheelDeltaY = e.wheelDeltaY / 120 * speed;
        break;

      case 'wheelDelta' in e:
        wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * speed;
        break;

      case 'detail' in e:
        wheelDeltaX = wheelDeltaY = -e.detail / 3 * speed;
        break;
    }

    wheelDeltaX *= direction;
    wheelDeltaY *= direction;

    if (!this.scroll.hasVerticalScroll) {
      if (Math.abs(wheelDeltaY) > Math.abs(wheelDeltaX)) {
        wheelDeltaX = wheelDeltaY;
      }

      wheelDeltaY = 0;
    }

    if (!this.scroll.hasHorizontalScroll) {
      wheelDeltaX = 0;
    }

    var directionX = wheelDeltaX > 0 ? -1
    /* Negative */
    : wheelDeltaX < 0 ? 1
    /* Positive */
    : 0
    /* Default */
    ;
    var directionY = wheelDeltaY > 0 ? -1
    /* Negative */
    : wheelDeltaY < 0 ? 1
    /* Positive */
    : 0
    /* Default */
    ;
    return {
      x: wheelDeltaX,
      y: wheelDeltaY,
      directionX: directionX,
      directionY: directionY
    };
  };

  MouseWheel.prototype.beforeHandler = function (e) {
    var _a = this.scroll.options,
        preventDefault = _a.preventDefault,
        stopPropagation = _a.stopPropagation,
        preventDefaultException = _a.preventDefaultException;

    if (preventDefault && !preventDefaultExceptionFn$1(e.target, preventDefaultException)) {
      e.preventDefault();
    }

    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  MouseWheel.prototype.getEaseTime = function () {
    var SAFE_EASETIME = 100;
    var easeTime = this.mouseWheelOpt.easeTime; // scrollEnd event will be triggered in every calling of scrollTo when easeTime is too small
    // easeTime needs to be greater than 100

    if (easeTime < SAFE_EASETIME) {
      warn("easeTime should be greater than 100." + "If mouseWheel easeTime is too small," + "scrollEnd will be triggered many times.");
    }

    return Math.max(easeTime, SAFE_EASETIME);
  };

  MouseWheel.prototype.destroy = function () {
    this.eventRegister.destroy();
    window.clearTimeout(this.wheelEndTimer);
    window.clearTimeout(this.wheelMoveTimer);
    this.hooksFn.forEach(function (item) {
      var hooks = item[0];
      var hooksName = item[1];
      var handlerFn = item[2];
      hooks.off(hooksName, handlerFn);
    });
  };

  MouseWheel.pluginName = 'mouseWheel';
  MouseWheel.applyOrder = "pre"
  /* Pre */
  ;
  return MouseWheel;
}(); // eslint-disable-next-line func-names


MouseWheel.prototype.wheelMoveHandler = function (delta) {
  var _this = this;

  var _a = this.mouseWheelOpt;
  var throttleTime = _a.throttleTime;
  var dampingFactor = _a.dampingFactor;

  if (throttleTime && this.wheelMoveTimer) {
    this.deltaCache.push(delta);
  } else {
    var cachedDelta = this.deltaCache.reduce(function (prev, current) {
      return {
        x: prev.x + current.x,
        y: prev.y + current.y
      };
    }, {
      x: 0,
      y: 0
    });
    this.cleanCache();
    var _b2 = this.scroll.scroller;
    var scrollBehaviorX = _b2.scrollBehaviorX;
    var scrollBehaviorY = _b2.scrollBehaviorY;
    scrollBehaviorX.setMovingDirection(-delta.directionX);
    scrollBehaviorY.setMovingDirection(-delta.directionY);
    scrollBehaviorX.setDirection(delta.x);
    scrollBehaviorY.setDirection(delta.y); // when out of boundary, perform a damping scroll

    var newX = scrollBehaviorX.performDampingAlgorithm(Math.round(delta.x) + cachedDelta.x, dampingFactor);
    var newY = scrollBehaviorY.performDampingAlgorithm(Math.round(delta.y) + cachedDelta.x, dampingFactor);

    if (!this.scroll.trigger(this.scroll.eventTypes.mousewheelMove, {
      x: newX,
      y: newY
    })) {
      var easeTime = this.getEaseTime();

      if (newX !== this.scroll.x || newY !== this.scroll.y) {
        // 如果是苹果触摸板，在加速度为负的情况下，会造成直接瞬间回到0位，视觉效果太差
        if (Math.abs(this.scroll.y - newY) < 1) {
          if (this.scroll.y > newY) {
            newY = this.scroll.y - 1.01;
          } else {
            newY = this.scroll.y + 1.01;
          }
        }

        this.scroll.scrollTo(newX, newY, easeTime);
      }
    }

    if (throttleTime) {
      this.wheelMoveTimer = window.setTimeout(function () {
        _this.wheelMoveTimer = 0;
      }, throttleTime);
    }
  }
};

var eventTypeMap = {
  touchstart: 1,
  touchmove: 1,
  touchend: 1,
  touchcancel: 1,
  mousedown: 2,
  mousemove: 2,
  mouseup: 2
};

function preventDefaultExceptionFn(el, exceptions) {
  var flag = false;
  Object.keys(exceptions).forEach(function (i) {
    if (exceptions[i].test(el[i])) {
      flag = true;
    }
  });
  return flag;
}

var tagExceptionFn = preventDefaultExceptionFn; // eslint-disable-next-line func-names

var ActionsHandlerStart = function ActionsHandlerStart(e) {
  var _eventType = eventTypeMap[e.type];

  if (this.initiated && this.initiated !== _eventType) {
    return;
  }

  this.setInitiated(_eventType); // if textarea or other html tags in options.tagException is manipulated
  // do not make bs scroll

  if (tagExceptionFn(e.target, this.options.tagException)) {
    this.setInitiated();
    return;
  } // only allow mouse left button


  if (_eventType === 2
  /* Mouse */
  && e.button !== 0
  /* Left */
  ) {
    this.setInitiated(); // 防止按下右键进行拖拽

    return;
  }

  if (this.hooks.trigger(this.hooks.eventTypes.beforeStart, e)) {
    return;
  }

  this.beforeHandler(e, 'start');
  var point = e.touches ? e.touches[0] : e;
  this.pointX = point.pageX;
  this.pointY = point.pageY;
  this.hooks.trigger(this.hooks.eventTypes.start, e);
};

var conversationListCss = ".conversation-wrapper{height:100%;background:#fff;position:relative}.conversation-container{height:100%}.pullup-tips{color:#111f2c;height:3.4em;line-height:3.4em;width:100%;text-align:center;font-size:2em}.after-trigger::before{content:' ';display:inline-block;width:1.8em;height:1.8em;background:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+bG9hZGluZzwvdGl0bGU+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9Ijk0LjA4NjkxNDElIiB5MT0iMCUiIHgyPSI5NC4wODY5MTQxJSIgeTI9IjkwLjU1OTA4MiUiIGlkPSJsaW5lYXJHcmFkaWVudC0xIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzhGOTQ5QSIgc3RvcC1vcGFjaXR5PSIwIiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM4Rjk0OUEiIHN0b3Atb3BhY2l0eT0iMC4zIiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iMTAwJSIgeTE9IjguNjczNzA2MDUlIiB4Mj0iMTAwJSIgeTI9IjkwLjYyODY2MjElIiBpZD0ibGluZWFyR3JhZGllbnQtMiI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM4Rjk0OUEiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzhGOTQ5QSIgc3RvcC1vcGFjaXR5PSIwLjMiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIwM1/lkJHkuIvmu5rliqjml7Zsb2FkaW5nIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQyLjAwMDAwMCwgLTkxMS4wMDAwMDApIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZyBpZD0i572R57uc5LiN5Y+v55So5o+Q56S6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNTc5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9ImxvYWRpbmciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0Mi4wMDAwMDAsIDMzMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0i55+p5b2iIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjgiIGhlaWdodD0iMjgiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iTG9hZGluZ0JyYW5kIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjAwMDAwMCwgMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLDAgQzE4LjYyNzQxNywwIDI0LDUuMzcyNTgzIDI0LDEyIEMyNCwxOC42Mjc0MTcgMTguNjI3NDE3LDI0IDEyLDI0IEwxMiwyMS45IEMxNy40Njc2MTksMjEuOSAyMS45LDE3LjQ2NzYxOSAyMS45LDEyIEMyMS45LDYuNTMyMzgwOTkgMTcuNDY3NjE5LDIuMSAxMiwyLjEgTDEyLDAgWiIgaWQ9Iui3r+W+hCIgZmlsbD0idXJsKCNsaW5lYXJHcmFkaWVudC0xKSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIsMCBMMTIsMi4xIEM2LjUzMjM4MDk5LDIuMSAyLjEsNi41MzIzODA5OSAyLjEsMTIgQzIuMSwxNy40Njc2MTkgNi41MzIzODA5OSwyMS45IDEyLDIxLjkgTDEyLDI0IEM1LjM3MjU4MywyNCAwLDE4LjYyNzQxNyAwLDEyIEMwLDUuMzcyNTgzIDUuMzcyNTgzLDAgMTIsMCBaIiBpZD0i6Lev5b6EIiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTIpIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiM4Rjk0OUEiIGN4PSIxMi4xNSIgY3k9IjEuMDUiIHI9IjEuMDUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+) no-repeat;-webkit-animation:loading 1s infinite;animation:loading 1s infinite;vertical-align:middle;margin:0 0.8em 0 0}@-webkit-keyframes loading{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes loading{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.no-data{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-size:2.2em;color:#111f2c;background:#fff}.no-data::before{content:' ';display:block;width:5.81818em;height:5.81818em;background:url(data:image/svg+xml;base64,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) no-repeat;margin:0 0 1.04545em}.mentioned{margin:0 0.5em 0 0}";
BScroll.use(PullUp);
BScroll.use(MouseWheel);

var ConversationList$1 = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(ConversationList$1, _HTMLElement4);

  var _super6 = _createSuper(ConversationList$1);

  function ConversationList$1() {
    var _this41;

    _classCallCheck(this, ConversationList$1);

    _this41 = _super6.call(this);

    _this41.__registerHost();

    attachShadow(_assertThisInitialized(_this41));
    _this41.updateConversation = createEvent(_assertThisInitialized(_this41), "updateConversation", 7);
    _this41.tapConversation = createEvent(_assertThisInitialized(_this41), "tapConversation", 7);
    _this41.deleteConversation = createEvent(_assertThisInitialized(_this41), "deleteConversation", 7);
    _this41.baseSize = '16px';
    _this41.isPullUpLoad = false;
    _this41.data = [];
    _this41.lang = core.lang; // 禁用菜单

    _this41.disableMenu = []; // 免打扰状态下是否展示未读数

    _this41.hideNotificUnreadCount = false; // 是否为获取更多历史会话
    // private isGetHistory: boolean = false;
    // 离线消息是否拉取完成

    _this41.offlineMessageFinished = false; // 节流获取会话列表

    _this41.getConListThrottle = throttle(_this41.getConversationList, 1000);
    _this41.contextMenuData = {
      visible: false
    };
    _this41.getConversationList = _this41.getConversationList.bind(_assertThisInitialized(_this41));
    _this41.handleUpdateConversation = _this41.handleUpdateConversation.bind(_assertThisInitialized(_this41));
    _this41.switchConversation = _this41.switchConversation.bind(_assertThisInitialized(_this41));
    _this41.hideContextMenu = _this41.hideContextMenu.bind(_assertThisInitialized(_this41));
    _this41.handleTopStatusChange = _this41.handleTopStatusChange.bind(_assertThisInitialized(_this41));
    _this41.handleDelete = _this41.handleDelete.bind(_assertThisInitialized(_this41));
    _this41.handleNotificationStatusChange = _this41.handleNotificationStatusChange.bind(_assertThisInitialized(_this41));
    _this41.pullingUpHandler = _this41.pullingUpHandler.bind(_assertThisInitialized(_this41));
    _this41.handleSelectConversation = _this41.handleSelectConversation.bind(_assertThisInitialized(_this41));
    _this41.handleMouseLeave = _this41.handleMouseLeave.bind(_assertThisInitialized(_this41));
    _this41.handleLanguageChanged = _this41.handleLanguageChanged.bind(_assertThisInitialized(_this41));
    _this41.handleConversationInfoChanged = _this41.handleConversationInfoChanged.bind(_assertThisInitialized(_this41));
    return _this41;
  }

  _createClass(ConversationList$1, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      var _this42 = this;

      // 会话列表更新
      core.on(CoreEvent.CONVERSATION, this.handleConversationInfoChanged);
      core.on(CoreEvent.UPDATE_CONVERSATION, this.handleUpdateConversation);
      core.on(CoreEvent.SWITCH_CONVERSATION, this.switchConversation);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.on(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleConversationInfoChanged);
      core.on(CoreEvent.CONNECTED, function (connectStatus) {
        _this42.offlineMessageFinished = false;

        if (connectStatus) {
          _this42.getConversationList(true);

          return;
        }

        _this42.data = [];
      });
      core.on(CoreEvent.PULL_OFFLINE_MESSAGE_FINISHED, function () {
        _this42.offlineMessageFinished = true;
      });
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      var connectStatus = getConnectionStatus();

      if (connectStatus === RCConnectionStatus.CONNECTED) {
        // 组件每次重载并不需要获取远端，防止每次切页面都进行远端拉取
        this.getConversationList();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.CONVERSATION, this.handleConversationInfoChanged);
      core.off(CoreEvent.UPDATE_CONVERSATION, this.handleUpdateConversation);
      core.off(CoreEvent.SWITCH_CONVERSATION, this.switchConversation);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.off(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleConversationInfoChanged);

      if (this.bscroll) {
        this.bscroll.off('pullingUp', this.pullingUpHandler);
        this.bscroll.destroy();
      }
    }
  }, {
    key: "handleConversationInfoChanged",
    value: function handleConversationInfoChanged() {
      // 在离线消息拉取完成前做节流处理，防止离线消息拉取过程中变动过于频繁[频繁跟应用要会话数据]
      if (this.offlineMessageFinished) {
        this.getConversationList();
      } else {
        this.getConListThrottle();
      }
    }
  }, {
    key: "getConversationList",
    value: function getConversationList() {
      var _this43 = this;

      var more = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return core.getConversationList(more).then(function (list) {
        _this43.data = list;
      });
    }
    /**
     * 更新会话
     * @param conversations
     */

  }, {
    key: "handleUpdateConversation",
    value: function handleUpdateConversation() {
      var _this44 = this;

      var conversations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      conversations.forEach(function (conversation) {
        var index = _this44.data.findIndex(function (one) {
          return one.conversation && isEqual(one.conversation, conversation);
        });

        if (index !== -1) {
          _this44.data[index].conversation = conversation;
        } else {
          // 如会话为新增会话，则延迟 500ms 更新，防止多次触发客户的获取详情接口
          // 存在风险，当网路延迟较高时 500ms 没有拿到数据会造成获取两遍会话详情情况，等待监听通知逻辑重构后解决此问题。
          // TODO 待优化
          setTimeout(function () {
            core.getConversationProfile(conversation).then(function (res) {
              var con = {
                conversation: conversation,
                profile: res
              }; // 异步过程中，this.data 可能已经被其他操作改变，所以需要重新获取一次 index

              var index2 = _this44.data.findIndex(function (one) {
                return one.conversation && isEqual(one.conversation, conversation);
              });

              if (index2 !== -1) {
                _this44.data[index2] = con;
              } else {
                var firstUnTopIndex = _this44.data.findIndex(function (one) {
                  return !one.conversation.isTop;
                });

                if (firstUnTopIndex !== -1) {
                  _this44.data.splice(firstUnTopIndex, 0, con);

                  _this44.data = deepClone(_this44.data);
                } else {
                  _this44.data.push(con);
                }
              }
            });
          }, 500);
        }
      });

      if (conversations.length) {
        this.data = deepClone(this.data);
      }
    }
  }, {
    key: "switchConversation",
    value: function switchConversation(conversation) {
      this.currentConversation = conversation;
    }
  }, {
    key: "createScroll",
    value: function createScroll() {
      var _this45 = this;

      if (!this.scrollWrapper) {
        return;
      }

      this.bscroll = new BScroll(this.scrollWrapper, {
        bindToWrapper: true,
        mouseWheel: {
          throttleTime: 30
        },
        scrollX: false,
        scrollY: true,
        pullUpLoad: true,
        click: true,
        bounce: {
          top: false,
          bottom: true,
          left: false,
          right: false
        }
      });
      this.bscroll.on('pullingUp', this.pullingUpHandler); // 防止右键进行拖拽

      this.bscroll.scroller.actionsHandler.wrapperEventRegister.events.forEach(function (e) {
        var event = e;

        if (event.name === 'mousedown') {
          event.handler = ActionsHandlerStart.bind(_this45.bscroll.scroller.actionsHandler);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.bscroll && this.scrollWrapper) {
        this.createScroll();
      } // if (this.isGetHistory) {
      // 渲染需要时间，因此需要等待刷新
      // this.isGetHistory = false;


      if (this.bscroll) {
        this.bscroll.refresh();
      } // }

    }
    /**
     * 上拉获取更多
     */

  }, {
    key: "pullingUpHandler",
    value: function pullingUpHandler() {
      var _this46 = this;

      this.isPullUpLoad = true; // 先显示正在加载，然后开始加载，保证下拉效果的顺滑

      setTimeout(function () {
        _this46.getConversationList(true).then(function () {
          setTimeout(function () {
            _this46.isPullUpLoad = false;

            _this46.bscroll.finishPullUp();
          }, 200);
        });
      }, 1000);
    }
  }, {
    key: "handleConversationRightClick",
    value: function handleConversationRightClick(conversation, e) {
      e.preventDefault();
      var top = e.clientY;
      var left = e.clientX;
      this.contextMenuData = {
        visible: true,
        position: {
          top: top,
          left: left
        },
        topStatus: conversation.isTop,
        notificationStatus: conversation.notificationStatus === 1
      };
      this.operatedConversation = conversation;
    }
  }, {
    key: "hideContextMenu",
    value: function hideContextMenu() {
      this.contextMenuData = {
        visible: false
      };
    }
  }, {
    key: "handleTopStatusChange",
    value: function handleTopStatusChange(event) {
      if (event === undefined) {
        return;
      }

      core.setConversationToTop({
        conversationType: this.operatedConversation.conversationType,
        targetId: this.operatedConversation.targetId,
        channelId: this.operatedConversation.channelId
      }, event.detail);
    }
  }, {
    key: "handleNotificationStatusChange",
    value: function handleNotificationStatusChange(event) {
      if (event === undefined) {
        return;
      }

      core.setConversationNotificationStatus({
        conversationType: this.operatedConversation.conversationType,
        targetId: this.operatedConversation.targetId,
        channelId: this.operatedConversation.channelId
      }, event.detail ? NotificationStatus.OPEN : NotificationStatus.CLOSE);
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      var _this47 = this;

      var conversation = {
        conversationType: this.operatedConversation.conversationType,
        targetId: this.operatedConversation.targetId,
        channelId: this.operatedConversation.channelId || ''
      };

      core._deleteConversation(conversation).then(function () {
        // 删除会话数据不需要拉远端会话
        _this47.getConversationList();

        _this47.deleteConversation.emit(conversation);
      });
    }
  }, {
    key: "handleSelectConversation",
    value: function handleSelectConversation(event) {
      core.selectConversation(event.detail);
      this.tapConversation.emit(event.detail);
    }
  }, {
    key: "isHover",
    value: function isHover(conversation) {
      if (!this.currentConversation) {
        return false;
      }

      return conversation.channelId === this.currentConversation.channelId && conversation.targetId === this.currentConversation.targetId && conversation.conversationType === this.currentConversation.conversationType;
    }
  }, {
    key: "getPullupTip",
    value: function getPullupTip() {
      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var locale = this.locale;

      if (this.isPullUpLoad) {
        return h("div", {
          "class": "after-trigger"
        }, h("span", {
          "class": "pullup-txt"
        }, locale.conversation.loading));
      }

      if ('ontouchstart' in window && !this.isPullUpLoad) {
        return h("div", {
          "class": "before-trigger"
        }, h("span", {
          "class": "pullup-txt"
        }, locale.conversation.forMore));
      }

      return null;
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      if (this.bscroll) {
        this.bscroll.stop(); // 鼠标按住左键移出滚动区域，放开左键后，回到滚动区域依然带动滚动动作。

        this.bscroll.scroller.actionsHandler.setInitiated();
      }
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "render",
    value: function render() {
      var _this48 = this;

      core.logger.info(LogTagId.A_KIT_CONVERSATION_RENDER_S, JSON.stringify(this.data.map(function (item) {
        return {
          conversationType: item.conversation.conversationType,
          targetId: item.conversation.targetId,
          unreadMessageCount: item.conversation.unreadMessageCount,
          latestMessageUId: item.conversation.latestMessage.messageUId,
          latestMessageTime: item.conversation.latestMessage.sentTime,
          channelId: item.conversation.channelId
        };
      })));
      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var contextMenuData = this.contextMenuData,
          locale = this.locale;
      return h("div", {
        "class": "conversation-wrapper",
        style: {
          fontSize: this.baseSize
        }
      }, this.data.length ? h("conversation-context-menu", Object.assign({}, contextMenuData, {
        conversation: this.operatedConversation,
        onHide: this.hideContextMenu,
        onTopStatusChange: this.handleTopStatusChange,
        onNotificationStatusChange: this.handleNotificationStatusChange,
        onDelete: this.handleDelete,
        customMenu: this.customMenu,
        disableMenu: this.disableMenu
      })) : null, this.data.length ? h("div", {
        "class": "conversation-container",
        ref: function ref(el) {
          _this48.scrollWrapper = el;
          return _this48.scrollWrapper;
        }
      }, h("div", {
        "class": "conversation-scroll-wrapper",
        onMouseLeave: this.handleMouseLeave
      }, h("div", {
        "class": "conversation-list"
      }, this.data.map(function (one) {
        return h("conversation-item", {
          key: "".concat(one.conversation.targetId, "_").concat(one.conversation.channelId, "_").concat(one.conversation.conversationType),
          isHover: _this48.isHover(one.conversation),
          hideNotificUnreadCount: _this48.hideNotificUnreadCount,
          data: one,
          onContextMenu: function onContextMenu(e) {
            return _this48.handleConversationRightClick(one.conversation, e);
          },
          onSelectConversation: _this48.handleSelectConversation
        });
      })), h("div", {
        "class": "pullup-tips"
      }, this.data.length ? this.getPullupTip() : null))) : h("div", {
        "class": "no-data"
      }, h("span", null, locale.conversation.noData)));
    }
  }], [{
    key: "style",
    get: function get() {
      return conversationListCss;
    }
  }]);

  return ConversationList$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var memberListCss = ".member-list{min-width:14em;max-width:30em;max-height:16em;background:#ffffff;-webkit-box-shadow:0em 0em 1.5em 0.3em rgba(100, 102, 109, 0.19);box-shadow:0em 0em 1.5em 0.3em rgba(100, 102, 109, 0.19);border-radius:0.4em;overflow:auto;position:fixed}.member-list ul{padding:0;margin:0;list-style:none}.member-list li{width:100%;height:4em;line-height:4em;cursor:pointer;padding:0 1em;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:1.3em}.member-list li:hover{background:#dfdfdf}";

var MessageEditor$2 = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(MessageEditor$2, _HTMLElement5);

  var _super7 = _createSuper(MessageEditor$2);

  function MessageEditor$2() {
    var _this49;

    _classCallCheck(this, MessageEditor$2);

    _this49 = _super7.call(this);

    _this49.__registerHost();

    _this49.close = createEvent(_assertThisInitialized(_this49), "close", 7);
    _this49.selectMember = createEvent(_assertThisInitialized(_this49), "selectMember", 7);
    _this49.visible = false;
    _this49.memberList = [];
    _this49.position = {
      left: 0,
      top: 0
    };
    _this49.lang = core.lang; // 语言标识

    _this49.selected = false; // 是否选中了一个

    _this49.selectMemberHandler = _this49.selectMemberHandler.bind(_assertThisInitialized(_this49));
    _this49.closeHandler = _this49.closeHandler.bind(_assertThisInitialized(_this49));
    _this49.handleLanguageChanged = _this49.handleLanguageChanged.bind(_assertThisInitialized(_this49));
    _this49.handleGroupInfoChanged = _this49.handleGroupInfoChanged.bind(_assertThisInitialized(_this49));
    return _this49;
  }

  _createClass(MessageEditor$2, [{
    key: "validateWatchConversation",
    value: function validateWatchConversation(newValue, oldValue) {
      if (newValue.conversationType !== oldValue.conversationType || newValue.channelId !== oldValue.channelId || newValue.targetId !== oldValue.targetId) {
        this.getMemberList();
      }
    }
  }, {
    key: "validateWatchVisible",
    value: function validateWatchVisible(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.calcPopPosition();
      }
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      window.addEventListener('click', this.closeHandler, false);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.on(CoreEvent.GROUP_INFO_CHANGED, this.handleGroupInfoChanged);
      this.getMemberList();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.off(CoreEvent.GROUP_INFO_CHANGED, this.handleGroupInfoChanged);
      window.removeEventListener('click', this.closeHandler, false);
    }
  }, {
    key: "closeHandler",
    value: function closeHandler() {
      this.close.emit(this.selected);
      this.selected = false;
    }
  }, {
    key: "getMemberList",
    value: function getMemberList() {
      var _this50 = this;

      if (this.conversation && this.conversation.conversationType === ConversationType$1.GROUP) {
        core.getGroupMembers(this.conversation).then(function (res) {
          if (!res) {
            _this50.memberList = [];
            return;
          }

          _this50.memberList = _toConsumableArray(res); // 将自己从列表中清理出去

          var me = getCurrentUserId();

          var index = _this50.memberList.findIndex(function (member) {
            return member.id === me;
          });

          if (index !== -1) {
            _this50.memberList.splice(index, 1);
          }
        });
      }
    }
  }, {
    key: "selectMemberHandler",
    value: function selectMemberHandler(e) {
      var target = e.target;
      var id = target.getAttribute('data-id');

      if (!id) {
        this.selected = false;
        return;
      }

      var name = target.getAttribute('data-name');
      this.selectMember.emit({
        id: id,
        value: name
      });
      this.selected = true;
    }
  }, {
    key: "calcPopPosition",
    value: function calcPopPosition() {
      var _this51 = this;

      // 隐藏状态，不进行计算
      if (!this.visible) {
        return;
      }

      setTimeout(function () {
        var targetRect = _this51.targetRect || {
          x: 0,
          y: 0,
          height: 0,
          width: 0,
          bottom: 0,
          top: 0,
          left: 0,
          right: 0
        };

        if (!_this51.listRef) {
          return targetRect;
        }

        var position = {
          left: targetRect.x,
          top: targetRect.y
        };

        var rect = _this51.listRef.getBoundingClientRect();

        var width = rect.width || rect.right - rect.left;
        var height = rect.height || rect.bottom - rect.top;
        var docWidth = document.documentElement.clientWidth;
        var docHeight = document.documentElement.clientHeight; // 先定位到targetRect的下面

        var x = targetRect.x;
        var y = targetRect.y + targetRect.height;

        if (x + width > docWidth) {
          position.left = docWidth - width;
        } else if (x < 0) {
          position.left = 0;
        } else {
          position.left = x;
        }

        if (y + height > docHeight) {
          position.top = docHeight - height;
        } else if (position.top < 0) {
          position.top = 0;
        } else {
          position.top = y;
        }

        _this51.position = position;
        return null;
      }, 17);
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "handleGroupInfoChanged",
    value: function handleGroupInfoChanged(info) {
      this.memberList = info;
    }
  }, {
    key: "render",
    value: function render() {
      var _this52 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var memberList = this.memberList,
          visible = this.visible,
          position = this.position,
          locale = this.locale;
      return h("div", {
        "class": "member-list",
        ref: function ref(el) {
          _this52.listRef = el;
          return _this52.listRef;
        },
        style: {
          display: visible ? 'block' : 'none',
          left: "".concat(position.left, "px"),
          top: "".concat(position.top, "px")
        }
      }, h("ul", {
        onClick: this.selectMemberHandler
      }, h("li", {
        "data-id": "all",
        "data-name": locale.other.all
      }, locale.other.all), memberList.map(function (member) {
        return h("li", {
          "data-id": member.id,
          key: member.id,
          "data-name": member.groupNickname || member.name || member.id
        }, member.groupNickname || member.name || member.id);
      })));
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "conversation": ["validateWatchConversation"],
        "visible": ["validateWatchVisible"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return memberListCss;
    }
  }]);

  return MessageEditor$2;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var messageContextMenuCss = ".message-context-menu{font-size:2em;position:fixed;top:0;left:0;z-index:1;min-width:7em;background:#FFFFFF;border-radius:0.2em}.context-menu-box-shadow{-webkit-box-shadow:0em 0em 0.75em 0.15em rgba(100, 102, 109, 0.19);box-shadow:0em 0em 0.75em 0.15em rgba(100, 102, 109, 0.19)}.message-context-menu ul{list-style:none;padding:0;margin:0}.message-context-menu ul li{list-style:none;text-align:center;background:#fff;height:3em;line-height:3em;cursor:pointer;padding:0 1em;color:#111F2C}.message-context-menu ul li:hover{background:#F2F8FF}";

var MessageList$4 = /*#__PURE__*/function (_HTMLElement6) {
  _inherits(MessageList$4, _HTMLElement6);

  var _super8 = _createSuper(MessageList$4);

  function MessageList$4() {
    var _this53;

    _classCallCheck(this, MessageList$4);

    _this53 = _super8.call(this);

    _this53.__registerHost();

    _this53.position = {
      top: 0,
      left: 0
    };
    _this53.visible = false;
    _this53.lang = core.lang; // 语言标识

    _this53.isShowForward = false;
    _this53.msgType = ['RC:TxtMsg', 'RC:FileMsg', 'RC:ImgMsg'];
    _this53.handleCopy = _this53.handleCopy.bind(_assertThisInitialized(_this53));
    _this53.handleReference = _this53.handleReference.bind(_assertThisInitialized(_this53));
    _this53.handleRecall = _this53.handleRecall.bind(_assertThisInitialized(_this53));
    _this53.handleDelete = _this53.handleDelete.bind(_assertThisInitialized(_this53));
    _this53.handlForward = _this53.handlForward.bind(_assertThisInitialized(_this53));
    _this53.hide = _this53.hide.bind(_assertThisInitialized(_this53));
    _this53.handleLanguageChanged = _this53.handleLanguageChanged.bind(_assertThisInitialized(_this53));
    return _this53;
  }

  _createClass(MessageList$4, [{
    key: "watchPosition",
    value: function watchPosition() {
      if (!this.visible) {
        this.visible = true;
      }
    }
  }, {
    key: "watchMessage",
    value: function watchMessage() {// do nothing.
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      document.body.addEventListener('mouseup', this.hide, false);
      window.addEventListener('blur', this.hide, false);
      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.body.removeEventListener('mouseup', this.hide, false);
      window.removeEventListener('blur', this.hide, false);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "handleCopy",
    value: function handleCopy() {
      var item;

      switch (this.message.messageType) {
        case MessageType$1.TEXT:
          item = {
            'text/plain': new Blob([this.message.content.content], {
              type: 'text/plain'
            })
          };
          break;

        default:
          item = null;
      }

      if (!item) {
        throw new Error('No data copied');
      }

      try {
        if (navigator.clipboard) {
          var clipboardObj = navigator.clipboard;
          clipboardObj.write([new ClipboardItem(item)]);
          return;
        }

        var copyInput = document.createElement('input');
        copyInput.setAttribute('id', 'COPY_INPUT');
        copyInput.style.position = 'fixed';
        copyInput.style.left = '-100%';
        copyInput.style.top = '0';
        copyInput.style.zIndex = '-100';
        copyInput.style.opacity = '0';
        document.body.appendChild(copyInput);
        copyInput.value = this.message.content.content;
        copyInput.focus();
        copyInput.select(); // document.execCommand 可能会被废弃

        if (document.execCommand('copy')) {
          document.execCommand('copy');
        }
      } catch (e) {
        core.logger.info(LogTagId.A_KIT_COPY_FAILE_O, JSON.stringify({
          msg: 'Failed to copy',
          e: e
        }));
      }
    }
  }, {
    key: "handleReference",
    value: function handleReference() {
      if (this.message) {
        core.referenceMessage(this.message);
      }
    }
  }, {
    key: "handleRecall",
    value: function handleRecall() {
      if (!this.message || this.message.messageDirection !== MessageDirection$1.SEND) {
        return;
      }

      core.recallMessage(this.message);
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      if (!this.message) {
        return;
      }

      core.deleteMessage(this.message);
    }
  }, {
    key: "handlForward",
    value: function handlForward() {
      var _this54 = this;

      if (!this.message) {
        return;
      }

      var forwardUserList = this.forwardList.callback(this.message);

      if (!isArray(forwardUserList)) {
        core.logger.error(LogTagId.A_KIT_FORWARD_O, 'Forwardlist needs to return an array');
        return;
      }

      if (!notEmptyArray(forwardUserList)) {
        core.logger.error(LogTagId.A_KIT_FORWARD_O, 'Forwarding list is empty');
        return;
      } // 防止发消息超频，lib 1s 客户端最大上行 5 条


      if (forwardUserList.length > 6) {
        core.logger.error(LogTagId.A_KIT_FORWARD_O, 'Forwarding quantity exceeds the limit');
        return;
      }

      forwardUserList.forEach(function (item) {
        var messageContent = _this54.message.content;
        var messageBody;

        switch (_this54.message.messageType) {
          case 'RC:TxtMsg':
            messageBody = new TextMessage$1({
              content: messageContent.content
            });
            break;

          case 'RC:ImgMsg':
            messageBody = new ImageMessage$1({
              content: messageContent.content,
              imageUri: messageContent.imageUri
            });
            break;

          case 'RC:FileMsg':
            messageBody = new FileMessage$1({
              name: messageContent.name,
              size: messageContent.size,
              type: messageContent.type,
              fileUrl: messageContent.fileUrl
            });
            break;
        }

        var conversation = {
          conversationType: item.conversationType,
          targetId: item.targetId
        };
        core.sendMessage(conversation, messageBody, null);
      });
    }
  }, {
    key: "hide",
    value: function hide(e) {
      if (e.button === 2) {
        return;
      }

      if (!this.hide) {
        return;
      }

      this.visible = false;
    }
  }, {
    key: "checkMaxRecallDuration",
    value: function checkMaxRecallDuration() {
      var time = isNumber(this.maxRecallDuration) && this.maxRecallDuration > 0 ? this.maxRecallDuration : 120; // 转换成毫秒

      return time * 1000;
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "createCustomMenu",
    value: function createCustomMenu() {
      var _this55 = this;

      if (!this.customMenu || !this.message) {
        return [];
      }

      var result = [];
      this.customMenu.forEach(function (menu) {
        var name = menu.name(_objectSpread({}, _this55.message));

        if (name) {
          result.push({
            name: name,
            callback: function callback() {
              return menu.callback(_objectSpread({}, _this55.message));
            }
          });
        }
      });
      return result;
    }
  }, {
    key: "getContextMenuStyle",
    value: function getContextMenuStyle(menuHeight, menuWidth) {
      return {
        'z-index': this.visible ? '1' : '-1',
        display: 'block',
        opacity: this.visible ? '1' : '0',
        left: "".concat(this.calculateLeft(menuWidth), "px"),
        top: "".concat(this.calculateTop(menuHeight), "px")
      };
    }
  }, {
    key: "calculateTop",
    value: function calculateTop(menuHeight) {
      var clientHeight = document.documentElement.clientHeight;

      if (this.position) {
        return clientHeight - this.position.top < menuHeight ? this.position.top - menuHeight : this.position.top;
      }

      return 0;
    }
  }, {
    key: "calculateLeft",
    value: function calculateLeft(menuWidth) {
      var clientWidth = document.documentElement.clientWidth;

      if (this.position) {
        return clientWidth - this.position.left < menuWidth ? this.position.left - menuWidth : this.position.left;
      }

      return 0;
    }
  }, {
    key: "getContextMenuCalss",
    value: function getContextMenuCalss(menuNum) {
      var contextMenuBoxShadow = '';

      if (menuNum > 0) {
        contextMenuBoxShadow = 'context-menu-box-shadow';
      }

      return contextMenuBoxShadow;
    }
  }, {
    key: "calculateMenu",
    value: function calculateMenu(customMenu) {
      var menuNum = 0;
      menuNum += customMenu.length;
      var menuHeight = 0;
      var menuWidth = 0;

      if (this.contextMenu) {
        var menuElement = this.contextMenu.childNodes[0];
        var elementLength = menuElement.children.length;

        if (elementLength > 0) {
          menuNum += elementLength;
          menuHeight = menuElement.childNodes[0].clientHeight * menuNum;
          menuWidth = menuElement.clientWidth;
        }
      }

      return {
        menuNum: menuNum,
        menuHeight: menuHeight,
        menuWidth: menuWidth
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this56 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var locale = this.locale;
      var message = this.message;
      var customMenu = this.createCustomMenu();
      this.isShowForward = !!(this.forwardList && this.forwardList.callback);

      var _this$calculateMenu2 = this.calculateMenu(customMenu),
          menuNum = _this$calculateMenu2.menuNum,
          menuHeight = _this$calculateMenu2.menuHeight,
          menuWidth = _this$calculateMenu2.menuWidth;

      var currentTime = new Date().getTime();
      return h("div", {
        "class": "".concat(this.getContextMenuCalss(menuNum), " message-context-menu"),
        style: this.getContextMenuStyle(menuHeight, menuWidth),
        ref: function ref(el) {
          _this56.contextMenu = el;
          return _this56.contextMenu;
        }
      }, h("ul", null, !this.disableMenu.includes(DisabledMessageContextMenu.Copy) && message && message.messageType === MessageType$1.TEXT ? h("li", {
        onClick: this.handleCopy
      }, locale.message.copy) : null, !this.disableMenu.includes(DisabledMessageContextMenu.Reference) ? h("li", {
        onClick: this.handleReference
      }, locale.message.quote) : null, !this.disableMenu.includes(DisabledMessageContextMenu.Recall) && message && currentTime < message.sentTime + this.checkMaxRecallDuration() && message.messageDirection === MessageDirection$1.SEND ? h("li", {
        onClick: this.handleRecall
      }, locale.message.recall) : null, !this.disableMenu.includes(DisabledMessageContextMenu.Delete) ? h("li", {
        onClick: this.handleDelete
      }, locale.message["delete"]) : null, !this.disableMenu.includes(DisabledMessageContextMenu.Forward) && this.isShowForward && message && this.msgType.indexOf(message.messageType) > -1 ? h("li", {
        onClick: this.handlForward
      }, locale.message.forward) : null, customMenu.map(function (menu) {
        return h("li", {
          key: "".concat(message.messageUId, "_").concat(menu.name),
          onClick: menu.callback
        }, menu.name);
      })));
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "position": ["watchPosition"],
        "message": ["watchMessage"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return messageContextMenuCss;
    }
  }]);

  return MessageList$4;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var messageEditorCss = ".message-editor-wrapper{position:relative;width:100%;height:100%;min-width:10em;min-height:10em;text-align:left;background:#fbfbfc;border-top:1px solid rgb(227, 229, 230)}.editor-body{width:100%;height:100%}.editor-tool-bar{width:100%;height:4em;padding:3em 0 0.5em 4em}.editor-content-wrapper{width:100%;height:calc(100% - 7.5em);padding:0.5em 1em;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative}.editor-tool-bar .buttons .button{width:3.6em;height:3.6em;display:inline-block;text-align:center;line-height:3em;margin:0 3em 0 0;border-radius:0.5em;cursor:pointer;overflow:hidden}.editor-tool-bar .buttons .button input{display:none}.editor-tool-bar .buttons .button .label{display:block;width:3.6em;padding:3.6em 0 0;height:0;overflow:hidden;background-repeat:no-repeat;background-size:contain}.editor-tool-bar .buttons .button.image-btn .label{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzZweCIgaGVpZ2h0PSIzNnB4IiB2aWV3Qm94PSIwIDAgMzYgMzYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5Zu+54mHaWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIwM1/lkJHkuIvmu5rliqjml7Zsb2FkaW5nIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg3LjAwMDAwMCwgLTcxMC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IuWbvueJh2ljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ4Ny4wMDAwMDAsIDcxMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSLnn6nlvaIiIHg9IjAiIHk9IjAiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTMwLjU5MDE2MzksNSBDMzEuMjU0NDc3Niw1IDMxLjg1NTgwNyw1LjI3MjE2MzE4IDMyLjI5MTMyMjksNS43MTA3NjA2MSBDMzIuNzI5MzgyNiw2LjE1MTkxOTczIDMzLDYuNzYxMzc4NTcgMzMsNy40MzM5NjIyNiBMMzMsNy40MzM5NjIyNiBMMzMsMjguNTY2MDM3NyBDMzMsMjkuMjM4NjIxNCAzMi43MjkzODI2LDI5Ljg0ODA4MDMgMzIuMjkxMzIyOSwzMC4yODkyMzk0IEMzMS44NTU4MDcsMzAuNzI3ODM2OCAzMS4yNTQ0Nzc2LDMxIDMwLjU5MDE2MzksMzEgTDMwLjU5MDE2MzksMzEgTDUuNDA5ODM2MDcsMzEgQzQuNzcxNDc4LDMxIDQuMTU5NTg0OTUsMzAuNzQ0MDcxIDMuNzA4MzEyOTcsMzAuMjg5NjA2MSBDMy4yNTQ0MDU4MywyOS44MzI0ODczIDMsMjkuMjEyMzQzNSAzLDI4LjU2NjAzNzcgTDMsMjguNTY2MDM3NyBMMyw3LjQzMzk2MjI2IEMzLDYuNzYxMzc4NTcgMy4yNzA2MTc0Myw2LjE1MTkxOTczIDMuNzA4Njc3MDgsNS43MTA3NjA2MSBDNC4xNDQxOTMwMyw1LjI3MjE2MzE4IDQuNzQ1NTIyNCw1IDUuNDA5ODM2MDcsNSBMNS40MDk4MzYwNyw1IFoiIGlkPSLot6/lvoQiIHN0cm9rZT0iIzc3Nzc3NyIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNC4zMjM1NDYyLDE2Ljc1Mzg3NTkgQzI1LjEyMjQ1ODksMTYuNjk2NDUxMSAyNS45MzcwMzc0LDE2Ljg0NTc5MSAyNi42Nzk5NjAxLDE3LjIwODk0OTMgTDI2LjY3OTk2MDEsMTcuMjA4OTQ5MyBMMzAuNTE2ODEyNCwxOS4wODMxNDM5IEMzMS4yNzg3ODQ4LDE5LjQ1NTU3NTIgMzEuOTAxMTEwOCwyMC4wMjE3NzQzIDMyLjMzMjMyNzEsMjAuNzAzODUwNSBDMzIuNzYwNDkyMiwyMS4zODExMDA3IDMzLDIyLjE3MjUzOTYgMzMsMjIuOTk5NjYyNiBMMzMsMjIuOTk5NjYyNiBMMzMsMjguNjY3NjgwNSBDMzMsMjkuMzA4ODQ1NiAzMi43MzE4Nzc1LDI5Ljg4ODQ0MzggMzIuMzAyMTI2MiwzMC4zMDg1MTY0IEMzMS44NjQwMzM2LDMwLjczNjc0MjUgMzEuMjU4NDYyNCwzMC45OTk5OTk2IDMwLjU5MDkwMjUsMzAuOTk5OTk5NiBMMzAuNTkwOTAyNSwzMC45OTk5OTk2IEw1Ljk3OTc4MjIsMzAuOTk5OTk5OCBDNS43MjU1NTQ0NiwzMS4wMDAxNDgxIDUuNDg1NjM4MDEsMzAuOTIwNDIxNCA1LjI5MDM3MTk0LDMwLjc4MDU1NjIgQzUuMTAxMzMwOTQsMzAuNjQ1MTQ5OSA0Ljk1NDExMjE3LDMwLjQ1MzAyNjEgNC44Nzk5NjA4LDMwLjIyMzEzMiBDNC44MDczNDIyNywyOS45OTc5OTAyIDQuODEzNjgyNjYsMjkuNzYyODQwOSA0Ljg4NzYxOTkxLDI5LjU1MDE1OTQgQzQuOTYzMjEzMzYsMjkuMzMyNzEzOCA1LjEwOTAwNzYsMjkuMTM5MjI0OCA1LjMxMTQ1OTczLDI5LjAwMDg0NDEgTDUuMzExNDU5NzMsMjkuMDAwODQ0MSBMMjIuMDYzMTA4MywxNy41Mzk4MDg2IEMyMi43NDI3NjU3LDE3LjA3NDk2NDYgMjMuNTI1NDg1NywxNi44MTEyMzk1IDI0LjMyMzU0NjIsMTYuNzUzODc1OSBaIiBpZD0i6Lev5b6EIiBzdHJva2U9IiM3Nzc3NzciIHN0cm9rZS13aWR0aD0iMiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAuNjg1NzE0MywxNC44Mzg3MDk3IEMxMS45NDgwNzk0LDE0LjgzODcwOTcgMTIuOTcxNDI4NiwxMy44Mjc3Mzk4IDEyLjk3MTQyODYsMTIuNTgwNjQ1MiBDMTIuOTcxNDI4NiwxMS4zMzM1NTA2IDExLjk0ODA3OTQsMTAuMzIyNTgwNiAxMC42ODU3MTQzLDEwLjMyMjU4MDYgQzkuNDIzMzQ5MTIsMTAuMzIyNTgwNiA4LjQsMTEuMzMzNTUwNiA4LjQsMTIuNTgwNjQ1MiBDOC40LDEzLjgyNzczOTcgOS40MjMzNDkxMiwxNC44Mzg3MDk3IDEwLjY4NTcxNDMsMTQuODM4NzA5NyBMMTAuNjg1NzE0MywxNC44Mzg3MDk3IFoiIGlkPSLot6/lvoQiIGZpbGw9IiM3Nzc3NzciIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}.editor-tool-bar .buttons .button.image-btn .label:hover{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzZweCIgaGVpZ2h0PSIzNnB4IiB2aWV3Qm94PSIwIDAgMzYgMzYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5Zu+54mHaWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0i6aG16Z2iLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxN1/ljZXogYot5Y+R6YCB5Zu+54mH5raI5oGvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg3LjAwMDAwMCwgLTg2MC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IuWbvueJh2ljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ4Ny4wMDAwMDAsIDg2MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSLnn6nlvaIiIHg9IjAiIHk9IjAiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTMwLjU5MDE2MzksNSBDMzEuMjU0NDc3Niw1IDMxLjg1NTgwNyw1LjI3MjE2MzE4IDMyLjI5MTMyMjksNS43MTA3NjA2MSBDMzIuNzI5MzgyNiw2LjE1MTkxOTczIDMzLDYuNzYxMzc4NTcgMzMsNy40MzM5NjIyNiBMMzMsNy40MzM5NjIyNiBMMzMsMjguNTY2MDM3NyBDMzMsMjkuMjM4NjIxNCAzMi43MjkzODI2LDI5Ljg0ODA4MDMgMzIuMjkxMzIyOSwzMC4yODkyMzk0IEMzMS44NTU4MDcsMzAuNzI3ODM2OCAzMS4yNTQ0Nzc2LDMxIDMwLjU5MDE2MzksMzEgTDMwLjU5MDE2MzksMzEgTDUuNDA5ODM2MDcsMzEgQzQuNzcxNDc4LDMxIDQuMTU5NTg0OTUsMzAuNzQ0MDcxIDMuNzA4MzEyOTcsMzAuMjg5NjA2MSBDMy4yNTQ0MDU4MywyOS44MzI0ODczIDMsMjkuMjEyMzQzNSAzLDI4LjU2NjAzNzcgTDMsMjguNTY2MDM3NyBMMyw3LjQzMzk2MjI2IEMzLDYuNzYxMzc4NTcgMy4yNzA2MTc0Myw2LjE1MTkxOTczIDMuNzA4Njc3MDgsNS43MTA3NjA2MSBDNC4xNDQxOTMwMyw1LjI3MjE2MzE4IDQuNzQ1NTIyNCw1IDUuNDA5ODM2MDcsNSBMNS40MDk4MzYwNyw1IFoiIGlkPSLot6/lvoQiIHN0cm9rZT0iIzAwOTlGRiIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNC4zMjM1NDYyLDE2Ljc1Mzg3NTkgQzI1LjEyMjQ1ODksMTYuNjk2NDUxMSAyNS45MzcwMzc0LDE2Ljg0NTc5MSAyNi42Nzk5NjAxLDE3LjIwODk0OTMgTDI2LjY3OTk2MDEsMTcuMjA4OTQ5MyBMMzAuNTE2ODEyNCwxOS4wODMxNDM5IEMzMS4yNzg3ODQ4LDE5LjQ1NTU3NTIgMzEuOTAxMTEwOCwyMC4wMjE3NzQzIDMyLjMzMjMyNzEsMjAuNzAzODUwNSBDMzIuNzYwNDkyMiwyMS4zODExMDA3IDMzLDIyLjE3MjUzOTYgMzMsMjIuOTk5NjYyNiBMMzMsMjIuOTk5NjYyNiBMMzMsMjguNjY3NjgwNSBDMzMsMjkuMzA4ODQ1NiAzMi43MzE4Nzc1LDI5Ljg4ODQ0MzggMzIuMzAyMTI2MiwzMC4zMDg1MTY0IEMzMS44NjQwMzM2LDMwLjczNjc0MjUgMzEuMjU4NDYyNCwzMC45OTk5OTk2IDMwLjU5MDkwMjUsMzAuOTk5OTk5NiBMMzAuNTkwOTAyNSwzMC45OTk5OTk2IEw1Ljk3OTc4MjIsMzAuOTk5OTk5OCBDNS43MjU1NTQ0NiwzMS4wMDAxNDgxIDUuNDg1NjM4MDEsMzAuOTIwNDIxNCA1LjI5MDM3MTk0LDMwLjc4MDU1NjIgQzUuMTAxMzMwOTQsMzAuNjQ1MTQ5OSA0Ljk1NDExMjE3LDMwLjQ1MzAyNjEgNC44Nzk5NjA4LDMwLjIyMzEzMiBDNC44MDczNDIyNywyOS45OTc5OTAyIDQuODEzNjgyNjYsMjkuNzYyODQwOSA0Ljg4NzYxOTkxLDI5LjU1MDE1OTQgQzQuOTYzMjEzMzYsMjkuMzMyNzEzOCA1LjEwOTAwNzYsMjkuMTM5MjI0OCA1LjMxMTQ1OTczLDI5LjAwMDg0NDEgTDUuMzExNDU5NzMsMjkuMDAwODQ0MSBMMjIuMDYzMTA4MywxNy41Mzk4MDg2IEMyMi43NDI3NjU3LDE3LjA3NDk2NDYgMjMuNTI1NDg1NywxNi44MTEyMzk1IDI0LjMyMzU0NjIsMTYuNzUzODc1OSBaIiBpZD0i6Lev5b6EIiBzdHJva2U9IiMwMDk5RkYiIHN0cm9rZS13aWR0aD0iMiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAuNjg1NzE0MywxNC44Mzg3MDk3IEMxMS45NDgwNzk0LDE0LjgzODcwOTcgMTIuOTcxNDI4NiwxMy44Mjc3Mzk4IDEyLjk3MTQyODYsMTIuNTgwNjQ1MiBDMTIuOTcxNDI4NiwxMS4zMzM1NTA2IDExLjk0ODA3OTQsMTAuMzIyNTgwNiAxMC42ODU3MTQzLDEwLjMyMjU4MDYgQzkuNDIzMzQ5MTIsMTAuMzIyNTgwNiA4LjQsMTEuMzMzNTUwNiA4LjQsMTIuNTgwNjQ1MiBDOC40LDEzLjgyNzczOTcgOS40MjMzNDkxMiwxNC44Mzg3MDk3IDEwLjY4NTcxNDMsMTQuODM4NzA5NyBMMTAuNjg1NzE0MywxNC44Mzg3MDk3IFoiIGlkPSLot6/lvoQiIGZpbGw9IiMwMDk5RkYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}.editor-tool-bar .buttons .button.file-btn .label{background-image:url(data:image/svg+xml;base64,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)}.editor-tool-bar .buttons .button.file-btn .label:hover{background-image:url(data:image/svg+xml;base64,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)}.error-tip{width:300px;height:50px;position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;background:#f56c6c;line-height:50px;color:#fff;font-size:20px;border-radius:8px}";

var MessageEditor$1 = /*#__PURE__*/function (_HTMLElement7) {
  _inherits(MessageEditor$1, _HTMLElement7);

  var _super9 = _createSuper(MessageEditor$1);

  function MessageEditor$1() {
    var _this57;

    _classCallCheck(this, MessageEditor$1);

    _this57 = _super9.call(this);

    _this57.__registerHost();

    _this57.baseSize = '16px';
    _this57.showMemberList = false;
    _this57.isError = false;
    _this57.lang = core.lang; // 语言标识

    _this57.connected = true; // 记录编辑器change时返回的内容数据

    _this57.content = '';
    _this57.switchConversation = _this57.switchConversation.bind(_assertThisInitialized(_this57));
    _this57.sendFileMessage = _this57.sendFileMessage.bind(_assertThisInitialized(_this57));
    _this57.sendImageMessage = _this57.sendImageMessage.bind(_assertThisInitialized(_this57));
    _this57.handlePostMessage = _this57.handlePostMessage.bind(_assertThisInitialized(_this57));
    _this57.handleEditorChange = _this57.handleEditorChange.bind(_assertThisInitialized(_this57));
    _this57.handleReferenceMessage = _this57.handleReferenceMessage.bind(_assertThisInitialized(_this57));
    _this57.handleCloseReference = _this57.handleCloseReference.bind(_assertThisInitialized(_this57));
    _this57.handleConnected = _this57.handleConnected.bind(_assertThisInitialized(_this57));
    _this57.handleConnecting = _this57.handleConnecting.bind(_assertThisInitialized(_this57));
    _this57.handleSuspend = _this57.handleSuspend.bind(_assertThisInitialized(_this57));
    _this57.handleLanguageChanged = _this57.handleLanguageChanged.bind(_assertThisInitialized(_this57));
    return _this57;
  }

  _createClass(MessageEditor$1, [{
    key: "checkMentioned",
    value: function checkMentioned() {
      var mentionedInfo = {
        mentionedUserIdList: [],
        mentionedType: MentionedType.SINGAL
      };
      var tempDom = document.createElement('div');
      tempDom.innerHTML = this.content;
      var mentionedSpans = tempDom.querySelectorAll('span.at-span');

      if (mentionedSpans.length) {
        for (var i = 0; i < mentionedSpans.length; i++) {
          var one = mentionedSpans[i];
          var id = one.getAttribute('data-id'); // 所有人

          if (id === 'all') {
            mentionedInfo.mentionedType = MentionedType.ALL;
            mentionedInfo.mentionedUserIdList.length = 0;
            break;
          }

          if (mentionedInfo.mentionedUserIdList.indexOf(id) === -1) {
            mentionedInfo.mentionedUserIdList.push(id);
          }
        }

        return mentionedInfo;
      }

      return null;
    }
  }, {
    key: "handlePostMessage",
    value: function handlePostMessage(event) {
      var content = event.detail;
      this.content = event.detail;

      if (!content || !this.connected) {
        return;
      } // 判断是否提及了其他用户


      var mentionedInfo = this.checkMentioned(); // 将br标签替换为换行符

      content = content.replace(/<br\s?\/?>/gi, '\n'); // 将nbsp;替换为空

      content = content.replace(/&nbsp;/gi, ' ');
      content = delHtmlTag(content);
      var messageBody;
      var sendOption;

      if (this.referenceMessage) {
        messageBody = new ReferenceMessage$3({
          referMsgUserId: this.referenceMessage.message.senderUserId,
          referMsg: this.referenceMessage.message.content,
          content: content,
          objName: this.referenceMessage.message.messageType
        });
      } else {
        var messageInfo = {
          content: content
        };
        sendOption = mentionedInfo ? _objectSpread({
          isMentioned: true
        }, mentionedInfo) : undefined;

        if (!sendOption) {
          messageInfo.mentionedInfo = sendOption;
        }

        messageBody = new TextMessage$1(messageInfo);
      }

      core.sendMessage(this.conversation, messageBody, sendOption);
      this.content = '';
    }
  }, {
    key: "sendImageMessage",
    value: function sendImageMessage() {
      var _this58 = this;

      var typeArr = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!this.connected) {
        return;
      }

      var files = this.imageInputRef.files;

      if (!files.length) {
        return;
      }

      var file = files[0];

      if (typeArr.indexOf(files[0].type) === -1) {
        this.isError = true;
        setTimeout(function () {
          _this58.isError = false;
        }, 2000);
        return;
      }

      core.sendImageMessage(this.conversation, {
        file: file
      }, {
        onProgress: function onProgress() {// do nothing.
        },
        onComplete: function onComplete() {// do nothing.
        }
      });
      this.imageInputRef.value = '';
    }
  }, {
    key: "sendFileMessage",
    value: function sendFileMessage() {
      if (!this.connected) {
        return;
      }

      var files = this.fileInputRef.files;

      if (!files.length) {
        return;
      }

      var file = files[0];
      core.sendFileMessage(this.conversation, {
        file: file
      }, {
        onProgress: function onProgress() {},
        onComplete: function onComplete() {// do nothing.
        }
      });
      this.fileInputRef.value = '';
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      if (this.draft) {
        this.content = this.draft.text;
      }

      addEventListener(Events.CONNECTED, this.handleConnected);
      addEventListener(Events.CONNECTING, this.handleConnecting);
      addEventListener(Events.SUSPEND, this.handleSuspend);
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      this.conversation = core.currentConversation; // 系统消息，不显示编辑器

      if ((core.currentConversation && core.currentConversation.conversationType) === ConversationType$1.SYSTEM) {
        this.conversation = null;
      }

      core.on(CoreEvent.SWITCH_CONVERSATION, this.switchConversation);
      core.on(CoreEvent.REFERENCE_MESSAGE, this.handleReferenceMessage);
      core.on(CoreEvent.CLOSE_REFERENCE, this.handleCloseReference); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.SWITCH_CONVERSATION, this.switchConversation);
      core.off(CoreEvent.REFERENCE_MESSAGE, this.handleReferenceMessage);
      core.off(CoreEvent.CLOSE_REFERENCE, this.handleCloseReference);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      removeEventListener(Events.CONNECTED, this.handleConnected);
      removeEventListener(Events.CONNECTING, this.handleConnecting);
      removeEventListener(Events.SUSPEND, this.handleSuspend);

      if (this.content) {
        core.saveTextMessageDraft(this.conversation, this.content);
      }
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "handleConnected",
    value: function handleConnected() {
      this.connected = true;
    }
  }, {
    key: "handleConnecting",
    value: function handleConnecting() {
      this.connected = false;
    }
  }, {
    key: "handleSuspend",
    value: function handleSuspend() {
      this.connected = false;
    }
  }, {
    key: "handleReferenceMessage",
    value: function handleReferenceMessage(message) {
      this.referenceMessage = {
        message: message,
        time: Date.now()
      };
    }
  }, {
    key: "handleCloseReference",
    value: function handleCloseReference() {
      this.referenceMessage = null;
    }
    /**
     * 切换会话
     */

  }, {
    key: "switchConversation",
    value: function switchConversation(option) {
      var _this59 = this;

      // 关闭引用消息
      this.handleCloseReference(); // 切换前先存草稿

      if (this.conversation && this.conversation !== option && this.content) {
        core.saveTextMessageDraft(this.conversation, this.content);
      }

      this.conversation = option; // 清空当前的输入框

      this.draft = {
        time: Date.now(),
        text: ''
      };
      this.content = '';

      if (!option) {
        // option 为空不展示编辑器
        this.conversation = null;
        return;
      } // 系统消息，不显示编辑器


      if (option.conversationType === ConversationType$1.SYSTEM) {
        this.conversation = null;
        return;
      } // 获取之前的草稿


      getTextMessageDraft(this.conversation).then(function (res) {
        if (res.code === 0) {
          if (res.data) {
            _this59.draft = {
              time: Date.now(),
              text: res.data
            };
            _this59.content = _this59.draft.text;
          }

          clearTextMessageDraft(_this59.conversation);
        }
      });
    }
  }, {
    key: "handleEditorChange",
    value: function handleEditorChange(event) {
      var value = event.detail;
      value = value.trim(); // 兼容部分浏览器

      if (value === '<br>') {
        value = '';
      }

      this.content = value;
    }
  }, {
    key: "onInputContent",
    value: function onInputContent() {
      // 发送正在输入的状态
      sendTypingStatusMessage(this.conversation, MessageType$1.TEXT);
    }
  }, {
    key: "render",
    value: function render() {
      var _this60 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var conversation = this.conversation,
          isError = this.isError,
          locale = this.locale;
      return conversation ? h("div", {
        "class": "message-editor-wrapper",
        style: {
          fontSize: this.baseSize
        }
      }, h("reference-message", {
        referenceMessage: this.referenceMessage,
        onClose: this.handleCloseReference
      }), h("div", {
        "class": "editor-body"
      }, h("div", {
        "class": "editor-tool-bar"
      }, h("div", {
        "class": "buttons"
      }, h("div", {
        "class": "button image-btn"
      }, h("input", {
        type: "file",
        accept: "image/jpeg,image/jpg,image/png",
        ref: function ref(el) {
          _this60.imageInputRef = el;
          return _this60.imageInputRef;
        },
        onChange: this.sendImageMessage
      }), h("span", {
        "class": "label",
        onClick: function onClick() {
          return _this60.imageInputRef.click();
        }
      }, locale.messageEdit.picture), isError ? h("div", {
        "class": "error-tip"
      }, locale.messageEdit.picError) : ''), h("div", {
        "class": "button file-btn"
      }, h("input", {
        type: "file",
        accept: "*",
        ref: function ref(el) {
          _this60.fileInputRef = el;
          return _this60.fileInputRef;
        },
        onChange: this.sendFileMessage
      }), h("span", {
        "class": "label",
        onClick: function onClick() {
          return _this60.fileInputRef.click();
        }
      }, locale.messageEdit.file)))), h("div", {
        "class": "editor-content-wrapper"
      }, h("content-editor", {
        conversation: this.conversation,
        onPost: this.handlePostMessage,
        onContentChange: this.handleEditorChange,
        onInputContent: this.onInputContent,
        value: this.draft
      })))) : null;
    }
  }], [{
    key: "style",
    get: function get() {
      return messageEditorCss;
    }
  }]);

  return MessageEditor$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var ACreateMessage = /*#__PURE__*/function () {
  function ACreateMessage(message, callback) {
    _classCallCheck(this, ACreateMessage);

    this.uid = message.messageUId;
    this.direction = message.messageDirection;
    this.content = message.content;
    this.callback = callback;
    this.messageType = message.messageType;
    this.conversationType = message.conversationType;
    this.senderUserId = message.senderUserId;
    this.targetId = message.targetId;
    this.channelId = message.channelId;
  }

  _createClass(ACreateMessage, [{
    key: "wrap",
    value: function wrap(inner) {
      return h("div", {
        "class": "message-content"
      }, inner);
    }
  }]);

  return ACreateMessage;
}();

var fileTypeMap = {
  'application/zip': 'file-zip',
  'application/gzip': 'file-zip',
  'application/x-zip-compressed': 'file-zip',
  'application/x-tar': 'file-zip',
  'application/x-compressed': 'file-zip',
  'application/msword': 'file-word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-word',
  'application/rtf': 'file-text',
  'application/vnd.ms-excel application/x-excel': 'file-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-xls',
  'application/x-xls': 'file-xls',
  'text/csv': 'file-xls',
  'application/vnd.ms-excel': 'file-xls',
  'application/x-ppt': 'file-ppt',
  'application/vnd.ms-powerpoint': 'file-ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'file-ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'file-ppt',
  'application/pdf': 'file-pdf',
  'audio/mp3': 'file-audio',
  'audio/wav': 'file-audio',
  'audio/m3u': 'file-audio',
  'audio/midi': 'file-audio',
  'audio/flac': 'file-audio',
  'audio/ape': 'file-audio',
  'audio/x-ms-wma': 'file-audio',
  'video/mpeg4': 'file-video',
  'video/x-ms-wmv': 'file-video',
  'video/avi': 'file-video',
  'video/mpg': 'file-video',
  'video/mp4': 'file-video',
  'video/x-msvideo': 'file-video',
  'video/x-flv': 'file-video',
  'application/x-mpegURL': 'file-video',
  'video/3gpp': 'file-video',
  'text/plain': 'file-plain',
  'image/jpeg': 'file-image',
  'image/tiff': 'file-image',
  'image/png': 'file-image',
  'image/gif': 'file-image',
  'application/vnd.android.package-archive': 'file-apk',
  'application/xml': 'file-text',
  'application/rdf+xml': 'file-text',
  'application/rss+xml': 'file-text',
  'application/soap+xml': 'file-text',
  'application/atom+xml': 'file-text',
  'application/xhtml+xml': 'file-text',
  'text/html': 'file-text',
  'text/xml': 'file-text',
  'text/css': 'file-text'
};
/**
 * 格式化文件大小为适合查看的单位
 * @param s 单位字节
 * @returns
 */

function formatSize(s) {
  var size = s;

  if (size < 1024) {
    return "".concat(size, "B");
  }

  if (size > 1024 * 1024 * 1024) {
    size = "".concat((size / 1024 / 1024 / 1024).toFixed(2), "G");
  } else if (size > 1024 * 1024) {
    size = "".concat((size / 1024 / 1024).toFixed(2), "M");
  } else if (size > 1024) {
    size = "".concat((size / 1024).toFixed(2), "K");
  }

  return size;
}

var FileMessage = /*#__PURE__*/function (_ACreateMessage) {
  _inherits(FileMessage, _ACreateMessage);

  var _super10 = _createSuper(FileMessage);

  function FileMessage(message, callback) {
    var _this61;

    _classCallCheck(this, FileMessage);

    _this61 = _super10.call(this, message, callback);
    _this61.handleClick = _this61.handleClick.bind(_assertThisInitialized(_this61));
    return _this61;
  }

  _createClass(FileMessage, [{
    key: "handleClick",
    value: function handleClick() {
      if (typeof this.callback === 'function') {
        this.callback({
          type: 'file',
          url: this.content.fileUrl,
          size: this.content.size,
          name: this.content.name,
          fileType: this.content.type
        });
      }
    }
  }, {
    key: "getFileIcon",
    value: function getFileIcon(type) {
      var fileType = fileTypeMap[type];
      return fileType || 'file-icon';
    }
  }, {
    key: "create",
    value: function create() {
      var content = this.content;
      return this.wrap(h("div", {
        "class": "file-message-body",
        "data-origin": content.imageUri
      }, h("div", {
        "class": "file-message-icon ".concat(this.getFileIcon(content.type))
      }), h("div", {
        "class": "file-desc"
      }, h("div", {
        "class": "file-name",
        title: content.name
      }, content.name), h("div", {
        "class": "file-size"
      }, formatSize(content.size))), this.uid.startsWith('sending_') || this.uid.startsWith('fail_') ? null : h("div", {
        "class": "file-download-btn",
        onClick: this.handleClick
      })));
    }
  }]);

  return FileMessage;
}(ACreateMessage);

var GifMessage = /*#__PURE__*/function (_ACreateMessage2) {
  _inherits(GifMessage, _ACreateMessage2);

  var _super11 = _createSuper(GifMessage);

  function GifMessage() {
    _classCallCheck(this, GifMessage);

    return _super11.apply(this, arguments);
  }

  _createClass(GifMessage, [{
    key: "create",
    value: function create() {
      var content = this.content;
      return this.wrap(h("div", {
        "class": "gif-message-body"
      }, h("img", {
        src: content.remoteUrl
      })));
    }
  }]);

  return GifMessage;
}(ACreateMessage); // eslint-disable-next-line max-len


var icon = 'data:image/svg+xml;base64,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'; // eslint-disable-next-line max-len

var iconPlaying = 'data:image/gif;base64,R0lGODlhQABAAIcAAAAAABEfLBIgLREfLRIfLRIgLBEgLBEgLRIhLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFFAAAACwAAAAAQABAAAAIiwABCBxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqTJkyhTqlzJsqXLlzBjypxJs6bNmzhz6txJUsCAAgd2Bhg6tEBOAkSJBr2ZNOlNAU2J4ow6FGeBqEZxHki69OiAAwZ4ih1LtqzZs2jTql3Ltq3bt3Djyp1Lt67du3h1BgQAIfkEBRQAAAAsGAAQAAwAIAAACHEAAQgEIGCgwYEGAgQ4iFChQoYJHT40KNHhgYMVFQ7AmPGggIwFDX6syLDjwYgOCZQkyVHiSpctHTI8wJJizYEFbgo0aRPmwJEOQw4EaZDmTQJEh/IEkNPkgIwBLu6EavBpRaECrSpEwBCA1a4DuXYNCAAh+QQJFAAAACwkAAQAEQA4AAAIygABCASAYKDBgwMNBDCAsKHCABAbGnwIMUABiQIraiSAkYDGihgBUKzIEaOAjxZDHkAZEgDKiyZZqvwoIOQAmR0/lpR48mNLlAVzaqwZEqfEmxp/0lRaESZGow2hIvSYNCRVkCF7YsVY4GNQiV01fm2oFSJRsD6tpn26VqLUg28NfjyQ9SNDoRXHIowrMGxViSMDnI3aFmHZAAOKFj7oF+JOwyjvEl48EOlfhCvt8kRJt6HlywYbk3SLcvDBz4hbWu6sOnXLhK8BBAQAIfkEBRQAAAAsAAAAAAEAAQAACAQAAQQEADs=';

var HqVoiceMessage = /*#__PURE__*/function (_ACreateMessage3) {
  _inherits(HqVoiceMessage, _ACreateMessage3);

  var _super12 = _createSuper(HqVoiceMessage);

  function HqVoiceMessage(message, callback) {
    var _this62;

    _classCallCheck(this, HqVoiceMessage);

    _this62 = _super12.call(this, message, callback);
    _this62.isPlaying = false;
    _this62.handleClick = _this62.handleClick.bind(_assertThisInitialized(_this62));
    _this62.onStart = _this62.onStart.bind(_assertThisInitialized(_this62));
    _this62.onStop = _this62.onStop.bind(_assertThisInitialized(_this62));
    return _this62;
  }

  _createClass(HqVoiceMessage, [{
    key: "handleClick",
    value: function handleClick() {
      if (typeof this.callback === 'function') {
        var url;

        if (this.messageType === 'RC:VcMsg') {
          url = addBase64head(this.content.content);
        } else if (this.messageType === MessageType.HQ_VOICE) {
          url = this.content.remoteUrl;
        }

        this.callback({
          uid: this.uid,
          type: 'hqvoice',
          url: url,
          duration: this.content.duration,
          onStart: this.onStart,
          onStop: this.onStop
        });
      }
    }
  }, {
    key: "onStart",
    value: function onStart() {
      this.voiceIcon.src = iconPlaying;
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.voiceIcon.src = icon;
    }
  }, {
    key: "create",
    value: function create() {
      var _this63 = this;

      var content = this.content;
      return this.wrap(h("div", {
        "class": "hqvoice-message-body",
        style: {
          width: "".concat(Math.max(150, Math.min(500, content.duration / 60 * 500)), "px")
        },
        "data-origin": content.remoteUrl,
        onClick: this.handleClick
      }, h("img", {
        ref: function ref(_ref2) {
          _this63.voiceIcon = _ref2;
        },
        "class": "voice-icon",
        src: icon
      }), content.duration ? h("span", null, Math.round(content.duration), "''") : null));
    }
  }]);

  return HqVoiceMessage;
}(ACreateMessage); // eslint-disable-next-line max-len


var errotBase64Str = 'data:image/svg+xml;base64,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';

var ImageMessage = /*#__PURE__*/function (_ACreateMessage4) {
  _inherits(ImageMessage, _ACreateMessage4);

  var _super13 = _createSuper(ImageMessage);

  function ImageMessage(message, callback) {
    var _this64;

    _classCallCheck(this, ImageMessage);

    _this64 = _super13.call(this, message, callback);
    _this64.handleClick = _this64.handleClick.bind(_assertThisInitialized(_this64));
    _this64.onError = _this64.onError.bind(_assertThisInitialized(_this64));
    return _this64;
  }

  _createClass(ImageMessage, [{
    key: "handleClick",
    value: function handleClick() {
      if (typeof this.callback === 'function') {
        this.callback({
          type: 'image',
          thumb: this.content.content,
          url: this.content.imageUri
        });
      }
    }
  }, {
    key: "onError",
    value: function onError(e) {
      var target = e.target;
      target.src = errotBase64Str;
    }
  }, {
    key: "create",
    value: function create() {
      var content = this.content;
      return this.wrap(h("div", {
        "class": "image-message-body",
        "data-origin": content.imageUri,
        onClick: this.handleClick
      }, h("img", {
        src: addBase64head(content.content, errotBase64Str),
        onError: this.onError
      })));
    }
  }]);

  return ImageMessage;
}(ACreateMessage);

var LocationMessage = /*#__PURE__*/function (_ACreateMessage5) {
  _inherits(LocationMessage, _ACreateMessage5);

  var _super14 = _createSuper(LocationMessage);

  function LocationMessage() {
    _classCallCheck(this, LocationMessage);

    return _super14.apply(this, arguments);
  }

  _createClass(LocationMessage, [{
    key: "create",
    value: function create() {
      var lang = core.lang ? core.lang : language.zh_CN;
      var locale = language[lang];
      var location = "[".concat(locale.message.location, "]").concat(locale.message.nonsupport);
      return this.wrap(h("div", {
        "class": "location-message-body"
      }, h("p", null, location)));
    }
  }]);

  return LocationMessage;
}(ACreateMessage);

var RecallMessage = /*#__PURE__*/function (_ACreateMessage6) {
  _inherits(RecallMessage, _ACreateMessage6);

  var _super15 = _createSuper(RecallMessage);

  function RecallMessage() {
    _classCallCheck(this, RecallMessage);

    return _super15.apply(this, arguments);
  }

  _createClass(RecallMessage, [{
    key: "create",
    value: function create() {
      var _this65 = this;

      var name;
      var lang = core.lang ? core.lang : language.zh_CN;
      var locale = language[lang];

      if (this.direction === MessageDirection$1.SEND) {
        name = "".concat(locale.message.you, " ");
      } else if (this.conversationType === ConversationType$1.PRIVATE) {
        core.getConversationProfile({
          targetId: this.targetId,
          conversationType: ConversationType$1.PRIVATE,
          channelId: this.channelId
        }).then(function (res) {
          name = res ? res.name : _this65.senderUserId;
          _this65.nameRef.innerText = "".concat(name, " ");
        });
      } else if (this.conversationType === ConversationType$1.GROUP) {
        core.getGroupMemberProfile({
          targetId: this.targetId,
          conversationType: ConversationType$1.GROUP,
          channelId: this.channelId
        }, this.senderUserId).then(function (res) {
          name = res ? res.groupNickname || res.name || _this65.senderUserId : _this65.senderUserId;
          _this65.nameRef.innerText = "".concat(name, " ");
        });
      }

      return this.wrap(h("div", {
        "class": "recall-message-body"
      }, h("div", {
        "class": "tip-content"
      }, h("span", {
        ref: function ref(el) {
          _this65.nameRef = el;
          return _this65.nameRef;
        }
      }, name), locale.message.msgRecall)));
    }
  }]);

  return RecallMessage;
}(ACreateMessage);

var ReferenceMessage$2 = /*#__PURE__*/function (_ACreateMessage7) {
  _inherits(ReferenceMessage$2, _ACreateMessage7);

  var _super16 = _createSuper(ReferenceMessage$2);

  function ReferenceMessage$2(message, callback) {
    var _this66;

    _classCallCheck(this, ReferenceMessage$2);

    _this66 = _super16.call(this, message, callback);
    _this66.message = message;

    _this66.getName(message);

    return _this66;
  }

  _createClass(ReferenceMessage$2, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.on(CoreEvent.GROUP_INFO_CHANGED, this.handleInfoChanged);
      core.on(CoreEvent.USER_INFO_CHANGED, this.handleInfoChanged);
      core.on(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleInfoChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.GROUP_INFO_CHANGED, this.handleInfoChanged);
      core.off(CoreEvent.USER_INFO_CHANGED, this.handleInfoChanged);
      core.off(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleInfoChanged);
    }
  }, {
    key: "handleInfoChanged",
    value: function handleInfoChanged() {
      if (this.message) {
        this.getName(this.message);
      }
    }
  }, {
    key: "getProfile",
    value: function getProfile(message) {
      var conversationOption = {
        conversationType: message.conversationType,
        targetId: message.targetId,
        channelId: message.channelId
      };
      var promise;

      if (message.conversationType === ConversationType$1.GROUP) {
        promise = core.getGroupMemberProfile(conversationOption, message.senderUserId);
      } else if (message.content.referMsgUserId === getCurrentUserId()) {
        promise = core.getMyProfile();
      } else {
        promise = core.getConversationProfile(conversationOption);
      }

      return promise;
    }
  }, {
    key: "getName",
    value: function getName(message) {
      var _this67 = this;

      this.name = this.content.referMsgUserId;
      var promise = this.getProfile(message);
      promise.then(function (res) {
        if (!res) {
          return;
        }

        _this67.name = res.displayName || res.groupNickname || res.name;

        if (_this67.nameRef) {
          _this67.nameRef.innerText = _this67.name;
        }
      });
    }
  }, {
    key: "referMsgContentIsObject",
    value: function referMsgContentIsObject(referMsg) {
      if (isObject(referMsg.content)) {
        return referMsg.content;
      }

      return referMsg;
    }
  }, {
    key: "getRererenceContent",
    value: function getRererenceContent(type, referMsg) {
      var content = '';
      var handledContent = '';
      var referMsgContent = '';
      var lang = core.lang ? core.lang : language.zh_CN;
      var locale = language[lang];

      switch (type) {
        case MessageType$1.TEXT:
          // imkit 5.4.0 以前版本引用消息格式多一层 content 与lib和其他端不对齐。为兼容历史版本中增加此判断
          referMsgContent = this.referMsgContentIsObject(referMsg).content;
          handledContent = formatTextMessage(referMsgContent);
          content = h("div", {
            innerHTML: handledContent,
            "class": "referenced-message-text"
          }, h("div", {
            "class": "quote quoteContent",
            innerHTML: handledContent
          }));
          break;

        case MessageType$1.IMAGE:
          referMsgContent = this.referMsgContentIsObject(referMsg).content;
          content = h("img", {
            src: addBase64head(referMsgContent)
          });
          break;

        case MessageType$1.GIF:
          referMsgContent = this.referMsgContentIsObject(referMsg).remoteUrl;
          content = h("img", {
            src: referMsgContent
          });
          break;

        case MessageType$1.FILE:
          referMsgContent = this.referMsgContentIsObject(referMsg).name;
          content = "[".concat(locale.conversation.file, "] ").concat(referMsgContent);
          break;

        case MessageType$1.RICH_CONTENT:
          referMsgContent = this.referMsgContentIsObject(referMsg).title;
          content = "[".concat(locale.conversation.img, "] ").concat(referMsgContent);
          break;

        case MessageType$1.REFERENCE:
          content = this.referMsgContentIsObject(referMsg).content;
          break;
      }

      return content;
    }
  }, {
    key: "create",
    value: function create() {
      var _this68 = this;

      var content = this.content;
      return this.wrap(h("div", {
        "class": "reference-message-body"
      }, h("div", {
        "class": "reference-message-content"
      }, h("div", {
        "class": "user",
        ref: function ref(el) {
          _this68.nameRef = el;
          return _this68.nameRef;
        }
      }, this.name), h("div", {
        "class": "content"
      }, this.getRererenceContent(content.objName, content.referMsg))), h("div", {
        "class": "message-content",
        innerHTML: formatTextMessage(content.content)
      })));
    }
  }]);

  return ReferenceMessage$2;
}(ACreateMessage);

var RichMessage = /*#__PURE__*/function (_ACreateMessage8) {
  _inherits(RichMessage, _ACreateMessage8);

  var _super17 = _createSuper(RichMessage);

  function RichMessage(message, callback) {
    var _this69;

    _classCallCheck(this, RichMessage);

    _this69 = _super17.call(this, message, callback);
    _this69.handleClick = _this69.handleClick.bind(_assertThisInitialized(_this69));
    return _this69;
  }

  _createClass(RichMessage, [{
    key: "handleClick",
    value: function handleClick() {
      if (typeof this.callback === 'function') {
        this.callback({
          type: 'richContent',
          url: this.content.url
        });
      }
    }
  }, {
    key: "create",
    value: function create() {
      var content = this.content;
      return this.wrap(h("div", {
        "class": "rich-message-body",
        "data-url": content.url,
        onClick: this.handleClick
      }, h("div", {
        "class": "title"
      }, content.title), h("div", {
        "class": "content"
      }, content.imageUri ? h("img", {
        src: content.imageUri
      }) : null, h("p", null, content.content))));
    }
  }]);

  return RichMessage;
}(ACreateMessage);

var SightMessage = /*#__PURE__*/function (_ACreateMessage9) {
  _inherits(SightMessage, _ACreateMessage9);

  var _super18 = _createSuper(SightMessage);

  function SightMessage(message, callback) {
    var _this70;

    _classCallCheck(this, SightMessage);

    _this70 = _super18.call(this, message, callback);
    _this70.handleClick = _this70.handleClick.bind(_assertThisInitialized(_this70));
    return _this70;
  }

  _createClass(SightMessage, [{
    key: "handleClick",
    value: function handleClick() {
      if (typeof this.callback === 'function') {
        this.callback({
          type: 'sight',
          url: this.content.sightUrl,
          thumb: this.content.content,
          duration: this.content.duration,
          size: this.content.size,
          name: this.content.name
        });
      }
    }
  }, {
    key: "formatDuration",
    value: function formatDuration(d) {
      var duration = d;
      var hour = Math.floor(duration / 3600) >= 10 ? Math.floor(duration / 3600) : "0".concat(Math.floor(duration / 3600));
      duration -= 3600 * hour;
      var min = Math.floor(duration / 60) >= 10 ? Math.floor(duration / 60) : "0".concat(Math.floor(duration / 60));
      duration -= 60 * min;
      var sec = duration >= 10 ? duration : "0".concat(duration);
      return hour * 1 > 0 ? "".concat(hour, ":").concat(min, ":").concat(sec) : "".concat(min, ":").concat(sec);
    }
  }, {
    key: "create",
    value: function create() {
      var content = this.content;
      return this.wrap(h("div", {
        "class": "sight-message-body",
        "data-origin": content.imageUri,
        onClick: this.handleClick
      }, h("img", {
        "class": "sight-conver",
        src: addBase64head(content.content)
      }), h("div", {
        "class": "file-duration"
      }, this.formatDuration(content.duration)), h("div", {
        "class": "start-play-btn"
      }, h("button", null))));
    }
  }]);

  return SightMessage;
}(ACreateMessage);

var TextMessage = /*#__PURE__*/function (_ACreateMessage10) {
  _inherits(TextMessage, _ACreateMessage10);

  var _super19 = _createSuper(TextMessage);

  function TextMessage() {
    _classCallCheck(this, TextMessage);

    return _super19.apply(this, arguments);
  }

  _createClass(TextMessage, [{
    key: "create",
    value: function create() {
      var content = this.content.content;
      content = formatTextMessage(content);
      return this.wrap(h("div", {
        "class": "text-message-body"
      }, h("p", {
        innerHTML: content
      })));
    }
  }]);

  return TextMessage;
}(ACreateMessage);

var InfoNtfMessage = /*#__PURE__*/function (_ACreateMessage11) {
  _inherits(InfoNtfMessage, _ACreateMessage11);

  var _super20 = _createSuper(InfoNtfMessage);

  function InfoNtfMessage() {
    _classCallCheck(this, InfoNtfMessage);

    return _super20.apply(this, arguments);
  }

  _createClass(InfoNtfMessage, [{
    key: "create",
    value: function create() {
      var message = this.content.message;
      return this.wrap(h("div", {
        "class": "info-message-body"
      }, h("div", {
        "class": "tip-content"
      }, message)));
    }
  }]);

  return InfoNtfMessage;
}(ACreateMessage);

var GrpNtfMessage = /*#__PURE__*/function (_ACreateMessage12) {
  _inherits(GrpNtfMessage, _ACreateMessage12);

  var _super21 = _createSuper(GrpNtfMessage);

  function GrpNtfMessage() {
    _classCallCheck(this, GrpNtfMessage);

    return _super21.apply(this, arguments);
  }

  _createClass(GrpNtfMessage, [{
    key: "create",
    value: function create() {
      var _this71 = this;

      var content = this.createGroupNtfContent();
      return this.wrap(h("div", {
        "class": "group-info-message-body"
      }, h("div", {
        "class": "tip-content"
      }, h("span", {
        ref: function ref(el) {
          _this71.contentRef = el;
          return _this71.contentRef;
        }
      }, content))));
    }
  }, {
    key: "createGroupNtfContent",
    value: function createGroupNtfContent() {
      var lang = core.lang ? core.lang : language.zh_CN;
      var locale = language[lang];
      return setGroupNtfContent(locale, this.content);
    }
  }]);

  return GrpNtfMessage;
}(ACreateMessage);
/**
 * 通知类的消息类型
 */


var ntfMessageTypeMap = {
  'RC:RcCmd': RecallMessage,
  'RC:InfoNtf': InfoNtfMessage,
  'RC:ContactNtf': null,
  'RC:ProfileNtf': null,
  'RC:CmdNtf': null,
  'RC:GrpNtf': GrpNtfMessage
};
/**
 * 常规的消息类型，用于展示
 */

var commonMessageTypeMap = (_commonMessageTypeMap = {}, _defineProperty(_commonMessageTypeMap, MessageType$1.TEXT, TextMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.IMAGE, ImageMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.FILE, FileMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.SIGHT, SightMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.HQ_VOICE, HqVoiceMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.GIF, GifMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.REFERENCE, ReferenceMessage$2), _defineProperty(_commonMessageTypeMap, MessageType$1.RICH_CONTENT, RichMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.LOCATION, LocationMessage), _defineProperty(_commonMessageTypeMap, MessageType$1.HQ_VOICE, HqVoiceMessage), _commonMessageTypeMap);

function getMessageBody(message, callback) {
  var Func = commonMessageTypeMap[message.messageType] || ntfMessageTypeMap[message.messageType];

  if (!Func) {
    return '不识别的消息内容';
  }

  return new Func(message, callback).create();
}

var messageGroupCss = ".message-item{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:start;justify-content:flex-start;margin:0 1.5em;padding:2em 0}.ntf-message-item{display:block}.ntf-message-item .tip-content{text-align:center}.message-item.receiver{-ms-flex-direction:row;flex-direction:row}.message-item.poster{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.message-item .avatar{width:6em;height:6em;border-radius:50%;background:#4790ee;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;overflow:hidden;-ms-flex-negative:0;flex-shrink:0}.message-item .avatar img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.message-item .message-body-wrapper{position:relative;padding:0 1.6em;max-width:50em;-webkit-box-sizing:border-box;box-sizing:border-box}.message-item .message-body-wrapper .name{color:#a0a5ab;font-size:1.8em;line-height:1;margin:0 0 0.4em}.message-item .message-body{font-size:2.4em;border:0.1em solid #ccc;border-radius:1em;position:relative}.message-body .receive-status{width:3.67em;position:absolute;left:-4.2em;bottom:-0.2em;font-size:0.75em;color:#0099ff;text-align:right}.message-item.poster .message-body{border-radius:0.6667em 0.16666em 0.6667em 0.6667em;background:#d7eefd;border:1px solid #bdd9eb}.message-item.receiver .message-body{border-radius:0.16666em 0.6667em 0.6667em 0.6667em;border:1px solid #e2e4e5;background:#fff}.message-content p{margin:0;padding:0;line-height:1.5;font-weight:400;word-break:break-word}.time-separation,.message-group-notifi{font-size:2em;text-align:center;padding:1.5em;color:#a0a5ab}.message-item.fail .receive-status,.message-item.sending .receive-status{display:none}.message-item.sending .message-body::before,.message-item.fail .message-body::before{content:' ';display:block;width:1.6667em;height:1.6667em;background-repeat:no-repeat;background-size:contain;position:absolute;left:-2.2em;bottom:0}.message-item.fail .message-body::before{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjUgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5oSf5Y+55Y+3PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAyX+WNleiBii3ljZXogYrlkJHkuIrmu5rliqjml7YtbG9hZGluZyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNC4wMDAwMDAsIC02MzkuMDAwMDAwKSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IuaEn+WPueWPtyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA0LjQwMDAwMCwgNjM5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uELTI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUwMDAwMCwgMS41MDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiNGRjQxNDEiIGN4PSIxMC41IiBjeT0iMTAuNSIgcj0iMTAuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgZmlsbD0iI0ZGRkZGRiIgeD0iOS43NSIgeT0iNS4yNSIgd2lkdGg9IjEuNSIgaGVpZ2h0PSI3LjUiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiNGRkZGRkYiIGN4PSIxMC41IiBjeT0iMTUiIHI9IjEiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}.message-item.sending .message-body::before{content:' ';display:inline-block;width:1.5em;height:1.5em;background:url(data:image/svg+xml;base64,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) no-repeat;-webkit-animation:loading 1s infinite;animation:loading 1s infinite;vertical-align:middle;}@-webkit-keyframes loading{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes loading{from{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.text-message-body,.location-message-body{padding:0.5em 0.8333em}.file-message-body{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0.83333em;display:-ms-flexbox;display:flex;max-width:20em;-ms-flex-align:center;align-items:center;}.file-message-body .file-message-icon{width:3.5em;height:3.5em;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;background-repeat:no-repeat;background-size:contain;margin:0 0.833333em 0 0}.file-message-body .file-message-icon.file-icon{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotf5pyq55+lPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iMC43Ij4KICAgICAgICA8ZyBpZD0i54q25oCB5YiH5Zu+IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjExLjAwMDAwMCwgLTcwMC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Imljb25f5paH5Lu257G75Z6LX+acquefpSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjExLjAwMDAwMCwgNzAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0zOC1Db3B5LTQiIGZpbGw9IiNCNUI5QkMiIHg9IjAiIHk9IjAiIHdpZHRoPSI4NCIgaGVpZ2h0PSI4NCIgcng9IjYiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC04IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMS4wMDAwMDAsIDE0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNS41NDYzNTQyLDAgTDQxLjgwMywxNi4xNyBMNDEuODAzMTI1LDUzLjYyMDU4NTMgQzQxLjgwMzEyNSw1NC43ODk3MjUgNDAuODUxNDY1Miw1NS43Mzc1IDM5LjY3MjYzMDgsNTUuNzM3NSBMMi4xMzA0OTQyNCw1NS43Mzc1IEMwLjk1Mzg1NDc2MSw1NS43Mzc1IDAsNTQuNzkzNDU3OSAwLDUzLjYyMDU4NTMgTDAsMi4xMTY5MTQ2OSBDMCwwLjk0Nzc3NDk5IDAuOTUxNjU5Nzk2LDAgMi4xMzA0OTQyNCwwIEwyNS41NDYzNTQyLDAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTI1LjU0NjM1NDIsMCBMNDEuODQxOTYzOSwxNi4yMDg4NjAxIEwyNi42MTU1NTQ2LDE2LjIwODg2MDEgQzI2LjAyNTA1MTUsMTYuMjA4ODYwMSAyNS41NDYzNTQyLDE1Ljc0MTI0MDkgMjUuNTQ2MzU0MiwxNS4xNDUzNTE1IEwyNS41NDYzNTQyLDAgWiIgaWQ9IlRyaWFuZ2xlLTMiIGZpbGw9IiNENkQ2RDYiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)}.file-message-body .file-message-icon.file-zip{background-image:url(data:image/svg+xml;base64,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)}.file-message-body .file-message-icon.file-word{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotfZG9jPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IueKtuaAgeWIh+WbviIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMS4wMDAwMDAsIC0yNzQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uX+aWh+S7tuexu+Wei19kb2MiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMS4wMDAwMDAsIDI3NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC02IiBmaWxsPSIjNjBBN0ZFIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTM4IiB4PSIwIiB5PSIwIiB3aWR0aD0iODQiIGhlaWdodD0iODQiIHJ4PSI2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjIuOTU0NTQ1NSwyMCBMMjIuOTU0LDU0LjQ0MyBMNDEuNDQ0MzQ2NCwzNi4wMDUwOTYyIEw0Ni4yMTk4NDI5LDQwLjc2NzI1MDYgTDQ2LjIxMyw0MC43NzMgTDYwLjA0NSw1NC40MzggTDYwLjA0NTQ1NDUsMjAgTDY3LDIwIEw2Nyw2My45MjIzOTgyIEw2MC4xNTMsNjMuOTIyIEw2MC4wNzkyNjk5LDY0IEw0MS41LDQ1LjQ3MyBMMjIuOTU5NDI2OSw2My45NjI2ODA1IEwyMi45MjEsNjMuOTIyIEwxNiw2My45MjIzOTgyIEwxNiwyMCBMMjIuOTU0NTQ1NSwyMCBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)}.file-message-body .file-message-icon.file-xls{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotfZXhjZWw8L3RpdGxlPgogICAgPGcgaWQ9Iumhtemdoi0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i54q25oCB5YiH5Zu+IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjExLjAwMDAwMCwgLTQ4OC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Imljb25f5paH5Lu257G75Z6LX2V4Y2VsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTEuMDAwMDAwLCA0ODguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTM4LUNvcHktMiIgZmlsbD0iIzAyRDFBNSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijg0IiBoZWlnaHQ9Ijg0IiByeD0iNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTYzLDIxIEw0Ni45NzEsNDEuNSBMNjMsNjIgTDUzLjAzODU4MTksNjEuOTc2NzkwNSBMNDEuOTk5LDQ3Ljg1OCBMMzAuOTYxNDE4MSw2MS45NzY3OTA1IEwyMSw2MiBMMzcuMDI4LDQxLjUgTDIxLDIxIEwzMC45NjE0MTgxLDIxLjAyMzIwOTUgTDQyLDM1LjE0MSBMNTMuMDM4NTgxOSwyMS4wMjMyMDk1IEw2MywyMSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)}.file-message-body .file-message-icon.file-ppt{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotfcHB0PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IueKtuaAgeWIh+WbviIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMS4wMDAwMDAsIC05MTIuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uX+aWh+S7tuexu+Wei19wcHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMS4wMDAwMDAsIDkxMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMzgtQ29weS01IiBmaWxsPSIjRkY4NjU0IiB4PSIwIiB5PSIwIiB3aWR0aD0iODQiIGhlaWdodD0iODQiIHJ4PSI2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjYsMjAgTDQ1Ljg2MDcxODIsMjAgQzQ4LjQ3MjI2NTUsMjAgNTAuNzc2OTIxNSwyMC40MjAyOTE0IDUyLjc3NDc1NTIsMjEuMjYwODg2OCBDNTQuNzcyNTg4OSwyMi4xMDE0ODIyIDU2LjQ1NzAxMTYsMjMuMjAwNzA1OCA1Ny44MjgwNzQsMjQuNTU4NTkwNyBDNTkuMTk5MTM2MywyNS45MTY0NzU1IDYwLjIzNzIxMDgsMjcuNDQyNDU2NiA2MC45NDIzMjg2LDI5LjEzNjU3OTYgQzYxLjY0NzQ0NjQsMzAuODMwNzAyNiA2MiwzMi41MTgzMzQyIDYyLDM0LjE5OTUyNDkgQzYyLDM2LjAzNTkwMjYgNjEuNjQwOTE3NiwzNy44MDc1OTI0IDYwLjkyMjc0MjEsMzkuNTE0NjQ3NyBDNjAuMjA0NTY2Niw0MS4yMjE3MDI5IDU5LjE1OTk2MzMsNDIuNzQxMjE3OSA1Ny43ODg5MDEsNDQuMDczMjM4MyBDNTYuNDE3ODM4Niw0NS40MDUyNTg3IDU0LjczMzQxNTksNDYuNDcyMTUyMiA1Mi43MzU1ODIyLDQ3LjI3Mzk1MDkgQzUwLjczNzc0ODQsNDguMDc1NzQ5NiA0OC40NDYxNSw0OC40NzY2NDI5IDQ1Ljg2MDcxODIsNDguNDc2NjQyOSBMMzQuMjY1NTA2LDQ4LjQ3NjY0MjkgTDM0LjI2NTUwNiw2OSBMMjYsNjkgTDI2LDIwIFogTTM0LjI2NTUwNiw0Mi44NTExNDgxIEw0NS44NjA3MTgyLDQyLjg1MTE0ODEgQzQ2LjkwNTMzNzEsNDIuODUxMTQ4MSA0Ny45MTA3Njc3LDQyLjYyNDgzNzMgNDguODc3MDQwMyw0Mi4xNzIyMDkgQzQ5Ljg0MzMxMjgsNDEuNzE5NTgwNyA1MC42ODU1MjQyLDQxLjA5ODg0MjcgNTEuNDAzNjk5Nyw0MC4zMDk5NzYyIEM1Mi4xMjE4NzUyLDM5LjUyMTEwOTggNTIuNjk2NDA3LDM4LjU5NjQ2ODcgNTMuMTI3MzEyMywzNy41MzYwMjUzIEM1My41NTgyMTc2LDM2LjQ3NTU4MTkgNTMuNzczNjY3LDM1LjMzNzU2MjIgNTMuNzczNjY3LDM0LjEyMTkzMTkgQzUzLjc3MzY2NywzMi45MzIxNjYxIDUzLjU3MTI3NTEsMzEuODI2NDc2NSA1My4xNjY0ODUzLDMwLjgwNDgyOTggQzUyLjc2MTY5NTUsMjkuNzgzMTgzMSA1Mi4yMDY3NSwyOC45MDM4MDQyIDUxLjUwMTYzMjIsMjguMTY2NjY2NyBDNTAuNzk2NTE0NCwyNy40Mjk1MjkyIDQ5Ljk2MDgzMTgsMjYuODQ3NTg3MiA0OC45OTQ1NTkzLDI2LjQyMDgyMzQgQzQ4LjAyODI4NjgsMjUuOTk0MDU5NiA0Ni45ODM2ODM1LDI1Ljc4MDY4MDkgNDUuODYwNzE4MiwyNS43ODA2ODA5IEwzNC4yNjU1MDYsMjUuNzgwNjgwOSBMMzQuMjY1NTA2LDQyLjg1MTE0ODEgWiIgaWQ9IlAiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)}.file-message-body .file-message-icon.file-pdf{background-image:url(data:image/svg+xml;base64,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)}.file-message-body .file-message-icon.file-audio{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotfbXAzPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IueKtuaAgeWIh+WbviIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMS4wMDAwMDAsIC0zODIuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uX+aWh+S7tuexu+Wei19tcDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMS4wMDAwMDAsIDM4Mi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMzgtQ29weSIgZmlsbD0iIzg5RDA0MiIgeD0iMCIgeT0iMCIgd2lkdGg9Ijg0IiBoZWlnaHQ9Ijg0IiByeD0iNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTM3LjQ3NTIyMjcsMzEuNzU2NTMyMyBMNTEuODYwODE3MSw1Ni4yNDQyMzQgQzU0LjQ1OTc1Miw2MC42NjgyMzkgNTIuNDYxMjgxNSw2Ni41ODQwMTU4IDQ3LjM5NzEwODQsNjkuNDU3NDkxMyBDNDIuMzMyOTM1Myw3Mi4zMzA5NjY5IDM2LjEyMDc1ODksNzEuMDc0MDE0NCAzMy41MjE4MjQxLDY2LjY1MDAwOTQgQzMwLjkyMjg4OTIsNjIuMjI2MDA0NCAzMi45MjEzNTk3LDU2LjMxMDIyNzYgMzcuOTg1NTMyOCw1My40MzY3NTIxIEM0MC44NjYwNDQ3LDUxLjgwMjMxMzQgNDQuMTE3OTc2Niw1MS41MDQyMTU4IDQ2Ljg2NTEyNzQsNTIuMzY1MTcxNCBMMzEsMjUuMzU4OTUyOCBMMzEuMjQ4NDgzOCwyNS4yMTc5NiBMMzEuMjQwMzE0NCwyNS4yMDYyOTgzIEMzMS4yNDAzMTQ0LDI1LjIwNjI5ODMgMzEuNDIzNDIxNSwyNS4xMTA4NzI3IDMxLjc0NzU5NjEsMjQuOTM0NzU3NCBMMzMuMDM3NjY1OSwyNC4yMDI3NTU1IEwzMy4wNDMyNDAzLDI0LjIxMjI0NDQgQzM2LjUzMDQ0OCwyMi4yMjE1Mjk2IDQzLjk1MDU0OTEsMTcuNjI5MzUwNyA0NS4wMDg2MzA2LDE0LjA0NDI2ODUgQzQ2LjM5OTEyMDQsOS4zMzI4OTE4OSA1Mi4xMzQ5MjcxLDIxLjgxMzIxMDQgNDYuMzc2NTA1MSwyNi42MzM0MDI0IEM0Mi41NDQyMDQ3LDI5Ljg0MTI5OTMgMzkuMjUwMTE5NCwzMS4yMDM4OTUxIDM3LjQ3NTIyMjcsMzEuNzU2NTMyMyBMMzcuNDc1MjIyNywzMS43NTY1MzIzIFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}.file-message-body .file-message-icon.file-plain{background-image:url(data:image/svg+xml;base64,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)}.file-message-body .file-message-icon.file-video{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotfbXA0PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IueKtuaAgeWIh+WbviIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMS4wMDAwMDAsIC0xMDE4LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iaWNvbl/mlofku7bnsbvlnotfbXA0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTEuMDAwMDAwLCAxMDE4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0zOC1Db3B5LTYiIGZpbGw9IiNBMzk2RTgiIHg9IjAiIHk9IjAiIHdpZHRoPSI4NCIgaGVpZ2h0PSI4NCIgcng9IjYiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02Mi4zNDQ4NDI5LDI1IEM2My44MTEyNDU3LDI1IDY1LDI2LjE4NDU2NzkgNjUsMjcuNjU5NDE1NyBMNjUsNTcuMzQwNTg0MyBDNjUsNTguODA5MzM5IDYzLjgxNjY4ODcsNjAgNjIuMzQ0ODQyOSw2MCBMMjEuNjU1MTU3MSw2MCBDMjAuMTg4NzU0Myw2MCAxOSw1OC44MTU0MzIxIDE5LDU3LjM0MDU4NDMgTDE5LDI3LjY1OTQxNTcgQzE5LDI2LjE5MDY2MSAyMC4xODMzMTEzLDI1IDIxLjY1NTE1NzEsMjUgTDYyLjM0NDg0MjksMjUgWiBNMzcuMSwzNS4yNjU5Njk2IEwzNy4xLDUwLjg5MDY5OTMgQzM3LjEsNTIuMzU0MzUxMiAzOC4wNTM2MTMzLDUyLjgyOTk2OCAzOS4yMzE1MzU5LDUxLjk1MTg0MDYgTDQ5LjAwMjk0NjksNDQuNjY3MzY5MiBDNTAuMTgwMTYxNyw0My43ODk3Njk1IDUwLjE4MDg2OTUsNDIuMzY3NDI3IDQ5LjAwMjk0NjksNDEuNDg5Mjk5NyBMMzkuMjMxNTM1OSwzNC4yMDQ4MjgyIEMzOC4wNTQzMjExLDMzLjMyNzIyODYgMzcuMSwzMy44MDA3NzEyIDM3LjEsMzUuMjY1OTY5NiBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)}.file-message-body .file-message-icon.file-image{background-image:url(data:image/png;base64,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)}.file-message-body .file-message-icon.file-apk{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSI4NHB4IiB2aWV3Qm94PSIwIDAgODQgODQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbl/mlofku7bnsbvlnotfYXBrPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IueKtuaAgeWIh+WbviIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMS4wMDAwMDAsIC0xNjU0LjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uX+aWh+S7tuexu+Wei19hcGsiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMS4wMDAwMDAsIDE2NTQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNy44NzQ5OTk5NywwIEw3Ni4xMjUsMCBDODAuNDU2MjUsMCA4NCwzLjU0Mzc1IDg0LDcuODc0OTk5OTcgTDg0LDc2LjEyNSBDODQsODAuNDU2MjUgODAuNDU2MjUsODQgNzYuMTI1LDg0IEw3Ljg3NDk5OTk3LDg0IEMzLjU0Mzc1LDg0IDAsODAuNDU2MjUgMCw3Ni4xMjUgTDAsNy44NzQ5OTk5NyBDMCwzLjU0Mzc1IDMuNTQzNzUsMCA3Ljg3NDk5OTk3LDAgWiIgaWQ9Iui3r+W+hCIgZmlsbD0iI0EwQzUzOCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTU3Ljc2NjY2NjYsNDguNTEyODk0NyBDNTcuNzY2NjY2Niw1MC4xNjc0NjAzIDU5LjIzMzMzMzMsNTEuNjM4MTg1MiA2MC44ODMzMzMzLDUxLjYzODE4NTIgQzYyLjcxNjY2NjYsNTEuNjM4MTg1MiA2NCw1MC4xNjc0NjAzIDY0LDQ4LjUxMjg5NDcgTDY0LDM2LjE5NTU3MzQgQzY0LDM0LjM1NzE2NzIgNjIuNTMzMzMzMywzMy4wNzAyODI5IDYwLjg4MzMzMzMsMzMuMDcwMjgyOSBDNTkuMjMzMzMzMywzMy4wNzAyODI5IDU3Ljc2NjY2NjYsMzQuNTQxMDA3OCA1Ny43NjY2NjY2LDM2LjE5NTU3MzQgTDU3Ljc2NjY2NjYsNDguNTEyODk0NyBaIE00Ni41ODMzMzM0LDI1LjkwMDQ5ODkgQzQ2LjU4MzMzMzQsMjQuOTgxMjk1OCA0Ny4zMTY2NjY3LDI0LjQyOTc3MzkgNDguMDQ5OTk5OSwyNC40Mjk3NzM5IEM0OC45NjY2NjY2LDI0LjQyOTc3MzkgNDkuNjk5OTk5OSwyNS4xNjUxMzY0IDQ5LjY5OTk5OTksMjUuOTAwNDk4OSBDNDkuNjk5OTk5OSwyNi44MTk3MDIgNDguOTY2NjY2NiwyNy4zNzEyMjM3IDQ4LjA0OTk5OTksMjcuMzcxMjIzNyBDNDcuMTMzMzMzMywyNy4zNzEyMjM3IDQ2LjU4MzMzMzQsMjYuNjM1ODYxMyA0Ni41ODMzMzM0LDI1LjkwMDQ5ODkgWiBNMzQuNjY2NjY2NywyNS45MDA0OTg5IEMzNC42NjY2NjY3LDI0Ljk4MTI5NTggMzUuNCwyNC40Mjk3NzM5IDM2LjEzMzMzMzQsMjQuNDI5NzczOSBDMzcuMDUsMjQuNDI5NzczOSAzNy42MDAwMDAxLDI1LjE2NTEzNjQgMzcuNjAwMDAwMSwyNS45MDA0OTg5IEMzNy42MDAwMDAxLDI2LjgxOTcwMiAzNi44NjY2NjY3LDI3LjM3MTIyMzcgMzYuMTMzMzMzNCwyNy4zNzEyMjM3IEMzNS4yMTY2NjY3LDI3LjM3MTIyMzcgMzQuNjY2NjY2NywyNi42MzU4NjEzIDM0LjY2NjY2NjcsMjUuOTAwNDk4OSBaIE0yOC4wNjY2NjY3LDU1LjY4MjY3ODggQzI4LjA2NjY2NjcsNTYuOTY5NTYzMiAyOS4xNjY2NjY2LDU4LjA3MjYwNjggMzAuNDUsNTguMDcyNjA2NyBMMzMuMiw1OC4wNzI2MDY3IEwzMy4yLDY0Ljg3NDcwOTYgQzMzLjIsNjYuNTI5Mjc1MiAzNC40ODMzMzM0LDY4IDM2LjMxNjY2NjcsNjggQzM3Ljk2NjY2NjcsNjggMzkuNDMzMzMzNCw2Ni41MjkyNzUgMzkuNDMzMzMzNCw2NC44NzQ3MDk2IEwzOS40MzMzMzM0LDU4LjA3MjYwNjcgTDQ0LjM4MzMzMzMsNTguMDcyNjA2NyBMNDQuMzgzMzMzMyw2NC44NzQ3MDk2IEM0NC4zODMzMzMzLDY2LjUyOTI3NTIgNDUuNjY2NjY2Nyw2OCA0Ny41LDY4IEM0OS4zMzMzMzMzLDY4IDUwLjYxNjY2NjcsNjYuNTI5Mjc1IDUwLjYxNjY2NjYsNjQuODc0NzA5NiBMNTAuNjE2NjY2Niw1OC4wNzI2MDY3IEw1My4zNjY2NjY3LDU4LjA3MjYwNjcgQzU0LjgzMzMzMzQsNTguMDcyNjA2NyA1NS43NSw1Ni45Njk1NjMgNTUuNzUsNTUuNjgyNjc4OCBMNTUuNzUsMzMuMjU0MTIzNSBMMjguMDY2NjY2NywzMy4yNTQxMjM1IEwyOC4wNjY2NjY3LDU1LjY4MjY3ODggWiBNNTUuOTMzMzMzMywzMS4yMzE4NzY3IEM1NS41NjY2NjY3LDI3LjAwMzU0MjYgNTIuNjMzMzMzMywyMy41MTA1NzA5IDQ4LjYsMjEuNDg4MzI0IEw1MS4xNjY2NjY2LDE3LjgxMTUxMTcgQzUxLjM0OTk5OTksMTcuNjI3NjcxMiA1MS4zNDk5OTk5LDE3LjI1OTk4OTkgNTEuMTY2NjY2NiwxNy4wNzYxNDkzIEM1MC45ODMzMzMzLDE2Ljg5MjMwODcgNTAuOCwxNy4wNzYxNDkzIDUwLjYxNjY2NjYsMTcuMjU5OTg5OSBMNDcuODY2NjY2NiwyMS4xMjA2NDI4IEM0Ni4wMzMzMzMzLDIwLjM4NTI4MDQgNDQuMiwyMC4wMTc1OTkyIDQyLjE4MzMzMzMsMjAuMDE3NTk5MSBDNDAuMTY2NjY2NiwyMC4wMTc1OTg5IDM4LjE1LDIwLjM4NTI4MDIgMzYuMzE2NjY2NywyMS4xMjA2NDI4IEwzMy43NSwxNy4yNTk5ODk5IEMzMy41NjY2NjY3LDE3LjA3NjE0OTMgMzMuMzgzMzMzNCwxNi44OTIzMDg3IDMzLjIsMTcuMDc2MTQ5MyBDMzMuMDE2NjY2NywxNy4yNTk5ODk5IDMzLjAxNjY2NjcsMTcuNDQzODMwNCAzMy4wMTY2NjY3LDE3LjgxMTUxMTcgTDM1LjU4MzMzMzMsMjEuNDg4MzI0IEMzMS41NSwyMy4zMjY3MzAyIDI4LjYxNjY2NjcsMjYuODE5NzAxOCAyOC4yNSwzMS4yMzE4NzY3IEw1NS45MzMzMzMzLDMxLjIzMTg3NjcgTDU1LjkzMzMzMzMsMzEuMjMxODc2NyBaIE0yMCw0OC41MTI4OTQ3IEMyMCw1MC4xNjc0NjAzIDIxLjI4MzMzMzQsNTEuNjM4MTg1MiAyMy4xMTY2NjY3LDUxLjYzODE4NTIgQzI0Ljc2NjY2NjcsNTEuNjM4MTg1MiAyNi4yMzMzMzM0LDUwLjE2NzQ2MDMgMjYuMjMzMzMzNCw0OC41MTI4OTQ3IEwyNi4yMzMzMzM0LDM2LjE5NTU3MzQgQzI2LjIzMzMzMzQsMzQuMzU3MTY3MiAyNC43NjY2NjY3LDMzLjA3MDI4MjkgMjMuMTE2NjY2NywzMy4wNzAyODI5IEMyMS4yODMzMzM0LDMzLjA3MDI4MjkgMjAsMzQuNTQxMDA3OCAyMCwzNi4xOTU1NzM0IEwyMCw0OC41MTI4OTQ3IFoiIGlkPSLlvaLnirYiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)}.file-message-body .file-message-icon.file-text{background-image:url(data:image/svg+xml;base64,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)}.file-message-body .file-desc{width:7.9166em;margin:0 0.41666em 0 0}.file-message-body .file-desc .file-name{height:2.3333em;line-height:1.1;text-overflow:ellipsis;font-size:1em;margin:0 0 0.1667em;word-break:break-all;overflow:hidden;white-space:nowrap}.file-message-body .file-desc .file-size{font-weight:400;color:#c7cbce;line-height:0.83333em;font-size:0.75em}.file-message-body .file-download-btn{background:url(data:image/svg+xml;base64,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) no-repeat;background-size:contain;width:2.8333em;height:2.8333em;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;cursor:pointer}.hqvoice-message-body{-webkit-box-sizing:border-box;box-sizing:border-box;font-size:1em;color:#111f2c;padding:0.625em 0.8333em 0.625em;display:-ms-flexbox;display:flex}.message-item.receiver .hqvoice-message-body{-ms-flex-direction:row;flex-direction:row}.message-item.poster .hqvoice-message-body{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.hqvoice-message-body img{width:1.3333em;height:1.3333em}.message-item.receiver .hqvoice-message-body img{margin:0 1.6em 0 0}.message-item.poster .hqvoice-message-body img{margin:0 0 0 1.6em;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sight-message-body{max-width:12.5em;position:relative;border-radius:0.5em;border:1px solid #e2e4e5;overflow:hidden}.sight-message-body img{display:block}.sight-message-body .file-duration{font-size:0.8333em;color:#ffffff;position:absolute;line-height:1.166667em;right:0.58333em;bottom:0.416667em;z-index:2}.sight-message-body .start-play-btn{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background:rgba(0, 0, 0, 0.2);position:absolute;left:0;top:0;z-index:1;font-size:1em}.sight-message-body .start-play-btn button{background:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzJweCIgaGVpZ2h0PSI3MnB4IiB2aWV3Qm94PSIwIDAgNzIgNzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+57yW57uEIDEwPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjE2X+WNleiBii3lsI/op4bpopHmtojmga8tMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMzYuMDAwMDAwLCAtNTAzLjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtMTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMjAuMDAwMDAwLCA0NTEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uELTEwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTYuMDAwMDAwLCA1Mi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBjeD0iMzYiIGN5PSIzNiIgcj0iMzUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zMS41MzY0NDM1LDIzLjk3NjYzMTkgTDUwLjI0OTU5MiwzNS44NzE1NDI0IEM1MC43MTU2ODUxLDM2LjE2NzgxMTkgNTAuODUzMzU0MywzNi43ODU4MjkgNTAuNTU3MDg0OCwzNy4yNTE5MjIxIEM1MC40NzU2MTIyLDM3LjM4MDA5NTMgNTAuMzY2MDE1MSwzNy40ODgwMjcyIDUwLjIzNjYwOTgsMzcuNTY3NTI4MSBMMzEuNTIzNDYxMyw0OS4wNjQwNTMyIEMzMS4wNTI4ODczLDQ5LjM1MzE1MjkgMzAuNDM3MDUwMiw0OS4yMDYwMzkgMzAuMTQ3OTUwNSw0OC43MzU0NjUgQzMwLjA1MTIxMTcsNDguNTc4MDAxMSAzMCw0OC4zOTY4MDk4IDMwLDQ4LjIxMjAwMzggTDMwLDI0LjgyMDU2ODEgQzMwLDI0LjI2ODI4MzQgMzAuNDQ3NzE1MywyMy44MjA1NjgxIDMxLDIzLjgyMDU2ODEgQzMxLjE5MDAwOTksMjMuODIwNTY4MSAzMS4zNzYwODcyLDIzLjg3NDcwMjMgMzEuNTM2NDQzNSwyMy45NzY2MzE5IFoiIGlkPSLnn6nlvaIiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+) no-repeat;background-size:contain;width:3em;height:3em;border:none}.gif-message-body img{max-width:30em;display:block}.reference-message-body{padding:0.5833em 0.8333em;min-width:8.333em}.reference-message-body .reference-message-content{border-bottom:1px solid rgba(160, 165, 171, 0.26)}.reference-message-body .reference-message-content .user{font-size:0.83333em;color:#a0a5ab;border-left:0.16667em solid #a0a5ab;padding:0 0 0 0.41666em;height:1.08333em;line-height:1.08333em}.reference-message-body .reference-message-content .content{color:#111f2c;padding:0.41667em 0 0.3em 0.58333em;word-break:break-all}.reference-message-body .reference-message-content .content img{width:2.91667em;height:2.91667em;border-radius:0.25em}.reference-message-body .message-content{color:#111f2c;font-size:1em;padding:0.41667em 0 0 0.05833em;word-break:break-all;position:relative}.rich-message-body{padding:0.58333em 0.83333em}.rich-message-body .title{color:#111f2c;font-size:1em;max-height:4.16667em;line-height:1.41667em;overflow:hidden;text-overflow:ellipsis;word-break:break-all;-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box}.rich-message-body .content{line-height:1.4;color:#a0a5ab;font-size:0.83333em;overflow:hidden}.rich-message-body .content>p{height:5em;overflow:hidden;text-overflow:ellipsis;word-break:break-all;-webkit-line-clamp:4;-webkit-box-orient:vertical;display:-webkit-box}.rich-message-body .content img{float:right;width:4.6667em;height:4.6667em;overflow:hidden;text-overflow:ellipsis;word-break:break-all;border-radius:0.25em;border:1px solid #979797;margin:0 0 0 1em}.message-item.custom-notify-message-item{text-align:center;display:block;font-size:1.5em}a.url-wrap{color:#0099ff;text-decoration:none}.referenced-message-text{height:1em;line-height:1;overflow:hidden;text-overflow:ellipsis;word-break:keep-all}div.referenced-message-text:hover div{visibility:visible}.quote{position:absolute;top:2em;z-index:100}.quoteContent{width:100%;word-break:break-all;visibility:hidden;padding:0.17em;background:#fff;-webkit-box-shadow:0px 0px 15px 3px rgba(100, 102, 109, 0.19);box-shadow:0px 0px 15px 3px rgba(100, 102, 109, 0.19);border-radius:0.17em;font-size:0.8em;font-family:PingFangSC-Regular, PingFang SC, sans-serif;font-weight:400;color:#111f2c;line-height:1.2}.sendFail{content:' ';display:block;width:1.6667em;height:1.6667em;background-repeat:no-repeat;background-size:contain;position:absolute;left:-2.2em;bottom:0;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjUgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5oSf5Y+55Y+3PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAyX+WNleiBii3ljZXogYrlkJHkuIrmu5rliqjml7YtbG9hZGluZyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNC4wMDAwMDAsIC02MzkuMDAwMDAwKSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IuaEn+WPueWPtyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA0LjQwMDAwMCwgNjM5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uELTI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUwMDAwMCwgMS41MDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiNGRjQxNDEiIGN4PSIxMC41IiBjeT0iMTAuNSIgcj0iMTAuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgZmlsbD0iI0ZGRkZGRiIgeD0iOS43NSIgeT0iNS4yNSIgd2lkdGg9IjEuNSIgaGVpZ2h0PSI3LjUiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiNGRkZGRkYiIGN4PSIxMC41IiBjeT0iMTUiIHI9IjEiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=)}";

var MessageList$3 = /*#__PURE__*/function (_HTMLElement8) {
  _inherits(MessageList$3, _HTMLElement8);

  var _super22 = _createSuper(MessageList$3);

  function MessageList$3() {
    var _this72;

    _classCallCheck(this, MessageList$3);

    _this72 = _super22.call(this);

    _this72.__registerHost();

    _this72.rightClick = createEvent(_assertThisInitialized(_this72), "rightClick", 7);
    _this72.tapMessageItem = createEvent(_assertThisInitialized(_this72), "tapMessageItem", 7);
    _this72.lang = core.lang; // 语言标识

    _this72.lastTime = 0; // 记录时间线的时间点

    _this72.tapMessageHandler = _this72.tapMessageHandler.bind(_assertThisInitialized(_this72));
    _this72.rightClickHandler = _this72.rightClickHandler.bind(_assertThisInitialized(_this72));
    _this72.handleLanguageChanged = _this72.handleLanguageChanged.bind(_assertThisInitialized(_this72));
    return _this72;
  }

  _createClass(MessageList$3, [{
    key: "validateData",
    value: function validateData(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.lastTime = 0;
      }
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lastTime = 0;
      this.lang = event.lang;
    }
  }, {
    key: "findMember",
    value: function findMember(id) {
      if (this.groupMembers && this.groupMembers.length) {
        return this.groupMembers.find(function (one) {
          return one.id === id;
        });
      }

      return null;
    }
  }, {
    key: "getTimeLine",
    value: function getTimeLine(timestamp, locale) {
      return h("div", {
        "class": "time-separation"
      }, formatTime(timestamp, {
        hour: ':',
        minute: ''
      }, locale));
    }
  }, {
    key: "tapMessageHandler",
    value: function tapMessageHandler(data) {
      this.tapMessageItem.emit(data.detail);
    }
  }, {
    key: "getItem",
    value: function getItem(message) {
      if (message.messageType.indexOf('__RECALL') !== -1) {
        return null;
      } // 由于dom结构不同，需要先判断是否为通知类的消息


      if (ntfMessageTypeMap[message.messageType]) {
        return h("div", {
          "class": "message-item ntf-message-item"
        }, getMessageBody(message));
      }

      if (core.isCustomNotifyMessage(message)) {
        return h("div", {
          "class": "message-item custom-notify-message-item",
          innerHTML: core.createCustomNotifyMessageDom(message)
        });
      }

      var isGroupMember = message.conversationType === ConversationType.GROUP;
      var member = {
        groupNickname: '',
        id: '',
        name: ''
      };

      if (isGroupMember) {
        var res = this.findMember(message.senderUserId);

        if (res) {
          member = res;
        }
      }

      return h("message-item", {
        member: member,
        message: message,
        isGroupMember: isGroupMember,
        conversationProfile: this.conversationProfile,
        myProfile: this.myProfile,
        onRightClick: this.rightClickHandler,
        onTap: this.tapMessageHandler
      });
    }
  }, {
    key: "rightClickHandler",
    value: function rightClickHandler(event) {
      this.rightClick.emit(event.detail);
    }
  }, {
    key: "checkGroup",
    value: function checkGroup(locale) {
      var _this73 = this;

      var messages = this.messages;
      return messages.map(function (message) {
        // 进行5分钟归类
        if (message.sentTime - _this73.lastTime < 5 * 60 * 1000) {
          return h("li", {
            key: message.messageUId
          }, _this73.getItem(message));
        }

        _this73.lastTime = message.sentTime;
        return h("li", {
          key: message.messageUId
        }, _this73.getTimeLine(message.sentTime, locale), _this73.getItem(message));
      });
    }
  }, {
    key: "render",
    value: function render() {
      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var locale = this.locale;
      return h("ul", {
        style: {
          'list-style': 'none',
          padding: '0',
          margin: '0'
        }
      }, this.checkGroup(locale));
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "messages": ["validateData"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return messageGroupCss;
    }
  }]);

  return MessageList$3;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var messageItemCss = ".message-item.image-message-item .message-body,.message-item.sight-message-item .message-body,.message-item.gif-message-item .message-body{background:none;border:none;padding:0}.message-item.image-message-item .message-body .image-message-body img{max-width:10em;min-width:2.5em}.message-item.image-message-item .image-message-body{min-width:2.2222em;min-height:2.2222em;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.message-item.file-message-item .upload-progress-mask{width:1.165em;height:1.165em;min-width:1.165em;top:0.27em;left:0.27em;border-radius:0.1em;background:none}.message-item.file-message-item .upload-progress-mask .upload-progress-bar{width:141.4%;height:141.4%}.message-item.file-message-item .upload-progress-mask .upload-progress-bar svg path{fill:rgba(0, 0, 0, .4)}.message-item .name{color:#a0a5ab;font-size:1.8em;line-height:1;margin:0 0 0 4.5em;position:absolute}.message-body-margin{margin-top:2em}";

var MessageList$2 = /*#__PURE__*/function (_HTMLElement9) {
  _inherits(MessageList$2, _HTMLElement9);

  var _super23 = _createSuper(MessageList$2);

  function MessageList$2() {
    var _this74;

    _classCallCheck(this, MessageList$2);

    _this74 = _super23.call(this);

    _this74.__registerHost();

    _this74.rightClick = createEvent(_assertThisInitialized(_this74), "rightClick", 7);
    _this74.tap = createEvent(_assertThisInitialized(_this74), "tap", 7);
    _this74.lang = core.lang; // 语言标识

    _this74.handleClick = _this74.handleClick.bind(_assertThisInitialized(_this74));
    _this74.handleFail = _this74.handleFail.bind(_assertThisInitialized(_this74));
    _this74.handleLanguageChanged = _this74.handleLanguageChanged.bind(_assertThisInitialized(_this74));
    return _this74;
  }

  _createClass(MessageList$2, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged); // 中英文切换

      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "getMessageStyleClass",
    value: function getMessageStyleClass(message) {
      var _styleMap;

      var styleMap = (_styleMap = {}, _defineProperty(_styleMap, MessageType$1.IMAGE, 'image-message-item'), _defineProperty(_styleMap, MessageType$1.SIGHT, 'sight-message-item'), _defineProperty(_styleMap, MessageType$1.GIF, 'gif-message-item'), _defineProperty(_styleMap, MessageType$1.FILE, 'file-message-item'), _styleMap);
      return "".concat(styleMap[message.messageType] || message.messageType, " ");
    }
  }, {
    key: "rightClickHandler",
    value: function rightClickHandler(message, e) {
      if (e.button !== 2) {
        return null;
      }

      e.preventDefault();
      return this.rightClick.emit({
        message: message,
        position: {
          top: e.clientY,
          left: e.clientX
        }
      });
    }
  }, {
    key: "getReceivedStatus",
    value: function getReceivedStatus(message, locale) {
      var receivedStatus = '';

      if (message.messageDirection === MessageDirection$1.SEND && message.conversationType === ConversationType$1.PRIVATE) {
        // 判断是否已读
        if (message.receivedStatus === ReceivedStatus$1.UNREAD) {
          // 暂时不显示已读未读状态 receivedStatus = "未读";
          receivedStatus = locale.conversation.unread;
        } else {
          // 暂时不显示已读未读状态 receivedStatus = "已读";
          receivedStatus = locale.conversation.read;
        }
      }

      return receivedStatus;
    }
  }, {
    key: "getProgressBar",
    value: function getProgressBar(message) {
      return message.messageUId.indexOf('sending') === 0 && message.messageId && [MessageType$1.IMAGE, MessageType$1.FILE, MessageType$1.SIGHT, MessageType$1.HQ_VOICE, MessageType$1.GIF].indexOf(message.messageType) !== -1 ? h("progress-bar", {
        mId: message.messageId,
        reverse: message.messageType === MessageType$1.FILE
      }) : null;
    }
  }, {
    key: "handleClick",
    value: function handleClick(data) {
      this.tap.emit(data);
    }
  }, {
    key: "handleFail",
    value: function handleFail() {
      var conversation = {
        conversationType: this.message.conversationType,
        targetId: this.message.targetId,
        channelId: this.message.channelId
      };
      core.resendMessage(conversation, this.message);
    }
  }, {
    key: "showAvatar",
    value: function showAvatar() {
      if (this.isGroupMember) {
        return this.member && this.member.portraitUri ? h("img", {
          src: this.member.portraitUri
        }) : null;
      }

      if (this.message.messageDirection === MessageDirection$1.RECEIVE) {
        return this.conversationProfile ? h("img", {
          src: this.conversationProfile.portraitUri
        }) : null;
      }

      return this.myProfile ? h("img", {
        src: this.myProfile.portraitUri
      }) : null;
    }
  }, {
    key: "showMessage",
    value: function showMessage() {
      if (commonMessageTypeMap[this.message.messageType]) {
        return h(Fragment, null, this.message.messageUId.startsWith('fail_') ? h("div", {
          onClick: this.handleFail,
          "class": "sendFail"
        }) : h("div", {
          "class": "receive-status"
        }, ' ', this.getReceivedStatus(this.message, this.locale), ' '), getMessageBody(this.message, this.handleClick), this.getProgressBar(this.message));
      }

      if (core.isCustomUserMessage(this.message)) {
        return h("div", null, h("div", {
          "class": "receive-status"
        }, ' ', this.getReceivedStatus(this.message, this.locale), ' '), h("div", {
          innerHTML: core.createCustomUserMessageDom(this.message)
        }));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this75 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var message = this.message,
          isGroupMember = this.isGroupMember,
          member = this.member; // 是否为内置支持的消息类型

      if (!commonMessageTypeMap[message.messageType] && !core.isCustomUserMessage(message)) {
        core.logger.info(LogTagId.A_KIT_MESSAGE_UNKNOW_O, JSON.stringify({
          msg: '无法识别的消息',
          message: message
        }));
        return null;
      }

      return h("div", {
        "class": "message-item ".concat(this.getMessageStyleClass(message)).concat(message.conversationType === ConversationType$1.SYSTEM ? 'system-user-message-item ' : '').concat(message.messageDirection === MessageDirection$1.RECEIVE ? 'receiver ' : 'poster ').concat(message.messageUId.startsWith('sending_') ? 'sending ' : ''),
        key: message.messageUId,
        "data-key": message.messageUId
      }, h("div", {
        "class": "avatar"
      }, this.showAvatar()), isGroupMember && message.messageDirection === MessageDirection$1.RECEIVE ? h("div", {
        "class": "name"
      }, h("span", null, member.groupNickname || member.name || member.id)) : null, h("div", {
        "class": "message-body-wrapper ".concat(isGroupMember && message.messageDirection === MessageDirection$1.RECEIVE ? 'message-body-margin' : ''),
        onContextMenu: function onContextMenu(e) {
          return _this75.rightClickHandler(message, e);
        }
      }, message.conversationType === ConversationType$1.SYSTEM ? h("div", {
        "class": "name"
      }, h("span", null, this.conversationProfile.name)) : null, h("div", {
        "class": "message-body"
      }, this.showMessage())));
    }
  }], [{
    key: "style",
    get: function get() {
      return messageItemCss;
    }
  }]);

  return MessageList$2;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
/*!
 * better-scroll / pull-down
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
// ssr support


var inBrowser = typeof window !== 'undefined';
var ua = inBrowser && navigator.userAgent.toLowerCase();
!!(ua && /wechatdevtools/.test(ua));
ua && ua.indexOf('android') > 0;
/* istanbul ignore next */

(function () {
  if (typeof ua === 'string') {
    var regex = /os (\d\d?_\d(_\d)?)/;
    var matches = regex.exec(ua);
    if (!matches) return false;
    var parts = matches[1].split('_').map(function (item) {
      return parseInt(item, 10);
    }); // ios version >= 13.4 issue 982

    return !!(parts[0] === 13 && parts[1] >= 4);
  }

  return false;
})();
/* istanbul ignore next */


if (inBrowser) {
  var EventName = 'test-passive';

  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', {
      get: function get() {}
    }); // https://github.com/facebook/flow/issues/285

    window.addEventListener(EventName, function () {}, opts);
  } catch (e) {}
}

var extend = function extend(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
};

var elementStyle = inBrowser && document.createElement('div').style;

var vendor = function () {
  /* istanbul ignore if  */
  if (!inBrowser) {
    return false;
  }

  var transformNames = [{
    key: 'standard',
    value: 'transform'
  }, {
    key: 'webkit',
    value: 'webkitTransform'
  }, {
    key: 'Moz',
    value: 'MozTransform'
  }, {
    key: 'O',
    value: 'OTransform'
  }, {
    key: 'ms',
    value: 'msTransform'
  }];

  for (var _i = 0, transformNames_1 = transformNames; _i < transformNames_1.length; _i++) {
    var obj = transformNames_1[_i];

    if (elementStyle[obj.value] !== undefined) {
      return obj.key;
    }
  }
  /* istanbul ignore next  */


  return false;
}();
/* istanbul ignore next  */


function prefixStyle(style) {
  if (vendor === false) {
    return style;
  }

  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }

    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

vendor && vendor !== 'standard' ? '-' + vendor.toLowerCase() + '-' : '';
var transform = prefixStyle('transform');
var transition = prefixStyle('transition');
inBrowser && prefixStyle('perspective') in elementStyle;
({
  transform: transform,
  transition: transition,
  transitionTimingFunction: prefixStyle('transitionTimingFunction'),
  transitionDuration: prefixStyle('transitionDuration'),
  transitionDelay: prefixStyle('transitionDelay'),
  transformOrigin: prefixStyle('transformOrigin'),
  transitionEnd: prefixStyle('transitionEnd'),
  transitionProperty: prefixStyle('transitionProperty')
});
var ease = {
  // easeOutQuint
  swipe: {
    style: 'cubic-bezier(0.23, 1, 0.32, 1)',
    fn: function fn(t) {
      return 1 + --t * t * t * t * t;
    }
  },
  // easeOutQuard
  swipeBounce: {
    style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    fn: function fn(t) {
      return t * (2 - t);
    }
  },
  // easeOutQuart
  bounce: {
    style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    fn: function fn(t) {
      return 1 - --t * t * t * t;
    }
  }
};
var sourcePrefix = 'plugins.pullDownRefresh';
var propertiesMap = [{
  key: 'finishPullDown',
  name: 'finishPullDown'
}, {
  key: 'openPullDown',
  name: 'openPullDown'
}, {
  key: 'closePullDown',
  name: 'closePullDown'
}, {
  key: 'autoPullDownRefresh',
  name: 'autoPullDownRefresh'
}];
var propertiesConfig = propertiesMap.map(function (item) {
  return {
    key: item.key,
    sourceKey: sourcePrefix + "." + item.name
  };
});
var PULLING_DOWN_EVENT = 'pullingDown';
var ENTER_THRESHOLD_EVENT = 'enterThreshold';
var LEAVE_THRESHOLD_EVENT = 'leaveThreshold';

var PullDown =
/** @class */
function () {
  function PullDown(scroll) {
    this.scroll = scroll;
    this.pulling = 0
    /* DEFAULT */
    ;
    this.thresholdBoundary = 0
    /* DEFAULT */
    ;
    this.init();
  }

  PullDown.prototype.setPulling = function (status) {
    this.pulling = status;
  };

  PullDown.prototype.setThresholdBoundary = function (boundary) {
    this.thresholdBoundary = boundary;
  };

  PullDown.prototype.init = function () {
    this.handleBScroll();
    this.handleOptions(this.scroll.options.pullDownRefresh);
    this.handleHooks();
    this.watch();
  };

  PullDown.prototype.handleBScroll = function () {
    this.scroll.registerType([PULLING_DOWN_EVENT, ENTER_THRESHOLD_EVENT, LEAVE_THRESHOLD_EVENT]);
    this.scroll.proxy(propertiesConfig);
  };

  PullDown.prototype.handleOptions = function (userOptions) {
    if (userOptions === void 0) {
      userOptions = {};
    }

    userOptions = userOptions === true ? {} : userOptions;
    var defaultOptions = {
      threshold: 90,
      stop: 40
    };
    this.options = extend(defaultOptions, userOptions);
    this.scroll.options.probeType = 3
    /* Realtime */
    ;
  };

  PullDown.prototype.handleHooks = function () {
    var _this = this;

    this.hooksFn = [];
    var scroller = this.scroll.scroller;
    var scrollBehaviorY = scroller.scrollBehaviorY;
    this.currentMinScrollY = this.cachedOriginanMinScrollY = scrollBehaviorY.minScrollPos;
    this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.contentChanged, function () {
      _this.finishPullDown();
    });
    this.registerHooks(scrollBehaviorY.hooks, scrollBehaviorY.hooks.eventTypes.computeBoundary, function (boundary) {
      // content is smaller than wrapper
      if (boundary.maxScrollPos > 0) {
        // allow scrolling when content is not full of wrapper
        boundary.maxScrollPos = -1;
      }

      boundary.minScrollPos = _this.currentMinScrollY;
    }); // integrate with mousewheel

    if (this.hasMouseWheelPlugin()) {
      this.registerHooks(this.scroll, this.scroll.eventTypes.alterOptions, function (mouseWheelOptions) {
        var SANE_DISCRETE_TIME = 300;
        var SANE_EASE_TIME = 350;
        mouseWheelOptions.discreteTime = SANE_DISCRETE_TIME; // easeTime > discreteTime ensure goInto checkPullDown function

        mouseWheelOptions.easeTime = SANE_EASE_TIME;
      });
      this.registerHooks(this.scroll, this.scroll.eventTypes.mousewheelEnd, function () {
        // mouseWheel need trigger checkPullDown manually
        scroller.hooks.trigger(scroller.hooks.eventTypes.end);
      });
    }
  };

  PullDown.prototype.registerHooks = function (hooks, name, handler) {
    hooks.on(name, handler, this);
    this.hooksFn.push([hooks, name, handler]);
  };

  PullDown.prototype.hasMouseWheelPlugin = function () {
    return !!this.scroll.eventTypes.alterOptions;
  };

  PullDown.prototype.watch = function () {
    var scroller = this.scroll.scroller;
    this.watching = true;
    this.registerHooks(scroller.hooks, scroller.hooks.eventTypes.end, this.checkPullDown);
    this.registerHooks(this.scroll, this.scroll.eventTypes.scrollStart, this.resetStateBeforeScrollStart);
    this.registerHooks(this.scroll, this.scroll.eventTypes.scroll, this.checkLocationOfThresholdBoundary);

    if (this.hasMouseWheelPlugin()) {
      this.registerHooks(this.scroll, this.scroll.eventTypes.mousewheelStart, this.resetStateBeforeScrollStart);
    }
  };

  PullDown.prototype.resetStateBeforeScrollStart = function () {
    // current fetching pulldownRefresh has ended
    if (!this.isFetchingStatus()) {
      this.setPulling(1
      /* MOVING */
      );
      this.setThresholdBoundary(0
      /* DEFAULT */
      );
    }
  };

  PullDown.prototype.checkLocationOfThresholdBoundary = function () {
    // pulldownRefresh is in the phase of Moving
    if (this.pulling === 1
    /* MOVING */
    ) {
      var scroll_1 = this.scroll; // enter threshold boundary

      var enteredThresholdBoundary = this.thresholdBoundary !== 1
      /* INSIDE */
      && this.locateInsideThresholdBoundary(); // leave threshold boundary

      var leftThresholdBoundary = this.thresholdBoundary !== 2
      /* OUTSIDE */
      && !this.locateInsideThresholdBoundary();

      if (enteredThresholdBoundary) {
        this.setThresholdBoundary(1
        /* INSIDE */
        );
        scroll_1.trigger(ENTER_THRESHOLD_EVENT);
      }

      if (leftThresholdBoundary) {
        this.setThresholdBoundary(2
        /* OUTSIDE */
        );
        scroll_1.trigger(LEAVE_THRESHOLD_EVENT);
      }
    }
  };

  PullDown.prototype.locateInsideThresholdBoundary = function () {
    return this.scroll.y <= this.options.threshold;
  };

  PullDown.prototype.unwatch = function () {
    var scroll = this.scroll;
    var scroller = scroll.scroller;
    this.watching = false;
    scroller.hooks.off(scroller.hooks.eventTypes.end, this.checkPullDown);
    scroll.off(scroll.eventTypes.scrollStart, this.resetStateBeforeScrollStart);
    scroll.off(scroll.eventTypes.scroll, this.checkLocationOfThresholdBoundary);

    if (this.hasMouseWheelPlugin()) {
      scroll.off(scroll.eventTypes.mousewheelStart, this.resetStateBeforeScrollStart);
    }
  };

  PullDown.prototype.checkPullDown = function () {
    var _a = this.options,
        threshold = _a.threshold,
        stop = _a.stop; // check if a real pull down action

    if (this.scroll.y < threshold) {
      return false;
    }

    if (this.pulling === 1
    /* MOVING */
    ) {
      this.modifyBehaviorYBoundary(stop);
      this.setPulling(2
      /* FETCHING */
      );
      this.scroll.trigger(PULLING_DOWN_EVENT);
    }

    this.scroll.scrollTo(this.scroll.x, stop, this.scroll.options.bounceTime, ease.bounce);
    return this.isFetchingStatus();
  };

  PullDown.prototype.isFetchingStatus = function () {
    return this.pulling === 2
    /* FETCHING */
    ;
  };

  PullDown.prototype.modifyBehaviorYBoundary = function (stopDistance) {
    var scrollBehaviorY = this.scroll.scroller.scrollBehaviorY; // manually modify minScrollPos for a hang animation
    // to prevent from resetPosition

    this.cachedOriginanMinScrollY = scrollBehaviorY.minScrollPos;
    this.currentMinScrollY = stopDistance;
    scrollBehaviorY.computeBoundary();
  };

  PullDown.prototype.finishPullDown = function () {
    if (this.isFetchingStatus()) {
      var scrollBehaviorY = this.scroll.scroller.scrollBehaviorY; // restore minScrollY since the hang animation has ended

      this.currentMinScrollY = this.cachedOriginanMinScrollY;
      scrollBehaviorY.computeBoundary();
      this.setPulling(0
      /* DEFAULT */
      );
      this.scroll.resetPosition(this.scroll.options.bounceTime, ease.bounce);
    }
  }; // allow 'true' type is compat for beta version implements


  PullDown.prototype.openPullDown = function (config) {
    if (config === void 0) {
      config = {};
    }

    this.handleOptions(config);

    if (!this.watching) {
      this.watch();
    }
  };

  PullDown.prototype.closePullDown = function () {
    this.unwatch();
  };

  PullDown.prototype.autoPullDownRefresh = function () {
    var _a = this.options,
        threshold = _a.threshold,
        stop = _a.stop;

    if (this.isFetchingStatus() || !this.watching) {
      return;
    }

    this.modifyBehaviorYBoundary(stop);
    this.scroll.trigger(this.scroll.eventTypes.scrollStart);
    this.scroll.scrollTo(this.scroll.x, threshold);
    this.setPulling(2
    /* FETCHING */
    );
    this.scroll.trigger(PULLING_DOWN_EVENT);
    this.scroll.scrollTo(this.scroll.x, stop, this.scroll.options.bounceTime, ease.bounce);
  };

  PullDown.pluginName = 'pullDownRefresh';
  return PullDown;
}();

var messageListCss = ".message-container{width:100%;height:100%;background:#fbfbfc}.message-list-container{height:calc(100% - 10.5em);overflow:hidden;position:relative}.message-list-scroller{min-height:101%}.message-list-wrapper{position:relative;height:100%;overflow:hidden}.conversation-info{border-bottom:0.1em solid #e3e5e6;padding:0 2.5em;height:10.4em;text-align:left}.conversation-info .receiver{padding:0 0 0;color:#333;font-size:2.8em;font-weight:500;line-height:3.714}.message-list{list-style:none;padding:0 1em}.pulldown-wrapper{position:absolute;width:100%;padding:2em;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform:translateY(-100%) translateZ(0);transform:translateY(-100%) translateZ(0);text-align:center;color:#999;font-size:2em}.message-loading{-webkit-box-sizing:border-box;box-sizing:border-box;text-align:center;color:rgb(153, 153, 153);font-size:2em}.no-data{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background:#fff}.no-data::before{content:\" \";display:block;width:12.8em;height:12.8em;background:url(data:image/svg+xml;base64,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) no-repeat;margin:0 0 1em}.no-data span{font-size:2.2em}.typing-status{position:absolute;bottom:20px;left:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;width:40px}.typing-status span{display:block;width:6px;height:6px;border-radius:50%;background:#111f2c}.typing-status span:nth-child(1){opacity:90%;-webkit-animation:animatedBackground_0 1s linear infinite;animation:animatedBackground_0 1s linear infinite}.typing-status span:nth-child(2){opacity:40%;-webkit-animation:animatedBackground_1 1s linear infinite;animation:animatedBackground_1 1s linear infinite}.typing-status span:nth-child(3){opacity:20%;-webkit-animation:animatedBackground_2 1s linear infinite;animation:animatedBackground_2 1s linear infinite}@-webkit-keyframes animatedBackground_0{0%{opacity:90%}33.33%{opacity:20%}66.66%{opacity:40%}100%{opacity:90%}}@keyframes animatedBackground_0{0%{opacity:90%}33.33%{opacity:20%}66.66%{opacity:40%}100%{opacity:90%}}@-webkit-keyframes animatedBackground_1{0%{opacity:40%}33.33%{opacity:90%}66.66%{opacity:20%}100%{opacity:40%}}@keyframes animatedBackground_1{0%{opacity:40%}33.33%{opacity:90%}66.66%{opacity:20%}100%{opacity:40%}}@-webkit-keyframes animatedBackground_2{0%{opacity:20%}33.33%{opacity:40%}66.66%{opacity:90%}100%{opacity:20%}}@keyframes animatedBackground_2{0%{opacity:20%}33.33%{opacity:40%}66.66%{opacity:90%}100%{opacity:20%}}";
BScroll.use(PullDown);
BScroll.use(MouseWheel);
var THRESHOLD = 70;
var STOP = 56;

var MessageList$1 = /*#__PURE__*/function (_HTMLElement10) {
  _inherits(MessageList$1, _HTMLElement10);

  var _super24 = _createSuper(MessageList$1);

  function MessageList$1() {
    var _this76;

    _classCallCheck(this, MessageList$1);

    _this76 = _super24.call(this);

    _this76.__registerHost();

    attachShadow(_assertThisInitialized(_this76));
    _this76.tapMessage = createEvent(_assertThisInitialized(_this76), "tapMessage", 7);
    _this76.baseSize = '16px'; // 禁用菜单

    _this76.disableMenu = []; // 消息撤回的最大有效期，单位为 s。默认 120s

    _this76.maxRecallDuration = 120;
    _this76.messages = [];
    _this76.hasMore = true;
    _this76.beforePullDown = true;
    _this76.isPullingDown = false;
    _this76.isLoading = false;
    _this76.lang = core.lang;
    _this76.groupMembers = [];
    _this76.isGetHistory = false; // 是否为拉取历史消息

    _this76.scrollWrapper = null;
    _this76.lastPosition = 0; // 下拉时记录当前的滚动位置

    _this76.handleSwitchConversation = _this76.handleSwitchConversation.bind(_assertThisInitialized(_this76));
    _this76.handleMessages = _this76.handleMessages.bind(_assertThisInitialized(_this76));
    _this76.pullingDownHandler = _this76.pullingDownHandler.bind(_assertThisInitialized(_this76));
    _this76.handleReceiptRequest = _this76.handleReceiptRequest.bind(_assertThisInitialized(_this76));
    _this76.handleSelectMessage = _this76.handleSelectMessage.bind(_assertThisInitialized(_this76));
    _this76.handleUpdateMessage = _this76.handleUpdateMessage.bind(_assertThisInitialized(_this76));
    _this76.handleDeleteMessage = _this76.handleDeleteMessage.bind(_assertThisInitialized(_this76));
    _this76.tapMessageHandler = _this76.tapMessageHandler.bind(_assertThisInitialized(_this76));
    _this76.handleTypingStatus = _this76.handleTypingStatus.bind(_assertThisInitialized(_this76));
    _this76.handleMouseLeave = _this76.handleMouseLeave.bind(_assertThisInitialized(_this76));
    _this76.handleLanguageChanged = _this76.handleLanguageChanged.bind(_assertThisInitialized(_this76));
    _this76.handleUserInfoChanged = _this76.handleUserInfoChanged.bind(_assertThisInitialized(_this76));
    _this76.handleGroupInfoChanged = _this76.handleGroupInfoChanged.bind(_assertThisInitialized(_this76));
    _this76.handleConversationInfoChanged = _this76.handleConversationInfoChanged.bind(_assertThisInitialized(_this76)); // 登陆成功-更新用户Profile

    core.on(CoreEvent.CONNECTED, function (connectStatus) {
      _this76.isConnect = connectStatus;

      if (_this76.isConnect) {
        _this76.updateMyProfile();

        return;
      }

      _this76.myProfile = null;
    });
    return _this76;
  }

  _createClass(MessageList$1, [{
    key: "updateMyProfile",
    value: function updateMyProfile() {
      var _this77 = this;

      core.getMyProfile().then(function (res) {
        _this77.myProfile = res;
      });
    }
  }, {
    key: "updateMessageList",
    value: function updateMessageList(option) {
      var _this78 = this;

      var currentConversation = option || core.currentConversation;

      if (currentConversation && currentConversation !== this.conversation) {
        core.getConversation(currentConversation).then(function (res) {
          if (res) {
            _this78.loadData(res);
          }
        });
      }
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.on(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.on(CoreEvent.MESSAGES, this.handleMessages);
      core.on(CoreEvent.MESSAGE_RECEIPT_REQUEST, this.handleReceiptRequest);
      core.on(CoreEvent.UPDATE_MESSAGE, this.handleUpdateMessage);
      core.on(CoreEvent.DELETE_MESSAGE, this.handleDeleteMessage);
      core.on(CoreEvent.MESSAGE_SEND_SUCCESS, this.handleUpdateMessage);
      core.on(CoreEvent.MESSAGE_SEND_FAIL, this.handleUpdateMessage);
      core.on(CoreEvent.TYPING_STATUS, this.handleTypingStatus);
      core.on(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.on(CoreEvent.USER_INFO_CHANGED, this.handleUserInfoChanged);
      core.on(CoreEvent.GROUP_INFO_CHANGED, this.handleGroupInfoChanged);
      core.on(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleConversationInfoChanged);
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      var _this79 = this;

      // 初始化完成时，dom可能还未准备就绪
      if (this.scrollWrapper) {
        this.mountScroller();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && _this79.bscroll) {
          // 切换到该页面时执行
          setTimeout(function () {
            _this79.bscroll.refresh();

            _this79.bscroll.scrollTo(0, _this79.bscroll.maxScrollY);
          }, 100);
        }
      });

      if (core.currentConversation) {
        this.handleSwitchConversation(core.currentConversation);
      }

      var connectStatus = getConnectionStatus();

      if (connectStatus === RCConnectionStatus$1.CONNECTED) {
        this.isConnect = true;
        this.updateMyProfile();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.bscroll) {
        this.bscroll.off('pullingDown', this.pullingDownHandler);
        this.bscroll.destroy();
      }

      core.off(CoreEvent.SWITCH_CONVERSATION, this.handleSwitchConversation);
      core.off(CoreEvent.MESSAGES, this.handleMessages);
      core.off(CoreEvent.MESSAGE_RECEIPT_REQUEST, this.handleReceiptRequest);
      core.off(CoreEvent.UPDATE_MESSAGE, this.handleUpdateMessage);
      core.off(CoreEvent.DELETE_MESSAGE, this.handleDeleteMessage);
      core.off(CoreEvent.MESSAGE_SEND_SUCCESS, this.handleUpdateMessage);
      core.off(CoreEvent.MESSAGE_SEND_FAIL, this.handleUpdateMessage);
      core.off(CoreEvent.TYPING_STATUS, this.handleTypingStatus);
      core.off(CoreEvent.LANGUAGE_CHANGED, this.handleLanguageChanged);
      core.off(CoreEvent.USER_INFO_CHANGED, this.handleUserInfoChanged);
      core.off(CoreEvent.GROUP_INFO_CHANGED, this.handleGroupInfoChanged);
      core.off(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleConversationInfoChanged);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // 下拉完毕后刷新Dom
      if (this.isGetHistory) {
        if (this.bscroll) {
          this.bscroll.refresh();
          this.bscroll.scrollTo(0, Math.min(0, this.lastPosition + this.bscroll.maxScrollY));
        }

        this.isGetHistory = false;
      }
    }
    /**
     * 装载滚动
     */

  }, {
    key: "mountScroller",
    value: function mountScroller() {
      var _this80 = this;

      if (!this.scrollWrapper) {
        return;
      }

      this.bscroll = new BScroll(this.scrollWrapper, {
        bindToWrapper: true,
        mouseWheel: {
          throttleTime: 30
        },
        scrollX: false,
        scrollY: true,
        pullDownRefresh: {
          threshold: THRESHOLD,
          stop: STOP
        },
        bounce: {
          top: true,
          bottom: false,
          left: false,
          right: false
        },
        // preventDefault: false,
        preventDefaultException: {
          className: /((hqvoice|sight|image|richContent)-message-body)|file-download-btn/
        }
      });
      this.bscroll.on('pullingDown', this.pullingDownHandler); // 防止右键进行拖拽

      this.bscroll.scroller.actionsHandler.wrapperEventRegister.events.forEach(function (e) {
        var event = e;

        if (event.name === 'mousedown') {
          event.handler = ActionsHandlerStart.bind(_this80.bscroll.scroller.actionsHandler);
        }
      }); // 滚动到第一条的位置

      setTimeout(function () {
        _this80.bscroll.refresh();

        _this80.bscroll.scrollTo(0, _this80.bscroll.maxScrollY);
      }, 600);
    }
    /**
     * 下拉获取历史消息
     */

  }, {
    key: "pullingDownHandler",
    value: function pullingDownHandler() {
      var _this81 = this;

      // 记录当前的位置
      this.lastPosition = -this.bscroll.maxScrollY; // 没有更多消息，不再处理下拉

      if (!this.hasMore) {
        this.beforePullDown = true;
        this.isPullingDown = false;
        this.bscroll.finishPullDown();
        return;
      }

      this.beforePullDown = false;
      this.isPullingDown = true;
      var lastestTime = Date.now();

      if (this.messages.length) {
        lastestTime = this.messages[0].sentTime;
      } // 先显示正在加载，然后开始请求数据，保证显示效果
      // setTimeout(() => {


      if (this.isConnect) {
        // 获取历史消息
        core.getMessages({
          conversationType: this.conversation.conversationType,
          targetId: this.conversation.targetId,
          channelId: this.conversation.channelId
        }, lastestTime, 30).then(function (messages) {
          // 判断是否有数据
          if (!messages.list.length) {
            _this81.hasMore = messages.hasMore;
            _this81.beforePullDown = true;
            _this81.isPullingDown = false;

            _this81.bscroll.finishPullDown();

            return;
          } // 判断返回的数据是否是当前会话的


          if (messages.list[0].conversationType !== _this81.conversation.conversationType || messages.list[0].targetId !== _this81.conversation.targetId || messages.list[0].channelId !== _this81.conversation.channelId) {
            _this81.beforePullDown = true;
            _this81.isPullingDown = false;

            _this81.bscroll.finishPullDown();

            return;
          }

          setTimeout(function () {
            // 顺序，方便显示渲染
            _this81.messages = messages.list.concat(_this81.messages);
            _this81.hasMore = messages.hasMore;
            _this81.beforePullDown = true;
            _this81.isPullingDown = false; // 处理滚动条无法计算匹配高度导致向下滚动不能到底部

            setTimeout(function () {
              _this81.bscroll.refresh();
            }, 100);

            _this81.bscroll.finishPullDown();

            _this81.isGetHistory = true;
          }, 600);
        });
      } // }, 1000);

    }
    /**
     * 切换conversation
     * @param option 会话
     */

  }, {
    key: "handleSwitchConversation",
    value: function handleSwitchConversation(option) {
      var tranceId = core.logger.createTraceId();
      core.logger.info(LogTagId.A_KIT_HANDLE_SWITCH_CONVERSATION_O, JSON.stringify({
        option: option
      }, tranceId));

      if (!option) {
        this.conversation = null;
        this.bscroll = null;
        return;
      }

      this.hasMore = true;

      if (!this.bscroll) {
        this.mountScroller();
      }

      this.isPullingDown = false;
      this.beforePullDown = true; // 切换会话清除掉上一回话历史消息【防止服务器异常时没有办法正常加载历史消息展示错乱】

      if (this.messages) {
        this.messages = [];
      }

      this.updateMessageList(option);
    }
    /**
     * 加载数据
     * @param data
     */

  }, {
    key: "loadData",
    value: function loadData(data) {
      var _this82 = this;

      this.conversation = data.conversation;
      this.conversationProfile = data.profile;
      core.logger.info(LogTagId.A_KIT_LOAD_DATA_O, JSON.stringify({
        conversationType: data.conversation.conversationType,
        targetId: data.conversation.targetId,
        channelId: data.conversation.channelId
      }));

      if (this.conversation.conversationType === ConversationType$1.GROUP) {
        core.getGroupMembers(this.conversation).then(function (res) {
          _this82.groupMembers = _toConsumableArray(res);

          _this82.getMessages();
        });
      } else {
        this.groupMembers = null;
        this.getMessages();
      }
    }
    /**
     * 获取消息
     * @returns
     */

  }, {
    key: "getMessages",
    value: function getMessages() {
      var _this83 = this;

      this.isLoading = true;
      return core.getMessages({
        conversationType: this.conversation.conversationType,
        targetId: this.conversation.targetId,
        channelId: this.conversation.channelId
      }).then(function (messages) {
        _this83.isLoading = false;
        _this83.messages = messages.list;
        _this83.hasMore = messages.hasMore;

        if (!_this83.bscroll) {
          setTimeout(function () {
            // 创建过程中包含滚动到最后一条位置，因此不需要再往下执行
            _this83.mountScroller();
          }, 100);
        }

        setTimeout(function () {
          _this83.bscroll.refresh();

          _this83.bscroll.scrollTo(0, _this83.bscroll.maxScrollY);
        }, 600); // 存在未读消息

        if (_this83.conversation.unreadMessageCount) {
          var lastMessages = _this83.messages[_this83.messages.length - 1];

          if (lastMessages) {
            _this83.sendReadReceipt(lastMessages);
          }
        }
      });
    }
    /**
     * 处理新消息
     */

  }, {
    key: "handleMessages",
    value: function handleMessages(newMessages) {
      var _this84 = this;

      if (!newMessages.length || !this.conversation) {
        return;
      }

      if (!isEqual(newMessages[0], this.conversation)) {
        return;
      }

      var refreshData = function refreshData() {
        var messages = [].concat(_toConsumableArray(_this84.messages), _toConsumableArray(newMessages));
        _this84.messages = messages;

        if (!_this84.bscroll) {
          _this84.mountScroller();
        } // 在一定范围内，则不滚动到底部


        if (_this84.bscroll.y < _this84.bscroll.maxScrollY + 30) {
          // TODO 待优化，为临时修复切换标签当前页面收到消息刷新异常问题调整时间戳从 100 调整到 1000。
          setTimeout(function () {
            _this84.bscroll.refresh();

            _this84.bscroll.scrollTo(0, _this84.bscroll.maxScrollY);
          }, 100);
        } else {
          setTimeout(function () {
            _this84.bscroll.refresh();
          }, 100);
        }

        var unreadMessage = messages[messages.length - 1];

        if (unreadMessage && unreadMessage.senderUserId !== getCurrentUserId()) {
          // 发送已读回执
          _this84.sendReadReceipt(unreadMessage);
        }
      }; // 如果是群组，则先要获取群组用户


      if (this.conversation.conversationType === ConversationType$1.GROUP) {
        core.getGroupMembers({
          conversationType: this.conversation.conversationType,
          targetId: this.conversation.targetId,
          channelId: this.conversation.channelId
        }).then(function (res) {
          _this84.groupMembers = res;
          refreshData();
        });
      } else {
        this.groupMembers = null;
        refreshData();
      }
    }
    /**
     * 发送已读回执
     */

  }, {
    key: "sendReadReceipt",
    value: function sendReadReceipt(unreadMessages) {
      core.clearMessagesUnreadStatus(this.conversation);

      if (!unreadMessages) {
        return;
      }

      if (unreadMessages.conversationType === ConversationType$1.PRIVATE) {
        // 发送已读回执
        sendReadReceiptMessage(this.conversation.targetId, unreadMessages.messageUId, unreadMessages.sentTime, // core.getTime(),
        this.conversation.channelId);
      }
    }
    /**
     * 处理群回执请求
     */

  }, {
    key: "handleReceiptRequest",
    value: function handleReceiptRequest(event) {
      // 直接发送响应
      sendReadReceiptResponseV2(event.conversation.targetId, _defineProperty({}, event.senderUserId, [event.messageUId]), event.conversation.channelId);
    }
  }, {
    key: "handleSelectMessage",
    value: function handleSelectMessage(event) {
      var _event$detail = event.detail,
          message = _event$detail.message,
          position = _event$detail.position;

      if (message.messageUId.startsWith('sending_') || message.messageUId.startsWith('fail_')) {
        return;
      }

      this.selectedMessage = message;
      this.contextMenuPosition = position;
    }
  }, {
    key: "handleUpdateMessage",
    value: function handleUpdateMessage(message) {
      var _this85 = this;

      var index = this.messages.findIndex(function (m) {
        return message.messageUId === m.messageUId;
      });

      if (index === -1) {
        return;
      }

      this.messages[index] = message;
      this.messages = _toConsumableArray(this.messages);

      if (!this.bscroll) {
        this.mountScroller();
        return;
      }

      setTimeout(function () {
        _this85.bscroll.refresh();
      }, 100);
    } // 删除消息

  }, {
    key: "handleDeleteMessage",
    value: function handleDeleteMessage(messages) {
      var _this86 = this;

      messages.forEach(function (message) {
        var index = _this86.messages.findIndex(function (m) {
          return message.messageUId === m.messageUId;
        });

        if (index === -1) {
          return;
        }

        _this86.messages.splice(index, 1);
      });
      this.messages = _toConsumableArray(this.messages);

      if (!this.bscroll) {
        this.mountScroller();
        return;
      }

      setTimeout(function () {
        _this86.bscroll.refresh();
      }, 100);
    }
  }, {
    key: "tapMessageHandler",
    value: function tapMessageHandler(data) {
      this.tapMessage.emit(data.detail);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      if (this.bscroll) {
        this.bscroll.stop(); // 鼠标按住左键移出滚动区域，放开左键后，回到滚动区域依然带动滚动动作。

        this.bscroll.scroller.actionsHandler.setInitiated();
      }
    }
  }, {
    key: "handleTypingStatus",
    value: function handleTypingStatus(event) {
      var _this87 = this;

      var status = event.status || [];
      var hasCurrentConversation = status.findIndex(function (one) {
        return _this87.conversation && isEqual(one, _this87.conversation);
      });

      if (hasCurrentConversation === -1) {
        return;
      }

      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.typingTimer = null;
      }

      this.showTypingStatus = true;
      this.typingTimer = setTimeout(function () {
        _this87.showTypingStatus = false;
      }, 5000);
    }
  }, {
    key: "handleLanguageChanged",
    value: function handleLanguageChanged(event) {
      this.lang = event.lang;
    }
  }, {
    key: "handleUserInfoChanged",
    value: function handleUserInfoChanged(info) {
      this.myProfile = info; // 没有当前用户不进行刷新

      if (this.conversation) {
        this.refreshScroller();
      }
    }
  }, {
    key: "handleConversationInfoChanged",
    value: function handleConversationInfoChanged(info) {
      if (this.conversation && info.conversationType && info.targetId && isEqual(this.conversation, {
        conversationType: info.conversationType,
        targetId: info.targetId
      })) {
        this.conversationProfile = info;
        this.refreshScroller();
      }
    }
  }, {
    key: "handleGroupInfoChanged",
    value: function handleGroupInfoChanged(info) {
      if (this.conversation) {
        this.groupMembers = info;
        this.refreshScroller();
      }
    }
  }, {
    key: "refreshScroller",
    value: function refreshScroller() {
      var _this88 = this;

      if (!this.bscroll) {
        this.mountScroller();
      }

      if (this.bscroll.y < this.bscroll.maxScrollY + 30) {
        setTimeout(function () {
          _this88.bscroll.refresh();

          _this88.bscroll.scrollTo(0, _this88.bscroll.maxScrollY);
        }, 100);
      } else {
        setTimeout(function () {
          _this88.bscroll.refresh();
        }, 100);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this89 = this;

      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var conversationProfile = this.conversationProfile,
          conversation = this.conversation,
          messages = this.messages,
          groupMembers = this.groupMembers,
          myProfile = this.myProfile,
          locale = this.locale;
      return conversation ? h("div", {
        "class": "message-container",
        style: {
          fontSize: this.baseSize
        }
      }, h("div", {
        "class": "conversation-info"
      }, h("div", {
        "class": "receiver"
      }, h("span", {
        "class": "name"
      }, conversationProfile ? conversationProfile.name : conversation.targetId), conversation.conversationType === ConversationType$1.GROUP ? h("span", {
        "class": "count"
      }, "\uFF08", conversationProfile === null || conversationProfile === void 0 ? void 0 : conversationProfile.memberCount, "\uFF09") : null)), h("div", {
        "class": "message-list-container",
        onMouseLeave: this.handleMouseLeave
      }, h("div", {
        "class": "input-tip"
      }), h("message-context-menu", {
        message: this.selectedMessage,
        position: this.contextMenuPosition,
        customMenu: this.customMenu,
        forwardList: this.forwardList,
        disableMenu: this.disableMenu,
        maxRecallDuration: this.maxRecallDuration
      }), h("div", {
        "class": "message-loading"
      }, h("div", {
        style: {
          display: this.isLoading ? 'block' : 'none'
        }
      }, h("span", null, locale.message.loading))), h("div", {
        "class": "message-list-wrapper",
        ref: function ref(el) {
          _this89.scrollWrapper = el;
          return _this89.scrollWrapper;
        }
      }, h("div", {
        "class": "message-list-scroller"
      }, h("div", {
        "class": "pulldown-wrapper"
      }, h("div", {
        style: {
          display: this.beforePullDown ? 'block' : 'none'
        }
      }, this.hasMore ? h("span", null, locale.message.loading) : h("span", null, locale.message.noHistory))), h("div", {
        "class": "message-list"
      }, h("message-group", {
        messages: messages,
        groupMembers: groupMembers,
        conversationProfile: conversationProfile,
        myProfile: myProfile,
        onRightClick: this.handleSelectMessage,
        onTapMessageItem: this.tapMessageHandler
      })))), h("div", {
        "class": "typing-status",
        style: {
          display: this.showTypingStatus ? 'flex' : 'none'
        }
      }, h("span", null), h("span", null), h("span", null)))) : h("div", {
        "class": "no-data",
        style: {
          fontSize: this.baseSize
        }
      }, h("span", null, locale.message.noData));
    }
  }], [{
    key: "style",
    get: function get() {
      return messageListCss;
    }
  }]);

  return MessageList$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var progressBarCss = ".upload-progress-mask{width:100%;height:100%;position:absolute;top:0;left:0;background:rgba(0, 0, 0, 0.4);font-size:72px;min-width:2.2222em;min-height:1em;overflow:hidden}.upload-progress-bar{position:absolute;width:1em;height:1em;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.upload-progress-bar svg{fill:#ffffff}";

function creatTagEle(tag, tagAttr) {
  var svgNS = 'http://www.w3.org/2000/svg';
  var oTag = document.createElementNS(svgNS, tag);
  Object.keys(tagAttr).forEach(function (attr) {
    if (Object.prototype.hasOwnProperty.call(tagAttr, attr)) {
      oTag.setAttribute(attr, tagAttr[attr]);
    }
  });
  return oTag;
}

var ProgressBar$1 = /*#__PURE__*/function (_HTMLElement11) {
  _inherits(ProgressBar$1, _HTMLElement11);

  var _super25 = _createSuper(ProgressBar$1);

  function ProgressBar$1() {
    var _this90;

    _classCallCheck(this, ProgressBar$1);

    _this90 = _super25.call(this);

    _this90.__registerHost();

    _this90.reverse = false;
    _this90.handleUploadProgress = _this90.handleUploadProgress.bind(_assertThisInitialized(_this90));
    return _this90;
  }

  _createClass(ProgressBar$1, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.on(CoreEvent.UPLOAD_PROGRESS, this.handleUploadProgress);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.UPLOAD_PROGRESS, this.handleUploadProgress);
    }
  }, {
    key: "drawPath",
    value: function drawPath(d) {
      var deg = d;
      deg = deg || 0; // 半径

      var outR = 146; // 中心点（ centerX,centerY ）

      var centerX = 150;
      var centerY = 150;
      var x = centerX + Math.sin(Math.PI / 180 * deg) * outR;
      var y = centerY - Math.cos(Math.PI / 180 * deg) * outR; // 生成path标签

      var path;

      if (this.reverse) {
        // 反向画弧
        if (deg <= 180) {
          path = "M".concat(centerX, " ").concat(centerY - outR, "A").concat(outR, " ").concat(outR, " 0 0 0 ").concat(centerX, " ").concat(centerY + outR, "A").concat(outR, " ").concat(outR, " 0 0 0 ").concat(x, " ").concat(y, "L").concat(centerX, " ").concat(centerY, " L").concat(centerX, " ").concat(centerY - outR, "Z");
        } else {
          path = "M".concat(centerX, " ").concat(centerY - outR, "A").concat(outR, " ").concat(outR, " 0 0 0 ").concat(x, " ").concat(y, "L").concat(centerX, " ").concat(centerY, " L").concat(centerX, " ").concat(centerY - outR, "Z");
        }
      } else if (deg <= 180) {
        // 正向画弧
        path = "M".concat(centerX, " ").concat(centerY - outR, "A").concat(outR, " ").concat(outR, " 0 0 1 ").concat(x, " ").concat(y, "L").concat(centerX, " ").concat(centerY, " L").concat(centerX, " ").concat(centerY - outR, "Z");
      } else {
        path = "M".concat(centerX, " ").concat(centerY - outR, "A").concat(outR, " ").concat(outR, " 0 0 1 ").concat(centerX, " ").concat(centerY + outR, "A").concat(outR, " ").concat(outR, " 0 0 1 ").concat(x, " ").concat(y, "L").concat(centerX, " ").concat(centerY, " L").concat(centerX, " ").concat(centerY - outR, "Z");
      }

      var oPath = creatTagEle('path', {
        fill: 'rgba(255, 255, 255, 1)',
        // 填充一个扇形区的外弧与内弧
        d: path
      });

      while (this.svg.childNodes.length > 1) {
        this.svg.removeChild(this.svg.childNodes[1]);
      } // 将创建的oPath标签添加到画布上


      this.svg.appendChild(oPath);
    }
  }, {
    key: "handleUploadProgress",
    value: function handleUploadProgress(data) {
      if (this.mId !== data.messageId) {
        return;
      }

      this.drawPath(data.progress * 3.6);
    }
  }, {
    key: "render",
    value: function render() {
      var _this91 = this;

      return h("div", {
        "class": "upload-progress-mask"
      }, h("div", {
        "class": "upload-progress-bar"
      }, h("svg", {
        ref: function ref(el) {
          _this91.svg = el;
          return _this91.svg;
        },
        id: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 300 300"
      }, h("circle", {
        xmlns: "http://www.w3.org/2000/svg",
        cx: "150",
        cy: "150",
        r: "148",
        stroke: "#ffffff",
        "stroke-width": "2",
        fill: "none"
      }))));
    }
  }], [{
    key: "style",
    get: function get() {
      return progressBarCss;
    }
  }]);

  return ProgressBar$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var referenceMessageCss = ".message-reference{position:absolute;-webkit-transform:translateY(calc(-100% - 1px));transform:translateY(calc(-100% - 1px));min-height:4.5em;padding:.83333em .291667em .83333em .83333em;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:2.4em;background:#fff}.message-reference .close-btn{position:absolute;right:.83333em;top:.83333em;width:1.33333em;height:0;padding-top:1.33333em;overflow:hidden;background:url(data:image/svg+xml;base64,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) no-repeat;background-size:contain;border:none;cursor:pointer}.message-reference .message-body{border-left:0.08333em solid #E3E5E6;padding:0 0 0 0.83333em;height:100%}.message-reference .content{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.message-reference .content .reference-image{width:100%;height:2.92em}.message-reference .content .reference-image img{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}";

var ReferenceMessage$1 = /*#__PURE__*/function (_HTMLElement12) {
  _inherits(ReferenceMessage$1, _HTMLElement12);

  var _super26 = _createSuper(ReferenceMessage$1);

  function ReferenceMessage$1() {
    var _this92;

    _classCallCheck(this, ReferenceMessage$1);

    _this92 = _super26.call(this);

    _this92.__registerHost();

    _this92.close = createEvent(_assertThisInitialized(_this92), "close", 7);
    _this92.lang = core.lang; // 语言标识

    _this92.closeReference = _this92.closeReference.bind(_assertThisInitialized(_this92));
    _this92.handleInfoChanged = _this92.handleInfoChanged.bind(_assertThisInitialized(_this92));
    return _this92;
  }

  _createClass(ReferenceMessage$1, [{
    key: "validateData",
    value: function validateData() {
      if (this.referenceMessage) {
        this.handleReferenceMessage(this.referenceMessage.message);
      } else {
        this.closeReference();
      }
    }
  }, {
    key: "componentWillLoad",
    value: function componentWillLoad() {
      core.on(CoreEvent.GROUP_INFO_CHANGED, this.handleInfoChanged);
      core.on(CoreEvent.USER_INFO_CHANGED, this.handleInfoChanged);
      core.on(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleInfoChanged);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      core.off(CoreEvent.GROUP_INFO_CHANGED, this.handleInfoChanged);
      core.off(CoreEvent.USER_INFO_CHANGED, this.handleInfoChanged);
      core.off(CoreEvent.CONVERSATION_INFO_CHANGED, this.handleInfoChanged);
    }
  }, {
    key: "handleInfoChanged",
    value: function handleInfoChanged() {
      if (this.referenceMessage) {
        this.handleReferenceMessage(this.referenceMessage.message);
      }
    }
  }, {
    key: "closeReference",
    value: function closeReference() {
      this.name = '';
      this.content = '';
      this.close.emit();
    }
  }, {
    key: "getProfile",
    value: function getProfile(message) {
      var conversationOption = {
        conversationType: message.conversationType,
        targetId: message.targetId,
        channelId: message.channelId
      };
      var promise;

      if (message.conversationType === ConversationType$1.GROUP) {
        promise = core.getGroupMemberProfile(conversationOption, message.senderUserId).then(function (res) {
          if (res) {
            return res.groupNickname || res.name;
          }

          return message.senderUserId;
        });
      } else if (message.senderUserId === getCurrentUserId()) {
        promise = core.getMyProfile().then(function (profile) {
          return profile.displayName || profile.name || message.senderUserId;
        });
      } else {
        promise = core.getConversationProfile(conversationOption).then(function (res) {
          if (res) {
            return res.displayName || res.name;
          }

          return message.senderUserId;
        });
      }

      return promise;
    }
  }, {
    key: "handleReferenceMessage",
    value: function handleReferenceMessage(message) {
      var _this93 = this;

      var promise = this.getProfile(message);

      if (promise) {
        promise.then(function (name) {
          _this93.name = name;

          switch (message.messageType) {
            case MessageType$1.TEXT:
              _this93.content = message.content.content;
              break;

            case MessageType$1.IMAGE:
              _this93.content = h("div", {
                "class": "reference-image"
              }, h("img", {
                src: addBase64head(message.content.content)
              }));
              break;

            case MessageType$1.FILE:
              _this93.content = "[".concat(_this93.locale.conversation.file, "]").concat(message.content.name);
              break;

            case MessageType$1.GIF:
              _this93.content = h("img", {
                src: message.content.remoteUrl
              });
              break;

            case MessageType$1.HQ_VOICE:
              _this93.content = "[".concat(_this93.locale.conversation.file, "]");
              break;

            case MessageType$1.SIGHT:
              _this93.content = h("img", {
                src: message.content.content
              });
              break;

            case MessageType$1.RICH_CONTENT:
              _this93.content = message.content.title;
              break;

            case MessageType$1.REFERENCE:
              _this93.content = message.content.content || '';
              break;

            default:
              _this93.content = "[".concat(_this93.locale.other.unKnowMessage, "]");
              break;
          }
        });
      }
    }
  }, {
    key: "componentShouldUpdate",
    value: function componentShouldUpdate() {
      if (!this.name && !this.content) {
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      this.locale = this.lang ? language[this.lang] : language.zh_CN;
      var name = this.name,
          content = this.content;
      return name && content ? h("div", {
        "class": "message-reference"
      }, h("div", {
        "class": "message-body"
      }, h("div", {
        "class": "name"
      }, this.name, "\uFF1A"), h("div", {
        "class": "content"
      }, this.content)), h("button", {
        "class": "close-btn",
        onClick: this.closeReference
      }, "\u5173\u95ED")) : null;
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "referenceMessage": ["validateData"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return referenceMessageCss;
    }
  }]);

  return ReferenceMessage$1;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var ContentEditor = /*@__PURE__*/proxyCustomElement(ContentEditor$1, [1, "content-editor", {
  "conversation": [16],
  "value": [16],
  "memberListVisible": [32],
  "targetRect": [32],
  "hasContent": [32],
  "locale": [32],
  "lang": [32]
}]);
var ConversationContextMenu = /*@__PURE__*/proxyCustomElement(ConversationContextMenu$1, [0, "conversation-context-menu", {
  "position": [16],
  "visible": [4],
  "topStatus": [4, "top-status"],
  "notificationStatus": [4, "notification-status"],
  "customMenu": [16],
  "disableMenu": [16],
  "conversation": [16],
  "locale": [32],
  "lang": [32]
}]);
var ConversationItem = /*@__PURE__*/proxyCustomElement(ConversationItem$1, [0, "conversation-item", {
  "data": [16],
  "isHover": [4, "is-hover"],
  "hideNotificUnreadCount": [4, "hide-notific-unread-count"],
  "draft": [32],
  "locale": [32],
  "lang": [32]
}]);
var ConversationList = /*@__PURE__*/proxyCustomElement(ConversationList$1, [1, "conversation-list", {
  "baseSize": [1, "base-size"],
  "userBackground": [1, "user-background"],
  "customMenu": [16],
  "disableMenu": [16],
  "hideNotificUnreadCount": [4, "hide-notific-unread-count"],
  "currentConversation": [32],
  "isPullUpLoad": [32],
  "data": [32],
  "locale": [32],
  "lang": [32],
  "contextMenuData": [32]
}]);
var MemberList = /*@__PURE__*/proxyCustomElement(MessageEditor$2, [0, "member-list", {
  "conversation": [16],
  "visible": [4],
  "targetRect": [16],
  "memberList": [32],
  "position": [32],
  "locale": [32],
  "lang": [32]
}]);
var MessageContextMenu = /*@__PURE__*/proxyCustomElement(MessageList$4, [0, "message-context-menu", {
  "position": [16],
  "message": [16],
  "customMenu": [16],
  "disableMenu": [16],
  "forwardList": [16],
  "maxRecallDuration": [2, "max-recall-duration"],
  "visible": [32],
  "locale": [32],
  "lang": [32],
  "isShowForward": [32],
  "msgType": [32]
}]);
var MessageEditor = /*@__PURE__*/proxyCustomElement(MessageEditor$1, [0, "message-editor", {
  "baseSize": [1, "base-size"],
  "conversation": [32],
  "hasContent": [32],
  "referenceMessage": [32],
  "showMemberList": [32],
  "draft": [32],
  "isError": [32],
  "locale": [32],
  "lang": [32]
}]);
var MessageGroup = /*@__PURE__*/proxyCustomElement(MessageList$3, [0, "message-group", {
  "messages": [16],
  "groupMembers": [16],
  "conversationProfile": [16],
  "myProfile": [16],
  "locale": [32],
  "lang": [32]
}]);
var MessageItem = /*@__PURE__*/proxyCustomElement(MessageList$2, [0, "message-item", {
  "message": [16],
  "member": [16],
  "isGroupMember": [4, "is-group-member"],
  "conversationProfile": [16],
  "myProfile": [16],
  "locale": [32],
  "lang": [32]
}]);
var MessageList = /*@__PURE__*/proxyCustomElement(MessageList$1, [1, "message-list", {
  "baseSize": [1, "base-size"],
  "customMenu": [16],
  "disableMenu": [16],
  "forwardList": [16],
  "maxRecallDuration": [2, "max-recall-duration"],
  "conversation": [32],
  "conversationProfile": [32],
  "messages": [32],
  "hasMore": [32],
  "beforePullDown": [32],
  "isPullingDown": [32],
  "isLoading": [32],
  "locale": [32],
  "lang": [32],
  "groupMembers": [32],
  "selectedMessage": [32],
  "contextMenuPosition": [32],
  "showTypingStatus": [32],
  "myProfile": [32]
}]);
var ProgressBar = /*@__PURE__*/proxyCustomElement(ProgressBar$1, [0, "progress-bar", {
  "mId": [2, "m-id"],
  "reverse": [4]
}]);
var ReferenceMessage = /*@__PURE__*/proxyCustomElement(ReferenceMessage$1, [0, "reference-message", {
  "referenceMessage": [16],
  "content": [32],
  "name": [32],
  "locale": [32],
  "lang": [32]
}]);

var defineCustomElements = function defineCustomElements(opts) {
  if (typeof customElements !== 'undefined') {
    [ContentEditor, ConversationContextMenu, ConversationItem, ConversationList, MemberList, MessageContextMenu, MessageEditor, MessageGroup, MessageItem, MessageList, ProgressBar, ReferenceMessage].forEach(function (cmp) {
      if (!customElements.get(cmp.is)) {
        customElements.define(cmp.is, cmp, opts);
      }
    });
  }
};

export { ContentEditor, ConversationContextMenu, ConversationItem, ConversationList, CoreEvent, DisabledConversationontextMenu, DisabledMessageContextMenu, Languages, MemberList, MessageContextMenu, MessageEditor, MessageGroup, MessageItem, MessageList, ProgressBar, ReferenceMessage, core, defineCustomElements, core as imkit };
